{
  "schemaVersion": 4,
  "generatedAt": "2026-08-03T04:59:05.920Z",
  "latestPeriod": "2026-06",
  "coverage": {
    "firstPeriod": "1992-01",
    "lastPeriod": "2026-06",
    "gaps": []
  },
  "sources": [
    {
      "id": "inegi-lp",
      "name": "Líneas de Pobreza (LP) — Banco de Indicadores",
      "institution": "INEGI",
      "url": "https://www.inegi.org.mx/desarrollosocial/lp/",
      "methodologyUrl": "https://www.coneval.org.mx/InformesPublicaciones/InformesPublicaciones/Documents/Lineas_pobreza.pdf",
      "cadence": "mensual",
      "retrievedAt": "2026-08-03T04:59:05.920Z",
      "license": "Datos abiertos del Gobierno de México (Libre uso de la información del INEGI)",
      "verified": true,
      "caveats": [
        "CONEVAL publicó esta serie de enero de 1992 a marzo de 2025. Desde julio de 2025 la genera el INEGI con la misma metodología, tras las reformas a la Ley General de Desarrollo Social vigentes desde el 17 de julio de 2025.",
        "La canasta está anclada a la ENIGH 2016 y se actualiza cada mes con el Índice Nacional de Precios al Consumidor: cambia el precio, no el contenido."
      ]
    },
    {
      "id": "coneval-lp-historico",
      "name": "Evolución de las Líneas de Pobreza por Ingresos, 1992 – marzo de 2025",
      "institution": "CONEVAL",
      "url": "https://www.coneval.org.mx/Medicion/Documents/Lineas_de_Pobreza_por_Ingresos/Lineas_de_Pobreza_por_Ingresos.zip",
      "cadence": "irregular",
      "retrievedAt": "2026-08-03T04:59:05.920Z",
      "verified": true,
      "caveats": [
        "Se usa como contraste independiente de la serie del INEGI, no como fuente de la app. Ya no se actualiza."
      ]
    },
    {
      "id": "inegi-lp-boletin",
      "name": "Boletín mensual de Líneas de Pobreza — cuadros de contenido y valor monetario",
      "institution": "INEGI",
      "url": "https://www.inegi.org.mx/contenidos/saladeprensa/boletines/2026/lp/lp2026_07.pdf",
      "cadence": "mensual",
      "retrievedAt": "2026-08-03T04:59:05.920Z",
      "license": "Libre uso de la información del INEGI",
      "verified": true,
      "caveats": [
        "Cada boletín publica el precio por kilogramo o litro de cada renglón de la canasta. La serie por producto arranca en 2025-07 porque es el primer boletín que el INEGI publicó bajo su nueva atribución.",
        "Dos renglones —«Alimentos y bebidas consumidas fuera del hogar» y «Otros alimentos preparados»— tienen precio por ración, no por peso, y no son comparables con los demás."
      ]
    },
    {
      "id": "conasami-salario-minimo",
      "name": "Salarios mínimos generales por área geográfica",
      "institution": "CONASAMI",
      "url": "https://www.gob.mx/conasami/articulos/incremento-a-los-salarios-minimos-para-2026",
      "methodologyUrl": "http://www.conasami.gob.mx/pdf/salario_minimo/octubre2015/salarios_area_geo_octubre2015.xlsx",
      "cadence": "anual",
      "retrievedAt": "2026-08-03T04:59:05.920Z",
      "verified": true,
      "caveats": [
        "De enero de 1992 a septiembre de 2015 no existe «el» salario mínimo: había tres áreas geográficas con montos distintos. Se usa el promedio nacional que publica la propia CONASAMI, ponderado con la población asalariada. Desde octubre de 2015 las áreas se unificaron y el monto ya es único.",
        "Los montos de 1992 están convertidos a nuevos pesos: el decreto del DOF del 22 de junio de 1992 quitó tres ceros a partir del 1 de enero de 1993, y la serie de la canasta ya viene en la unidad nueva.",
        "Desde 2016 el salario cambia una vez al año, el 1 de enero, pero antes hubo dos o tres fijaciones en 1995, 1996, 1998, 2012 y 2015. A cada mes se le asigna el monto que estuvo vigente la mayor parte de sus días.",
        "Se usa la zona de salarios mínimos generales (resto del país), no la Zona Libre de la Frontera Norte.",
        "Mensualización oficial: 30.4167 días (365/12), el mismo factor que usa CONASAMI."
      ]
    },
    {
      "id": "inegi-inpc-territorio",
      "name": "Índice Nacional de Precios al Consumidor, por entidad federativa y por ciudad",
      "institution": "INEGI",
      "url": "https://www.inegi.org.mx/programas/inpc/2018/",
      "methodologyUrl": "https://www.inegi.org.mx/app/indicesdeprecios/Estructura.aspx?idEstructura=112001700070",
      "cadence": "mensual",
      "retrievedAt": "2026-08-03T04:59:05.920Z",
      "license": "Datos abiertos del Gobierno de México (Libre uso de la información del INEGI)",
      "verified": true,
      "caveats": [
        "Un índice mide cuánto cambiaron los precios, no cuánto cuestan. No puede convertirse a pesos por ciudad ni usarse para decir dónde es más caro comer.",
        "Se toma el objeto del gasto «1. Alimentos, bebidas y tabaco», que sí incluye bebidas alcohólicas y tabaco. El INEGI publica además una clasificación CCIF que los excluye; no son comparables entre sí y aquí no se mezclan.",
        "Las series por entidad empiezan en julio de 2018; las de ciudad y la nacional vienen empalmadas desde 1982 y 1970. Toda comparación entre lugares se hace desde julio de 2018, que es la base común."
      ]
    },
    {
      "id": "inegi-denue-mayoristas",
      "name": "Directorio Estadístico Nacional de Unidades Económicas (DENUE), sector 43",
      "institution": "INEGI",
      "url": "https://www.inegi.org.mx/app/mapa/denue/",
      "methodologyUrl": "https://www.inegi.org.mx/contenidos/masiva/denue/denue_00_43_csv.zip",
      "cadence": "semestral",
      "retrievedAt": "2026-08-03T04:59:05.920Z",
      "license": "Términos de Libre Uso de la Información del INEGI",
      "verified": true,
      "caveats": [
        "El DENUE registra establecimientos, no capacidad de venta: no publica facturación ni volumen. El corte en 11 personas ocupadas separa la bodega familiar del proveedor que plausiblemente surte volumen, pero no garantiza que pueda.",
        "El sitio publica el directorio completo —nombre, razón social, domicilio, tamaño y coordenadas de los 23654 establecimientos— pero NO los datos de contacto. El DENUE trae correo o teléfono de 15449 de ellos (11033 con correo), y la mayoría de esos correos son de una persona, no de un buzón de empresa: la lista con contactos se genera aparte y no se publica en el sitio.",
        "Las plazas de abasto se agregan por municipio porque el DENUE registra la misma central con nombres distintos. Los nombres se conservan tal como vienen."
      ]
    },
    {
      "id": "profeco-qqp",
      "name": "Quién es Quién en los Precios (QQP), datos abiertos",
      "institution": "Profeco",
      "url": "https://datos.profeco.gob.mx/datos_abiertos/qqp.php",
      "methodologyUrl": "https://datos.profeco.gob.mx/diccionarioDatosQQP.php",
      "cadence": "quincenal",
      "retrievedAt": "2026-08-03T04:59:05.920Z",
      "license": "Creative Commons Atribución 4.0 Internacional (CC BY 4.0)",
      "verified": true,
      "caveats": [
        "Contra el boletín del INEGI la diferencia mediana por renglón es de 21.2 % y sólo 7 de 29 renglones caen dentro de ±10 %. Sirve para fijar un precio de compra y comparar canales, no como segunda estimación del costo de la canasta.",
        "El sesgo por producto es estable: a lo largo de cinco meses su rango mediano es de 7.9 puntos porcentuales, y de 1 a 5 pp en los procesados. Los niveles no son comparables con el INEGI; las variaciones sí son utilizables.",
        "«Central de Abasto» es precio de mayoreo, no de anaquel. El diferencial contra un autoservicio es un margen de intermediación, y sólo se publica cuando la misma presentación existe en los dos canales y representa el mismo bien.",
        "La central de abasto aparece en 11 de las 32 entidades y aporta el 1.1 % de las filas del archivo. Es la muestra más delgada del dataset y por eso su diferencial se publica con intervalo de confianza y con el número de entidades pareadas.",
        "QQP cubre 74 municipios, el 3 % de los de México; faltan Colima y Nayarit por completo y el Valle de México aporta el 36 % de los registros. No es un censo nacional de precios.",
        "Profeco no publica metodología de levantamiento, tamaño de muestra ni universo. Verificado en su portal de datos abiertos y en el diccionario de datos el 31 de julio de 2026.",
        "En mayo de 2026 el exportador de Profeco cambió de codificación y sustituyó cada acento por «?». El pipeline lo detecta y lo repara; sin esa reparación el 11.7 % de los productos aparecen como dos series distintas.",
        "Profeco regenera el año completo por lotes en fechas irregulares. El sitio publica la fecha de la última observación y su antigüedad en días, no la fecha de descarga.",
        "La última observación de Profeco es del 2026-05-29 y tiene 66 días de antigüedad. Profeco regenera el año completo por lotes en fechas irregulares; el sitio publica la fecha de la última observación y su antigüedad, no la fecha de descarga."
      ]
    }
  ],
  "baskets": [
    {
      "id": "canasta-alimentaria",
      "name": "Canasta alimentaria",
      "institution": "INEGI (antes CONEVAL)",
      "description": "Valor monetario del conjunto de alimentos que cubre los requerimientos de energía de una persona durante un mes. Es la Línea de Pobreza Extrema por Ingresos: quien gana menos que esto no puede comprar la comida que necesita ni gastando todo su ingreso en ella.",
      "productCount": 42,
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp",
      "primary": true,
      "caveats": [
        "El contenido difiere por ámbito: 39 renglones en el rural y 42 en el urbano.",
        "Es un umbral de suficiencia de ingreso, no el gasto observado de los hogares."
      ]
    },
    {
      "id": "canasta-ampliada",
      "name": "Canasta alimentaria más no alimentaria",
      "institution": "INEGI (antes CONEVAL)",
      "description": "Suma de la canasta alimentaria y la no alimentaria (transporte, vivienda, salud, educación, vestido, higiene). Es la Línea de Pobreza por Ingresos.",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp",
      "primary": false,
      "caveats": [
        "Incluye bienes y servicios que no son alimentos; no es comparable con la canasta alimentaria."
      ]
    }
  ],
  "series": [
    {
      "id": "canasta-alimentaria-rural",
      "label": "Canasta alimentaria, ámbito rural",
      "shortLabel": "Rural",
      "unit": "MXN_persona_mes",
      "geography": "rural",
      "basketId": "canasta-alimentaria",
      "sourceId": "inegi-lp",
      "higherIsBetter": false,
      "points": [
        {
          "period": "1992-01",
          "value": 124.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-02",
          "value": 125.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-03",
          "value": 127.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-04",
          "value": 129.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-05",
          "value": 127.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-06",
          "value": 127.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-07",
          "value": 127.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-08",
          "value": 127.03,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-09",
          "value": 127.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-10",
          "value": 127.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-11",
          "value": 130.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-12",
          "value": 134.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-01",
          "value": 137.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-02",
          "value": 137.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-03",
          "value": 134.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-04",
          "value": 133.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-05",
          "value": 135.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-06",
          "value": 135.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-07",
          "value": 135.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-08",
          "value": 135.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-09",
          "value": 136.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-10",
          "value": 136.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-11",
          "value": 137.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-12",
          "value": 140.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-01",
          "value": 142.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-02",
          "value": 140.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-03",
          "value": 139.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-04",
          "value": 139.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-05",
          "value": 139.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-06",
          "value": 140.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-07",
          "value": 141.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-08",
          "value": 142.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-09",
          "value": 142.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-10",
          "value": 142.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-11",
          "value": 143.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-12",
          "value": 145.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-01",
          "value": 151.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-02",
          "value": 156.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-03",
          "value": 163.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-04",
          "value": 174.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-05",
          "value": 182.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-06",
          "value": 189.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-07",
          "value": 194.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-08",
          "value": 196.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-09",
          "value": 199.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-10",
          "value": 203.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-11",
          "value": 212.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-12",
          "value": 222.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-01",
          "value": 232.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-02",
          "value": 238.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-03",
          "value": 243.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-04",
          "value": 251.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-05",
          "value": 258.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-06",
          "value": 263.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-07",
          "value": 266.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-08",
          "value": 269.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-09",
          "value": 273.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-10",
          "value": 277.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-11",
          "value": 283.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-12",
          "value": 291.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-01",
          "value": 301.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-02",
          "value": 303.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-03",
          "value": 303.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-04",
          "value": 306.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-05",
          "value": 308.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-06",
          "value": 309.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-07",
          "value": 312.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-08",
          "value": 314.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-09",
          "value": 317.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-10",
          "value": 318.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-11",
          "value": 321.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-12",
          "value": 327.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-01",
          "value": 336.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-02",
          "value": 346.43,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-03",
          "value": 352.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-04",
          "value": 354.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-05",
          "value": 354.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-06",
          "value": 356.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-07",
          "value": 360.84,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-08",
          "value": 364.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-09",
          "value": 369.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-10",
          "value": 376.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-11",
          "value": 381.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-12",
          "value": 396.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-01",
          "value": 412.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-02",
          "value": 412.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-03",
          "value": 407.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-04",
          "value": 407.03,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-05",
          "value": 408.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-06",
          "value": 408.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-07",
          "value": 410.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-08",
          "value": 411.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-09",
          "value": 412.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-10",
          "value": 413.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-11",
          "value": 415.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-12",
          "value": 424.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-01",
          "value": 430.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-02",
          "value": 430,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-03",
          "value": 429.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-04",
          "value": 429.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-05",
          "value": 433.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-06",
          "value": 439.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-07",
          "value": 444.03,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-08",
          "value": 445.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-09",
          "value": 444.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-10",
          "value": 448.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-11",
          "value": 452.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-12",
          "value": 464.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-01",
          "value": 464.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-02",
          "value": 452.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-03",
          "value": 455.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-04",
          "value": 458.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-05",
          "value": 463.29,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-06",
          "value": 463.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-07",
          "value": 461.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-08",
          "value": 467.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-09",
          "value": 470.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-10",
          "value": 475.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-11",
          "value": 477.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-12",
          "value": 479.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-01",
          "value": 485.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-02",
          "value": 472.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-03",
          "value": 472.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-04",
          "value": 478.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-05",
          "value": 482.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-06",
          "value": 486.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-07",
          "value": 489.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-08",
          "value": 489.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-09",
          "value": 488.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-10",
          "value": 488.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-11",
          "value": 493.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-12",
          "value": 505.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-01",
          "value": 504.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-02",
          "value": 501.43,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-03",
          "value": 511.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-04",
          "value": 505.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-05",
          "value": 506.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-06",
          "value": 507.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-07",
          "value": 511.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-08",
          "value": 510.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-09",
          "value": 514.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-10",
          "value": 517.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-11",
          "value": 523.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-12",
          "value": 534.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-01",
          "value": 533.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-02",
          "value": 530.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-03",
          "value": 531.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-04",
          "value": 535.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-05",
          "value": 537.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-06",
          "value": 530.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-07",
          "value": 533.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-08",
          "value": 544.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-09",
          "value": 557.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-10",
          "value": 574.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-11",
          "value": 582.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-12",
          "value": 576.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-01",
          "value": 556.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-02",
          "value": 553.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-03",
          "value": 560.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-04",
          "value": 578.86,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-05",
          "value": 589.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-06",
          "value": 575.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-07",
          "value": 580.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-08",
          "value": 578.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-09",
          "value": 578.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-10",
          "value": 573.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-11",
          "value": 566.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-12",
          "value": 582.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-01",
          "value": 594.29,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-02",
          "value": 592.85,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-03",
          "value": 582.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-04",
          "value": 581.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-05",
          "value": 586.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-06",
          "value": 581.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-07",
          "value": 581.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-08",
          "value": 592.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-09",
          "value": 622.43,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-10",
          "value": 632.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-11",
          "value": 620.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-12",
          "value": 635.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-01",
          "value": 643.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-02",
          "value": 640.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-03",
          "value": 641.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-04",
          "value": 645.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-05",
          "value": 626.43,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-06",
          "value": 617.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-07",
          "value": 625.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-08",
          "value": 630.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-09",
          "value": 646.43,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-10",
          "value": 644.5,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-11",
          "value": 648.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-12",
          "value": 659.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-01",
          "value": 659.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-02",
          "value": 648.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-03",
          "value": 659.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-04",
          "value": 670.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-05",
          "value": 671.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-06",
          "value": 674.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-07",
          "value": 683.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-08",
          "value": 688.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-09",
          "value": 695.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-10",
          "value": 701.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-11",
          "value": 715.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-12",
          "value": 728.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-01",
          "value": 723.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-02",
          "value": 718.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-03",
          "value": 731.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-04",
          "value": 746.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-05",
          "value": 747.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-06",
          "value": 747.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-07",
          "value": 749.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-08",
          "value": 754.5,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-09",
          "value": 770.29,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-10",
          "value": 762.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-11",
          "value": 756.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-12",
          "value": 757.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-01",
          "value": 769.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-02",
          "value": 773.85,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-03",
          "value": 799,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-04",
          "value": 790.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-05",
          "value": 767.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-06",
          "value": 751.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-07",
          "value": 752.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-08",
          "value": 756.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-09",
          "value": 763.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-10",
          "value": 773.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-11",
          "value": 779.03,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-12",
          "value": 786.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-01",
          "value": 790.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-02",
          "value": 794.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-03",
          "value": 788.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-04",
          "value": 809.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-05",
          "value": 791.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-06",
          "value": 778.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-07",
          "value": 789.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-08",
          "value": 793.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-09",
          "value": 800.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-10",
          "value": 806.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-11",
          "value": 813.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-12",
          "value": 832.29,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-01",
          "value": 847.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-02",
          "value": 841.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-03",
          "value": 842.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-04",
          "value": 840.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-05",
          "value": 843.85,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-06",
          "value": 858.86,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-07",
          "value": 875.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-08",
          "value": 878.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-09",
          "value": 898.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-10",
          "value": 900.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-11",
          "value": 898.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-12",
          "value": 904.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-01",
          "value": 904.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-02",
          "value": 902.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-03",
          "value": 917.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-04",
          "value": 920.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-05",
          "value": 921.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-06",
          "value": 914.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-07",
          "value": 906.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-08",
          "value": 914.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-09",
          "value": 919.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-10",
          "value": 918.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-11",
          "value": 935.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-12",
          "value": 948.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-01",
          "value": 951.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-02",
          "value": 951.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-03",
          "value": 955.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-04",
          "value": 941.84,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-05",
          "value": 938.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-06",
          "value": 939.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-07",
          "value": 944.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-08",
          "value": 952.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-09",
          "value": 964.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-10",
          "value": 970.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-11",
          "value": 978.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-12",
          "value": 997.22,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-01",
          "value": 982.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-02",
          "value": 973.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-03",
          "value": 988.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-04",
          "value": 992.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-05",
          "value": 981.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-06",
          "value": 982.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-07",
          "value": 987.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-08",
          "value": 990.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-09",
          "value": 997.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-10",
          "value": 1000.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-11",
          "value": 1000.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-12",
          "value": 1017.03,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-01",
          "value": 1034.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-02",
          "value": 1043.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-03",
          "value": 1040.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-04",
          "value": 1036.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-05",
          "value": 1029.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-06",
          "value": 1018.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-07",
          "value": 1015.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-08",
          "value": 1018.43,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-09",
          "value": 1043.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-10",
          "value": 1046.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-11",
          "value": 1052.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-12",
          "value": 1063.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-01",
          "value": 1061.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-02",
          "value": 1055.86,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-03",
          "value": 1067.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-04",
          "value": 1080.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-05",
          "value": 1090.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-06",
          "value": 1099.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-07",
          "value": 1120.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-08",
          "value": 1141.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-09",
          "value": 1146.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-10",
          "value": 1130.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-11",
          "value": 1138.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-12",
          "value": 1153.5,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-01",
          "value": 1151.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-02",
          "value": 1135.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-03",
          "value": 1148.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-04",
          "value": 1147.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-05",
          "value": 1136.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-06",
          "value": 1135.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-07",
          "value": 1145.5,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 1164.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 1168.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 1165.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 1185.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 1208.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 1218,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 1201.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 1208.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 1216.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 1210.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 1201.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 1218.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 1209.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 1209.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 1211.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 1224.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 1240.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 1255.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 1264.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 1278.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 1279.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 1289.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 1279.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 1287.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 1299.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 1308.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 1319.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 1315.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 1306.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 1313.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 1313.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 1326.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 1344.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 1360.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 1370.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 1383.84,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 1399.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 1417.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 1418.86,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 1447.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 1463.43,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 1481.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 1496.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 1517.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 1522.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 1523.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 1544.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 1566.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 1600.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 1625.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 1624.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 1620.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 1630.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 1644.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 1652.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 1659.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 1666.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 1666.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 1663.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 1672.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 1699.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 1721.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 1701.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 1703.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 1743.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 1798.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 1756.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 1750.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 1761.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 1767.03,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 1759.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 1804.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 1800.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 1786.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 1791.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 1799.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 1799.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 1795.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 1787.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 1797.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 1814.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 1844.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 1850.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 1856.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 1850.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 1850.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 1844.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 1854.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 1854.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 1863.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 1887.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 1940.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 1966.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 1960.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 1907.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        }
      ]
    },
    {
      "id": "canasta-alimentaria-urbana",
      "label": "Canasta alimentaria, ámbito urbano",
      "shortLabel": "Urbana",
      "unit": "MXN_persona_mes",
      "geography": "urbano",
      "basketId": "canasta-alimentaria",
      "sourceId": "inegi-lp",
      "higherIsBetter": false,
      "points": [
        {
          "period": "1992-01",
          "value": 169.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-02",
          "value": 171.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-03",
          "value": 173.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-04",
          "value": 175.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-05",
          "value": 174.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-06",
          "value": 175.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-07",
          "value": 175.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-08",
          "value": 174.86,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-09",
          "value": 175.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-10",
          "value": 175.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-11",
          "value": 177.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-12",
          "value": 182.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-01",
          "value": 186.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-02",
          "value": 186.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-03",
          "value": 184.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-04",
          "value": 183.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-05",
          "value": 184.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-06",
          "value": 185.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-07",
          "value": 185.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-08",
          "value": 185.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-09",
          "value": 187.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-10",
          "value": 187.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-11",
          "value": 188.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-12",
          "value": 191.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-01",
          "value": 193.85,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-02",
          "value": 192.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-03",
          "value": 191.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-04",
          "value": 191.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-05",
          "value": 192.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-06",
          "value": 192.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-07",
          "value": 194.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-08",
          "value": 194.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-09",
          "value": 195.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-10",
          "value": 195.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-11",
          "value": 197.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-12",
          "value": 199.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-01",
          "value": 206.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-02",
          "value": 215.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-03",
          "value": 224.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-04",
          "value": 237.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-05",
          "value": 248,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-06",
          "value": 256.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-07",
          "value": 262.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-08",
          "value": 266.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-09",
          "value": 270.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-10",
          "value": 275.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-11",
          "value": 285.5,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-12",
          "value": 299.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-01",
          "value": 312.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-02",
          "value": 320.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-03",
          "value": 326.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-04",
          "value": 337.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-05",
          "value": 346.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-06",
          "value": 352.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-07",
          "value": 357.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-08",
          "value": 360.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-09",
          "value": 366.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-10",
          "value": 371.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-11",
          "value": 378.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-12",
          "value": 390.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-01",
          "value": 403.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-02",
          "value": 406.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-03",
          "value": 408.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-04",
          "value": 412.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-05",
          "value": 415.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-06",
          "value": 417.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-07",
          "value": 420.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-08",
          "value": 423.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-09",
          "value": 427.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-10",
          "value": 429.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-11",
          "value": 433.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-12",
          "value": 441.22,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-01",
          "value": 453.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-02",
          "value": 466.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-03",
          "value": 473.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-04",
          "value": 476.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-05",
          "value": 478.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-06",
          "value": 479.53,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-07",
          "value": 484.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-08",
          "value": 489.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-09",
          "value": 496.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-10",
          "value": 503.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-11",
          "value": 510.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-12",
          "value": 527.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-01",
          "value": 544.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-02",
          "value": 547.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-03",
          "value": 544.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-04",
          "value": 545.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-05",
          "value": 548.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-06",
          "value": 549.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-07",
          "value": 552.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-08",
          "value": 554.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-09",
          "value": 556.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-10",
          "value": 558.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-11",
          "value": 562.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-12",
          "value": 573.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-01",
          "value": 581.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-02",
          "value": 581.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-03",
          "value": 581.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-04",
          "value": 581.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-05",
          "value": 586.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-06",
          "value": 593.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-07",
          "value": 599.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-08",
          "value": 602.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-09",
          "value": 602.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-10",
          "value": 606.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-11",
          "value": 611.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-12",
          "value": 624.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-01",
          "value": 625.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-02",
          "value": 615.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-03",
          "value": 617.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-04",
          "value": 622.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-05",
          "value": 627,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-06",
          "value": 628.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-07",
          "value": 627.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-08",
          "value": 633.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-09",
          "value": 635.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-10",
          "value": 640.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-11",
          "value": 643.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-12",
          "value": 646.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-01",
          "value": 654.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-02",
          "value": 643.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-03",
          "value": 644.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-04",
          "value": 649.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-05",
          "value": 653.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-06",
          "value": 658.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-07",
          "value": 662.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-08",
          "value": 663.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-09",
          "value": 662.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-10",
          "value": 662.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-11",
          "value": 667.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-12",
          "value": 679.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-01",
          "value": 681.29,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-02",
          "value": 679.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-03",
          "value": 690.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-04",
          "value": 684.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-05",
          "value": 685.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-06",
          "value": 687.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-07",
          "value": 691.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-08",
          "value": 690.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-09",
          "value": 694.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-10",
          "value": 697.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-11",
          "value": 704.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-12",
          "value": 716.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-01",
          "value": 718.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-02",
          "value": 716.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-03",
          "value": 717.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-04",
          "value": 721.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-05",
          "value": 723.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-06",
          "value": 719.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-07",
          "value": 723.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-08",
          "value": 733.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-09",
          "value": 749.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-10",
          "value": 766.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-11",
          "value": 774.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-12",
          "value": 771.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-01",
          "value": 753.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-02",
          "value": 751.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-03",
          "value": 757.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-04",
          "value": 775.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-05",
          "value": 786.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-06",
          "value": 774.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-07",
          "value": 779.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-08",
          "value": 778.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-09",
          "value": 780.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-10",
          "value": 776.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-11",
          "value": 770.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-12",
          "value": 785.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-01",
          "value": 798.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-02",
          "value": 796.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-03",
          "value": 786.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-04",
          "value": 786.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-05",
          "value": 792.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-06",
          "value": 787.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-07",
          "value": 789.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-08",
          "value": 799.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-09",
          "value": 826.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-10",
          "value": 835.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-11",
          "value": 825.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-12",
          "value": 841.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-01",
          "value": 850.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-02",
          "value": 850.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-03",
          "value": 852.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-04",
          "value": 856.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-05",
          "value": 836.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-06",
          "value": 828.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-07",
          "value": 837.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-08",
          "value": 843.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-09",
          "value": 859.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-10",
          "value": 859.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-11",
          "value": 864.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-12",
          "value": 876.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-01",
          "value": 878.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-02",
          "value": 869.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-03",
          "value": 879.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-04",
          "value": 890.53,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-05",
          "value": 893.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-06",
          "value": 897.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-07",
          "value": 908,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-08",
          "value": 915.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-09",
          "value": 923.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-10",
          "value": 930.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-11",
          "value": 946.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-12",
          "value": 960.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-01",
          "value": 958.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-02",
          "value": 954.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-03",
          "value": 967.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-04",
          "value": 981.53,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-05",
          "value": 983.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-06",
          "value": 984.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-07",
          "value": 987.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-08",
          "value": 993.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-09",
          "value": 1009.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-10",
          "value": 1001.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-11",
          "value": 996.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-12",
          "value": 998.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-01",
          "value": 1013.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-02",
          "value": 1020.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-03",
          "value": 1045.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-04",
          "value": 1037.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-05",
          "value": 1014.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-06",
          "value": 1000.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-07",
          "value": 1003.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-08",
          "value": 1007.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-09",
          "value": 1014.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-10",
          "value": 1024.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-11",
          "value": 1031.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-12",
          "value": 1041.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-01",
          "value": 1048.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-02",
          "value": 1052.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-03",
          "value": 1045.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-04",
          "value": 1064.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-05",
          "value": 1048.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-06",
          "value": 1035.86,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-07",
          "value": 1046.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-08",
          "value": 1050.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-09",
          "value": 1058.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-10",
          "value": 1063.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-11",
          "value": 1072.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-12",
          "value": 1092.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-01",
          "value": 1108.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-02",
          "value": 1104.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-03",
          "value": 1106.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-04",
          "value": 1105.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-05",
          "value": 1108.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-06",
          "value": 1124.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-07",
          "value": 1142.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-08",
          "value": 1147.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-09",
          "value": 1166.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-10",
          "value": 1170.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-11",
          "value": 1170.22,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-12",
          "value": 1178,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-01",
          "value": 1180.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-02",
          "value": 1180.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-03",
          "value": 1195.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-04",
          "value": 1199.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-05",
          "value": 1200.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-06",
          "value": 1194.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-07",
          "value": 1189.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-08",
          "value": 1198.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-09",
          "value": 1204.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-10",
          "value": 1204.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-11",
          "value": 1221.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-12",
          "value": 1235.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-01",
          "value": 1247.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-02",
          "value": 1251.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-03",
          "value": 1258.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-04",
          "value": 1244.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-05",
          "value": 1242.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-06",
          "value": 1244.85,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-07",
          "value": 1253.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-08",
          "value": 1264.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-09",
          "value": 1277.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-10",
          "value": 1284.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-11",
          "value": 1291.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-12",
          "value": 1309.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-01",
          "value": 1297.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-02",
          "value": 1289.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-03",
          "value": 1301.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-04",
          "value": 1304.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-05",
          "value": 1296.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-06",
          "value": 1299.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-07",
          "value": 1306.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-08",
          "value": 1311.29,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-09",
          "value": 1319.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-10",
          "value": 1323.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-11",
          "value": 1324.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-12",
          "value": 1341.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-01",
          "value": 1361.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-02",
          "value": 1371.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-03",
          "value": 1368.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-04",
          "value": 1365.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-05",
          "value": 1360.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-06",
          "value": 1350.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-07",
          "value": 1348.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-08",
          "value": 1351.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-09",
          "value": 1375.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-10",
          "value": 1378.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-11",
          "value": 1385.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-12",
          "value": 1400.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-01",
          "value": 1404.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-02",
          "value": 1401.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-03",
          "value": 1414.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-04",
          "value": 1428.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-05",
          "value": 1438.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-06",
          "value": 1449.85,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-07",
          "value": 1471.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-08",
          "value": 1495.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-09",
          "value": 1504.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-10",
          "value": 1491.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-11",
          "value": 1498.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-12",
          "value": 1513.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-01",
          "value": 1514.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-02",
          "value": 1500.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-03",
          "value": 1514.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-04",
          "value": 1514.53,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-05",
          "value": 1504.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-06",
          "value": 1506.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-07",
          "value": 1521.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 1544.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 1547.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 1543.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 1562.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 1586.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 1600.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 1587.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 1595.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 1605.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 1598.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 1589.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 1608.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 1602.22,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 1602.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 1604.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 1617.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 1637.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 1653.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 1663.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 1676.85,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 1677.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 1689.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 1679.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 1688.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 1702.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 1713.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 1724.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 1721,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 1713.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 1725.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 1728.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 1741.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 1759.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 1778.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 1793.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 1810.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 1828.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 1847.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 1850.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 1879.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 1901.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 1930.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 1950.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 1974.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 1978.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 1982.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 2011.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 2042.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 2086.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 2114.03,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 2112.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 2110.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 2124.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 2143.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 2154.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 2164.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 2173.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 2177.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 2179.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 2192.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 2220.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 2243.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 2224.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 2225.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 2269.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 2328.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 2293.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 2287.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 2298.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 2304.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 2302.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 2352.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 2354.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 2344.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 2349.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 2359.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 2363.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 2366.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 2364.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 2379.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 2400.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 2429.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 2441.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 2453.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 2452.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 2454.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 2450.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 2462.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 2467.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 2486.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 2516.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 2571.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 2598.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 2597.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 2553.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        }
      ]
    },
    {
      "id": "canasta-ampliada-rural",
      "label": "Canasta alimentaria más no alimentaria, ámbito rural",
      "shortLabel": "Rural",
      "unit": "MXN_persona_mes",
      "geography": "rural",
      "basketId": "canasta-ampliada",
      "sourceId": "inegi-lp",
      "higherIsBetter": false,
      "points": [
        {
          "period": "1992-01",
          "value": 258.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-02",
          "value": 260.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-03",
          "value": 262.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-04",
          "value": 264.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-05",
          "value": 264.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-06",
          "value": 265.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-07",
          "value": 266.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-08",
          "value": 266.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-09",
          "value": 268.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-10",
          "value": 271.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-11",
          "value": 274.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-12",
          "value": 280.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-01",
          "value": 284.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-02",
          "value": 285.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-03",
          "value": 284.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-04",
          "value": 284.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-05",
          "value": 285.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-06",
          "value": 287.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-07",
          "value": 287.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-08",
          "value": 288.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-09",
          "value": 292.03,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-10",
          "value": 293.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-11",
          "value": 295.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-12",
          "value": 298.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-01",
          "value": 301.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-02",
          "value": 301.03,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-03",
          "value": 301.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-04",
          "value": 301.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-05",
          "value": 301.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-06",
          "value": 303.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-07",
          "value": 304.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-08",
          "value": 306.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-09",
          "value": 308.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-10",
          "value": 309.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-11",
          "value": 311.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-12",
          "value": 314.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-01",
          "value": 324.43,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-02",
          "value": 338.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-03",
          "value": 361.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-04",
          "value": 390.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-05",
          "value": 405.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-06",
          "value": 419.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-07",
          "value": 427.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-08",
          "value": 434.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-09",
          "value": 442.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-10",
          "value": 451.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-11",
          "value": 465.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-12",
          "value": 482.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-01",
          "value": 501.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-02",
          "value": 512.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-03",
          "value": 522.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-04",
          "value": 536.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-05",
          "value": 547.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-06",
          "value": 557,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-07",
          "value": 564.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-08",
          "value": 572.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-09",
          "value": 583.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-10",
          "value": 591.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-11",
          "value": 602.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-12",
          "value": 624.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-01",
          "value": 640.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-02",
          "value": 647.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-03",
          "value": 652.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-04",
          "value": 658.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-05",
          "value": 663.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-06",
          "value": 668.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-07",
          "value": 673.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-08",
          "value": 679.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-09",
          "value": 688.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-10",
          "value": 693.5,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-11",
          "value": 702.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-12",
          "value": 712.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-01",
          "value": 728.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-02",
          "value": 745.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-03",
          "value": 755.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-04",
          "value": 761.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-05",
          "value": 762.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-06",
          "value": 768.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-07",
          "value": 776.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-08",
          "value": 784.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-09",
          "value": 798.29,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-10",
          "value": 809.85,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-11",
          "value": 826.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-12",
          "value": 853.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-01",
          "value": 877.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-02",
          "value": 885.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-03",
          "value": 888.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-04",
          "value": 893.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-05",
          "value": 896.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-06",
          "value": 901.84,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-07",
          "value": 906.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-08",
          "value": 911.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-09",
          "value": 920.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-10",
          "value": 926.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-11",
          "value": 936.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-12",
          "value": 949.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-01",
          "value": 961.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-02",
          "value": 967.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-03",
          "value": 969.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-04",
          "value": 972.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-05",
          "value": 975.29,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-06",
          "value": 982.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-07",
          "value": 989.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-08",
          "value": 994.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-09",
          "value": 999.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-10",
          "value": 1006.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-11",
          "value": 1017.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-12",
          "value": 1033.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-01",
          "value": 1035.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-02",
          "value": 1028.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-03",
          "value": 1033.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-04",
          "value": 1038.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-05",
          "value": 1040.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-06",
          "value": 1042.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-07",
          "value": 1040.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-08",
          "value": 1048.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-09",
          "value": 1057.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-10",
          "value": 1063.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-11",
          "value": 1071.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-12",
          "value": 1075.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-01",
          "value": 1083.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-02",
          "value": 1078.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-03",
          "value": 1081.53,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-04",
          "value": 1087.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-05",
          "value": 1087.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-06",
          "value": 1092.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-07",
          "value": 1095.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-08",
          "value": 1097.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-09",
          "value": 1101.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-10",
          "value": 1103.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-11",
          "value": 1115.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-12",
          "value": 1126.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-01",
          "value": 1128.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-02",
          "value": 1128.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-03",
          "value": 1140.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-04",
          "value": 1134.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-05",
          "value": 1128.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-06",
          "value": 1129.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-07",
          "value": 1133.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-08",
          "value": 1134.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-09",
          "value": 1143.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-10",
          "value": 1148.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-11",
          "value": 1163.53,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-12",
          "value": 1175.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-01",
          "value": 1179.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-02",
          "value": 1179.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-03",
          "value": 1183.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-04",
          "value": 1188.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-05",
          "value": 1183.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-06",
          "value": 1179.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-07",
          "value": 1182.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-08",
          "value": 1195.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-09",
          "value": 1213.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-10",
          "value": 1232.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-11",
          "value": 1249.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-12",
          "value": 1245.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-01",
          "value": 1227.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-02",
          "value": 1226.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-03",
          "value": 1235.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-04",
          "value": 1253.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-05",
          "value": 1254.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-06",
          "value": 1242.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-07",
          "value": 1247.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-08",
          "value": 1246.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-09",
          "value": 1252,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-10",
          "value": 1250.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-11",
          "value": 1256.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-12",
          "value": 1273.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-01",
          "value": 1288.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-02",
          "value": 1288.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-03",
          "value": 1280.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-04",
          "value": 1280.22,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-05",
          "value": 1274.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-06",
          "value": 1270.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-07",
          "value": 1272.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-08",
          "value": 1286.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-09",
          "value": 1319.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-10",
          "value": 1332.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-11",
          "value": 1331.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-12",
          "value": 1348.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-01",
          "value": 1358.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-02",
          "value": 1357.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-03",
          "value": 1360.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-04",
          "value": 1361.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-05",
          "value": 1335.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-06",
          "value": 1327.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-07",
          "value": 1337.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-08",
          "value": 1344.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-09",
          "value": 1364.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-10",
          "value": 1368.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-11",
          "value": 1381,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-12",
          "value": 1394.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-01",
          "value": 1397.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-02",
          "value": 1389.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-03",
          "value": 1404.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-04",
          "value": 1413.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-05",
          "value": 1408.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-06",
          "value": 1414.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-07",
          "value": 1427.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-08",
          "value": 1440.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-09",
          "value": 1455.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-10",
          "value": 1469.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-11",
          "value": 1495.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-12",
          "value": 1510.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-01",
          "value": 1509.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-02",
          "value": 1509.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-03",
          "value": 1524.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-04",
          "value": 1538.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-05",
          "value": 1531.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-06",
          "value": 1532.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-07",
          "value": 1536.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-08",
          "value": 1545.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-09",
          "value": 1564.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-10",
          "value": 1563.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-11",
          "value": 1568.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-12",
          "value": 1571.53,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-01",
          "value": 1591.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-02",
          "value": 1602.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-03",
          "value": 1631.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-04",
          "value": 1621.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-05",
          "value": 1589.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-06",
          "value": 1575.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-07",
          "value": 1577.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-08",
          "value": 1585.5,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-09",
          "value": 1597.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-10",
          "value": 1615.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-11",
          "value": 1632.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-12",
          "value": 1641.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-01",
          "value": 1650.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-02",
          "value": 1657.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-03",
          "value": 1653.53,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-04",
          "value": 1667.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-05",
          "value": 1639.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-06",
          "value": 1628.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-07",
          "value": 1640.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-08",
          "value": 1646.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-09",
          "value": 1658.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-10",
          "value": 1672.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-11",
          "value": 1695.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-12",
          "value": 1718.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-01",
          "value": 1738.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-02",
          "value": 1736.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-03",
          "value": 1739.5,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-04",
          "value": 1731.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-05",
          "value": 1724.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-06",
          "value": 1742.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-07",
          "value": 1761.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-08",
          "value": 1769.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-09",
          "value": 1791.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-10",
          "value": 1801.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-11",
          "value": 1813.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-12",
          "value": 1821.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-01",
          "value": 1826.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-02",
          "value": 1829.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-03",
          "value": 1847.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-04",
          "value": 1847.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-05",
          "value": 1839.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-06",
          "value": 1835.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-07",
          "value": 1828.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-08",
          "value": 1839.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-09",
          "value": 1851.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-10",
          "value": 1859.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-11",
          "value": 1890.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-12",
          "value": 1909.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-01",
          "value": 1921.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-02",
          "value": 1923.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-03",
          "value": 1929.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-04",
          "value": 1908.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-05",
          "value": 1892.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-06",
          "value": 1894.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-07",
          "value": 1901.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-08",
          "value": 1913.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-09",
          "value": 1930.22,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-10",
          "value": 1946.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-11",
          "value": 1970.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-12",
          "value": 1989.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-01",
          "value": 1974.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-02",
          "value": 1969.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-03",
          "value": 1989.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-04",
          "value": 1984.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-05",
          "value": 1961.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-06",
          "value": 1963,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-07",
          "value": 1968.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-08",
          "value": 1975.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-09",
          "value": 1988.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-10",
          "value": 2002.29,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-11",
          "value": 2016.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-12",
          "value": 2032.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-01",
          "value": 2050.84,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-02",
          "value": 2063.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-03",
          "value": 2060.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-04",
          "value": 2049.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-05",
          "value": 2028,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-06",
          "value": 2018.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-07",
          "value": 2019.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-08",
          "value": 2030.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-09",
          "value": 2061.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-10",
          "value": 2076.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-11",
          "value": 2098.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-12",
          "value": 2111.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-01",
          "value": 2139.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-02",
          "value": 2141.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-03",
          "value": 2157.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-04",
          "value": 2164.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-05",
          "value": 2166.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-06",
          "value": 2176.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-07",
          "value": 2196.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-08",
          "value": 2223.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-09",
          "value": 2234.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-10",
          "value": 2234.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-11",
          "value": 2261.43,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-12",
          "value": 2281.03,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-01",
          "value": 2287.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-02",
          "value": 2281.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-03",
          "value": 2299.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-04",
          "value": 2291.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-05",
          "value": 2270.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-06",
          "value": 2274.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-07",
          "value": 2288.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 2316.53,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 2328.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 2338.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 2374.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 2397.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 2406.84,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 2396.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 2410.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 2410.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 2392.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 2382.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 2401.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 2397.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 2402.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 2417.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 2447.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 2467.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 2485.43,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 2496.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 2501.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 2467.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 2474.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 2481.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 2502.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 2519.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 2533.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 2554,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 2555.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 2555.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 2574.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 2585.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 2605.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 2617.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 2621.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 2636.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 2653.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 2673.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 2698.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 2715.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 2761.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 2784.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 2811.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 2837.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 2869.84,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 2873.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 2865.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 2897.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 2927.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 2970.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 3006.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 3022.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 3036.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 3051.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 3073.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 3088.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 3101.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 3104.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 3090.22,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 3090.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 3103.3,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 3138.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 3170.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 3165.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 3183.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 3225.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 3285.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 3252.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 3251.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 3254.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 3244.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 3241.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 3293.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 3296.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 3290.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 3308.22,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 3329.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 3334.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 3342.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 3340.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 3350.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 3362.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 3380.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 3388.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 3396.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 3394.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 3403.5,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 3411.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 3447.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 3451.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 3465.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 3494.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 3553.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 3572.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 3554.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 3503.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        }
      ]
    },
    {
      "id": "canasta-ampliada-urbana",
      "label": "Canasta alimentaria más no alimentaria, ámbito urbano",
      "shortLabel": "Urbana",
      "unit": "MXN_persona_mes",
      "geography": "urbano",
      "basketId": "canasta-ampliada",
      "sourceId": "inegi-lp",
      "higherIsBetter": false,
      "points": [
        {
          "period": "1992-01",
          "value": 421.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-02",
          "value": 424.22,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-03",
          "value": 426.86,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-04",
          "value": 429.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-05",
          "value": 429.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-06",
          "value": 431.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-07",
          "value": 432.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-08",
          "value": 433.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-09",
          "value": 438.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-10",
          "value": 441.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-11",
          "value": 445.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1992-12",
          "value": 453.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-01",
          "value": 465.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-02",
          "value": 467.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-03",
          "value": 467.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-04",
          "value": 467.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-05",
          "value": 469.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-06",
          "value": 471.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-07",
          "value": 471.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-08",
          "value": 473.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-09",
          "value": 479.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-10",
          "value": 481.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-11",
          "value": 484.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1993-12",
          "value": 488.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-01",
          "value": 492.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-02",
          "value": 494.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-03",
          "value": 497.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-04",
          "value": 497.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-05",
          "value": 498.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-06",
          "value": 499.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-07",
          "value": 502.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-08",
          "value": 503.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-09",
          "value": 507.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-10",
          "value": 509.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-11",
          "value": 512.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1994-12",
          "value": 516.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-01",
          "value": 529.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-02",
          "value": 547.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-03",
          "value": 588.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-04",
          "value": 630.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-05",
          "value": 649.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-06",
          "value": 666.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-07",
          "value": 677.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-08",
          "value": 687.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-09",
          "value": 699.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-10",
          "value": 711.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-11",
          "value": 729.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1995-12",
          "value": 753.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-01",
          "value": 791.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-02",
          "value": 808.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-03",
          "value": 824.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-04",
          "value": 844.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-05",
          "value": 862.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-06",
          "value": 880.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-07",
          "value": 893.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-08",
          "value": 905.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-09",
          "value": 920.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-10",
          "value": 938.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-11",
          "value": 955.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1996-12",
          "value": 986.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-01",
          "value": 1003.29,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-02",
          "value": 1016.84,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-03",
          "value": 1028,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-04",
          "value": 1039.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-05",
          "value": 1053.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-06",
          "value": 1063.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-07",
          "value": 1074.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-08",
          "value": 1084.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-09",
          "value": 1100.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-10",
          "value": 1112.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-11",
          "value": 1128.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1997-12",
          "value": 1145.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-01",
          "value": 1170.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-02",
          "value": 1193.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-03",
          "value": 1208.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-04",
          "value": 1218.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-05",
          "value": 1220.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-06",
          "value": 1227.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-07",
          "value": 1237.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-08",
          "value": 1249.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-09",
          "value": 1270.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-10",
          "value": 1285.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-11",
          "value": 1309.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1998-12",
          "value": 1342.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-01",
          "value": 1369.5,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-02",
          "value": 1382.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-03",
          "value": 1397.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-04",
          "value": 1409.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-05",
          "value": 1412.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-06",
          "value": 1420.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-07",
          "value": 1432.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-08",
          "value": 1441.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-09",
          "value": 1455.5,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-10",
          "value": 1464.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-11",
          "value": 1481.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "1999-12",
          "value": 1498.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-01",
          "value": 1514.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-02",
          "value": 1522.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-03",
          "value": 1526.86,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-04",
          "value": 1529.31,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-05",
          "value": 1531.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-06",
          "value": 1541.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-07",
          "value": 1550.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-08",
          "value": 1559.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-09",
          "value": 1567,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-10",
          "value": 1588.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-11",
          "value": 1605.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2000-12",
          "value": 1623.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-01",
          "value": 1629.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-02",
          "value": 1624.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-03",
          "value": 1639.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-04",
          "value": 1644.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-05",
          "value": 1642.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-06",
          "value": 1646.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-07",
          "value": 1644.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-08",
          "value": 1653.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-09",
          "value": 1666.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-10",
          "value": 1674.85,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-11",
          "value": 1688.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2001-12",
          "value": 1693.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-01",
          "value": 1705.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-02",
          "value": 1708.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-03",
          "value": 1714.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-04",
          "value": 1721.06,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-05",
          "value": 1717.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-06",
          "value": 1724.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-07",
          "value": 1728.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-08",
          "value": 1732.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-09",
          "value": 1741.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-10",
          "value": 1746.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-11",
          "value": 1764.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2002-12",
          "value": 1775.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-01",
          "value": 1782.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-02",
          "value": 1784.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-03",
          "value": 1799.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-04",
          "value": 1793.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-05",
          "value": 1781.32,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-06",
          "value": 1783.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-07",
          "value": 1786.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-08",
          "value": 1790.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-09",
          "value": 1803.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-10",
          "value": 1809.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-11",
          "value": 1831.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2003-12",
          "value": 1844.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-01",
          "value": 1851.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-02",
          "value": 1855.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-03",
          "value": 1859.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-04",
          "value": 1865.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-05",
          "value": 1857.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-06",
          "value": 1856.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-07",
          "value": 1861.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-08",
          "value": 1875.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-09",
          "value": 1899.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-10",
          "value": 1921.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-11",
          "value": 1945.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2004-12",
          "value": 1944.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-01",
          "value": 1929.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-02",
          "value": 1928.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-03",
          "value": 1938.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-04",
          "value": 1954.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-05",
          "value": 1949.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-06",
          "value": 1940.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-07",
          "value": 1946.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-08",
          "value": 1948.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-09",
          "value": 1959.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-10",
          "value": 1961.98,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-11",
          "value": 1976.66,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2005-12",
          "value": 1995.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-01",
          "value": 2013.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-02",
          "value": 2012.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-03",
          "value": 2005.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-04",
          "value": 2005.57,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-05",
          "value": 1993.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-06",
          "value": 1991.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-07",
          "value": 1994.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-08",
          "value": 2008.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-09",
          "value": 2040.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-10",
          "value": 2054.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-11",
          "value": 2064.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2006-12",
          "value": 2084.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-01",
          "value": 2097.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-02",
          "value": 2098.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-03",
          "value": 2103.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-04",
          "value": 2101.22,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-05",
          "value": 2068.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-06",
          "value": 2063.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-07",
          "value": 2074.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-08",
          "value": 2083.18,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-09",
          "value": 2106.85,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-10",
          "value": 2116.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-11",
          "value": 2131.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2007-12",
          "value": 2144.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-01",
          "value": 2153.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-02",
          "value": 2147.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-03",
          "value": 2163.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-04",
          "value": 2169.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-05",
          "value": 2161.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-06",
          "value": 2173.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-07",
          "value": 2189.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-08",
          "value": 2206.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-09",
          "value": 2228.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-10",
          "value": 2247.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-11",
          "value": 2280.72,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2008-12",
          "value": 2293.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-01",
          "value": 2295.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-02",
          "value": 2296.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-03",
          "value": 2312.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-04",
          "value": 2325.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-05",
          "value": 2310.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-06",
          "value": 2312.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-07",
          "value": 2315.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-08",
          "value": 2322.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-09",
          "value": 2343.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-10",
          "value": 2349.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-11",
          "value": 2358.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2009-12",
          "value": 2361.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-01",
          "value": 2399.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-02",
          "value": 2417.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-03",
          "value": 2448.35,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-04",
          "value": 2434.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-05",
          "value": 2396.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-06",
          "value": 2384.81,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-07",
          "value": 2389.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-08",
          "value": 2399.34,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-09",
          "value": 2416.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-10",
          "value": 2435.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-11",
          "value": 2461.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2010-12",
          "value": 2470.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-01",
          "value": 2485.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-02",
          "value": 2499.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-03",
          "value": 2488.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-04",
          "value": 2473.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-05",
          "value": 2440.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-06",
          "value": 2431.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-07",
          "value": 2444.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-08",
          "value": 2450.7,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-09",
          "value": 2464.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-10",
          "value": 2483.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-11",
          "value": 2521.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2011-12",
          "value": 2545.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-01",
          "value": 2568.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-02",
          "value": 2570.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-03",
          "value": 2568.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-04",
          "value": 2552.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-05",
          "value": 2540.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-06",
          "value": 2551.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-07",
          "value": 2572.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-08",
          "value": 2583.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-09",
          "value": 2604.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-10",
          "value": 2613.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-11",
          "value": 2611.64,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2012-12",
          "value": 2599.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-01",
          "value": 2628.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-02",
          "value": 2667.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-03",
          "value": 2692.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-04",
          "value": 2687.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-05",
          "value": 2672.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-06",
          "value": 2669.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-07",
          "value": 2662.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-08",
          "value": 2672.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-09",
          "value": 2687.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-10",
          "value": 2707.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-11",
          "value": 2751.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2013-12",
          "value": 2771.79,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-01",
          "value": 2803.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-02",
          "value": 2813.77,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-03",
          "value": 2824.51,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-04",
          "value": 2793.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-05",
          "value": 2765.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-06",
          "value": 2771.99,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-07",
          "value": 2782.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-08",
          "value": 2798.07,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-09",
          "value": 2814.44,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-10",
          "value": 2836.26,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-11",
          "value": 2868.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2014-12",
          "value": 2878.88,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-01",
          "value": 2867.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-02",
          "value": 2869.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-03",
          "value": 2890.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-04",
          "value": 2877.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-05",
          "value": 2847.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-06",
          "value": 2850.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-07",
          "value": 2856.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-08",
          "value": 2866.33,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-09",
          "value": 2882.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-10",
          "value": 2901.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-11",
          "value": 2912.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2015-12",
          "value": 2923.29,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-01",
          "value": 2942.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-02",
          "value": 2955.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-03",
          "value": 2952.05,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-04",
          "value": 2933.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-05",
          "value": 2899.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-06",
          "value": 2889.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-07",
          "value": 2893.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-08",
          "value": 2903.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-09",
          "value": 2934.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-10",
          "value": 2957.38,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-11",
          "value": 2990.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2016-12",
          "value": 3008.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-01",
          "value": 3073.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-02",
          "value": 3083.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-03",
          "value": 3100.09,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-04",
          "value": 3098.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-05",
          "value": 3088.13,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-06",
          "value": 3099.36,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-07",
          "value": 3118.12,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-08",
          "value": 3151.61,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-09",
          "value": 3169.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-10",
          "value": 3191.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-11",
          "value": 3234.78,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2017-12",
          "value": 3256.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-01",
          "value": 3275.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-02",
          "value": 3275.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-03",
          "value": 3293.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-04",
          "value": 3275.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-05",
          "value": 3250.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-06",
          "value": 3264.69,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-07",
          "value": 3287.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 3325.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 3346.85,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 3364.82,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 3405.37,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 3427.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 3437.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 3434.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 3454.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 3446.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 3415.54,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 3400.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 3418.94,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 3417.75,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 3428.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 3451.76,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 3494.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 3518.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 3538.74,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 3548.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 3542.39,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 3475.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 3482.2,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 3503.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 3536.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 3559.53,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 3577.28,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 3605.92,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 3610.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 3618.84,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 3660.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 3686.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 3716.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 3722.02,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 3717.27,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 3740.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 3766.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 3775.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 3808.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 3842.9,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 3898.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 3916.48,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 3957.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 3996.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 4042.17,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 4040.68,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 4024.03,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 4064.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 4104.41,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 4157.63,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 4193.58,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 4208.19,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 4232.62,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 4245.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 4275.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 4298.4,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 4311.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 4304.25,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 4278.67,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 4277.08,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 4292.42,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 4336.6,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 4378.46,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 4386.21,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 4414.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 4460.93,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 4528.71,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 4514.95,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 4513.73,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 4509.24,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 4484.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 4485.56,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 4552.89,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 4564.97,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 4567.59,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 4592.47,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 4628.83,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 4640.16,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 4660.52,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 4666.65,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 4680.15,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 4685.49,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 4690.04,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 4703.8,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 4718.55,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 4722.01,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 4740.84,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 4759.91,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 4809.1,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 4818.14,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 4843.11,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 4877.87,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 4940.45,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 4954.23,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 4929.96,
          "sourceId": "inegi-lp",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 4888.22,
          "sourceId": "inegi-lp",
          "confidence": "high"
        }
      ]
    },
    {
      "id": "salario-minimo-diario",
      "label": "Salario mínimo general, pesos por día",
      "shortLabel": "Salario mínimo",
      "unit": "MXN_dia",
      "geography": "nacional",
      "sourceId": "conasami-salario-minimo",
      "higherIsBetter": true,
      "points": [
        {
          "period": "1992-01",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1992-02",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1992-03",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1992-04",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1992-05",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1992-06",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1992-07",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1992-08",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1992-09",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1992-10",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1992-11",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1992-12",
          "value": 12.08402,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-01",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-02",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-03",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-04",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-05",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-06",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-07",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-08",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-09",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-10",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-11",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1993-12",
          "value": 13.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-01",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-02",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-03",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-04",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-05",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-06",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-07",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-08",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-09",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-10",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-11",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1994-12",
          "value": 13.97,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-01",
          "value": 14.95,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-02",
          "value": 14.95,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-03",
          "value": 14.95,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-04",
          "value": 16.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-05",
          "value": 16.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-06",
          "value": 16.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-07",
          "value": 16.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-08",
          "value": 16.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-09",
          "value": 16.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-10",
          "value": 16.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-11",
          "value": 16.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1995-12",
          "value": 18.43,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-01",
          "value": 18.43,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-02",
          "value": 18.43,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-03",
          "value": 18.43,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-04",
          "value": 20.66,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-05",
          "value": 20.66,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-06",
          "value": 20.66,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-07",
          "value": 20.66,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-08",
          "value": 20.66,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-09",
          "value": 20.66,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-10",
          "value": 20.66,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-11",
          "value": 20.66,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1996-12",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-01",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-02",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-03",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-04",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-05",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-06",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-07",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-08",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-09",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-10",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-11",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1997-12",
          "value": 24.3,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-01",
          "value": 27.99,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-02",
          "value": 27.99,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-03",
          "value": 27.99,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-04",
          "value": 27.99,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-05",
          "value": 27.99,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-06",
          "value": 27.99,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-07",
          "value": 27.99,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-08",
          "value": 27.99,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-09",
          "value": 27.99,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-10",
          "value": 27.99,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-11",
          "value": 27.99,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1998-12",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-01",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-02",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-03",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-04",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-05",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-06",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-07",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-08",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-09",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-10",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-11",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "1999-12",
          "value": 31.91,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-01",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-02",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-03",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-04",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-05",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-06",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-07",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-08",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-09",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-10",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-11",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2000-12",
          "value": 35.12,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-01",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-02",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-03",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-04",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-05",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-06",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-07",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-08",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-09",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-10",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-11",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2001-12",
          "value": 37.57,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-01",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-02",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-03",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-04",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-05",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-06",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-07",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-08",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-09",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-10",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-11",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2002-12",
          "value": 39.74,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-01",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-02",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-03",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-04",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-05",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-06",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-07",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-08",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-09",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-10",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-11",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2003-12",
          "value": 41.53,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-01",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-02",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-03",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-04",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-05",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-06",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-07",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-08",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-09",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-10",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-11",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2004-12",
          "value": 43.297,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-01",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-02",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-03",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-04",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-05",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-06",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-07",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-08",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-09",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-10",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-11",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2005-12",
          "value": 45.24,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-01",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-02",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-03",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-04",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-05",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-06",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-07",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-08",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-09",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-10",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-11",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2006-12",
          "value": 47.05,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-01",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-02",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-03",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-04",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-05",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-06",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-07",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-08",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-09",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-10",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-11",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2007-12",
          "value": 48.88,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-01",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-02",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-03",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-04",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-05",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-06",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-07",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-08",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-09",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-10",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-11",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2008-12",
          "value": 50.84,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-01",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-02",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-03",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-04",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-05",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-06",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-07",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-08",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-09",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-10",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-11",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2009-12",
          "value": 53.19,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-01",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-02",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-03",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-04",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-05",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-06",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-07",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-08",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-09",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-10",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-11",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2010-12",
          "value": 55.77,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-01",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-02",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-03",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-04",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-05",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-06",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-07",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-08",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-09",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-10",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-11",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2011-12",
          "value": 58.06,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-01",
          "value": 60.5,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-02",
          "value": 60.5,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-03",
          "value": 60.5,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-04",
          "value": 60.5,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-05",
          "value": 60.5,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-06",
          "value": 60.5,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-07",
          "value": 60.5,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-08",
          "value": 60.5,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-09",
          "value": 60.5,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-10",
          "value": 60.5,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-11",
          "value": 60.5,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2012-12",
          "value": 60.75,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-01",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-02",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-03",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-04",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-05",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-06",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-07",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-08",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-09",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-10",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-11",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2013-12",
          "value": 63.11925,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-01",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-02",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-03",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-04",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-05",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-06",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-07",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-08",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-09",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-10",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-11",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2014-12",
          "value": 65.5809007,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-01",
          "value": 68.3352986,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-02",
          "value": 68.3352986,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-03",
          "value": 68.3352986,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-04",
          "value": 69.26,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-05",
          "value": 69.26,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-06",
          "value": 69.26,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-07",
          "value": 69.26,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-08",
          "value": 69.26,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-09",
          "value": 69.26,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-10",
          "value": 70.1,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-11",
          "value": 70.1,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2015-12",
          "value": 70.1,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-01",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-02",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-03",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-04",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-05",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-06",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-07",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-08",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-09",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-10",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-11",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2016-12",
          "value": 73.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-01",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-02",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-03",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-04",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-05",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-06",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-07",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-08",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-09",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-10",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-11",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2017-12",
          "value": 80.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-01",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-02",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-03",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-04",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-05",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-06",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-07",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 88.36,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 102.68,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 123.22,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 141.7,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 172.87,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 207.44,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 248.93,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 278.8,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 315.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 315.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 315.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 315.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 315.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 315.04,
          "sourceId": "conasami-salario-minimo",
          "confidence": "high"
        }
      ]
    }
  ],
  "products": [
    {
      "id": "enigh-a095",
      "name": "Aceite vegetal: canola, cártamo, girasol, maíz, etcétera",
      "category": "azucares-grasas",
      "unit": "L",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 550.2,
        "urbano": 326.1
      }
    },
    {
      "id": "enigh-a215",
      "name": "Agua natural embotellada",
      "category": "bebidas",
      "unit": "L",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 11986.5,
        "urbano": 15813.6
      }
    },
    {
      "id": "enigh-a243-a245",
      "name": "Alimentos y bebidas consumidas fuera del hogar",
      "category": "otros",
      "unit": "ración",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 226.2,
        "urbano": 414.9
      }
    },
    {
      "id": "enigh-a019",
      "name": "Arroz en grano",
      "category": "cereales",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 444.6,
        "urbano": 343.8
      }
    },
    {
      "id": "enigh-a068",
      "name": "Atún enlatado",
      "category": "pescados",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "urbano": 90.9
      }
    },
    {
      "id": "enigh-a173",
      "name": "Azúcar blanca y morena",
      "category": "azucares-grasas",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 607.2,
        "urbano": 355.5
      }
    },
    {
      "id": "enigh-a091",
      "name": "Bebidas fermentadas de leche",
      "category": "lacteos-huevo",
      "unit": "L",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 140.1,
        "urbano": 224.1
      }
    },
    {
      "id": "enigh-a038",
      "name": "Bistec de puerco (de cualquier parte que se saque)",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 95.1,
        "urbano": 84.6
      }
    },
    {
      "id": "enigh-a025",
      "name": "Bistec de res (de cualquier parte que se saque)",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 563.1,
        "urbano": 639.9
      }
    },
    {
      "id": "enigh-a112",
      "name": "Cebolla",
      "category": "verduras",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 1199.1,
        "urbano": 1284
      }
    },
    {
      "id": "enigh-a021",
      "name": "Cereal de maíz, trigo, arroz, avena, granola, etcétera",
      "category": "cereales",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "urbano": 127.5
      }
    },
    {
      "id": "enigh-a048",
      "name": "Chicharrón de puerco",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 60.6
      }
    },
    {
      "id": "enigh-a115-a118",
      "name": "Chile (promedio de jalapeño, poblano, serrano y otros)",
      "category": "verduras",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 404.7,
        "urbano": 350.1
      }
    },
    {
      "id": "enigh-a049",
      "name": "Chorizo con cualquier condimento y color, y longaniza",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "urbano": 125.4
      }
    },
    {
      "id": "enigh-a062",
      "name": "Chorizo de pollo, jamón, nugget, salchicha, mortadela, etcétera",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 97.2
      }
    },
    {
      "id": "enigh-a042",
      "name": "Costilla y chuleta de puerco",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 84.3,
        "urbano": 615.6
      }
    },
    {
      "id": "enigh-a067",
      "name": "Filete de pescado",
      "category": "pescados",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "urbano": 78
      }
    },
    {
      "id": "enigh-a137",
      "name": "Frijol en grano",
      "category": "leguminosas",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 1937.4,
        "urbano": 1534.5
      }
    },
    {
      "id": "enigh-a010",
      "name": "Galletas dulces",
      "category": "cereales",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 139.8,
        "urbano": 121.8
      }
    },
    {
      "id": "enigh-a093",
      "name": "Huevo de gallina, blanco y rojo",
      "category": "lacteos-huevo",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 1291.2,
        "urbano": 1116.3
      }
    },
    {
      "id": "enigh-a052",
      "name": "Jamón de puerco",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "urbano": 104.4
      }
    },
    {
      "id": "enigh-a124",
      "name": "Jitomate",
      "category": "verduras",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 2040.3,
        "urbano": 1911.9
      }
    },
    {
      "id": "enigh-a218",
      "name": "Jugos y néctares envasados",
      "category": "bebidas",
      "unit": "L",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "urbano": 1701.6
      }
    },
    {
      "id": "enigh-a075",
      "name": "Leche pasteurizada de vaca",
      "category": "lacteos-huevo",
      "unit": "L",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 3616.8,
        "urbano": 6187.8
      }
    },
    {
      "id": "enigh-a154",
      "name": "Limón",
      "category": "frutas",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 682.2,
        "urbano": 789
      }
    },
    {
      "id": "enigh-a001",
      "name": "Maíz en grano (de todo tipo y color)",
      "category": "cereales",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 1524.9
      }
    },
    {
      "id": "enigh-a158",
      "name": "Manzana y perón",
      "category": "frutas",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 785.1,
        "urbano": 906.6
      }
    },
    {
      "id": "enigh-a034",
      "name": "Molida de res",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 414,
        "urbano": 421.8
      }
    },
    {
      "id": "enigh-a160",
      "name": "Naranja",
      "category": "frutas",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 755.1,
        "urbano": 869.4
      }
    },
    {
      "id": "enigh-a202",
      "name": "Otros alimentos preparados",
      "category": "otros",
      "unit": "ración",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 41.1,
        "urbano": 74.4
      }
    },
    {
      "id": "enigh-a012",
      "name": "Pan blanco: bolillo, telera, baguete, etcétera",
      "category": "cereales",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 369.9,
        "urbano": 789
      }
    },
    {
      "id": "enigh-a013",
      "name": "Pan dulce en piezas (de todo tipo)",
      "category": "cereales",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 826.5,
        "urbano": 1036.5
      }
    },
    {
      "id": "enigh-a015",
      "name": "Pan para sándwich, hamburguesa, hot dog y tostado",
      "category": "cereales",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "urbano": 203.7
      }
    },
    {
      "id": "enigh-a102",
      "name": "Papa",
      "category": "verduras",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 993.6,
        "urbano": 1355.1
      }
    },
    {
      "id": "enigh-a009",
      "name": "Pasta para sopa",
      "category": "cereales",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 246,
        "urbano": 176.4
      }
    },
    {
      "id": "enigh-a066",
      "name": "Pescado entero, limpio y sin limpiar",
      "category": "pescados",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 194.7,
        "urbano": 79.2
      }
    },
    {
      "id": "enigh-a057",
      "name": "Pierna, muslo o pechuga de pollo con hueso",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 847.8,
        "urbano": 604.8
      }
    },
    {
      "id": "enigh-a058",
      "name": "Pierna, muslo o pechuga de pollo sin hueso",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 85.2,
        "urbano": 243.3
      }
    },
    {
      "id": "enigh-a166",
      "name": "Plátano verde y tabasco",
      "category": "frutas",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 987,
        "urbano": 1051.8
      }
    },
    {
      "id": "enigh-a059",
      "name": "Pollo entero o en piezas (excepto pierna, muslo y pechuga)",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 987,
        "urbano": 396
      }
    },
    {
      "id": "enigh-a200",
      "name": "Pollo rostizado",
      "category": "otros",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 181.2,
        "urbano": 258
      }
    },
    {
      "id": "enigh-a085",
      "name": "Queso fresco",
      "category": "lacteos-huevo",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 220.5,
        "urbano": 150.9
      }
    },
    {
      "id": "enigh-a087",
      "name": "Queso oaxaca o asadero",
      "category": "lacteos-huevo",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 60.3,
        "urbano": 93.3
      }
    },
    {
      "id": "enigh-a220",
      "name": "Refrescos de cola y de sabores",
      "category": "bebidas",
      "unit": "L",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 3705.3,
        "urbano": 4770.9
      }
    },
    {
      "id": "enigh-a055",
      "name": "Salchichas y salchichón",
      "category": "carnes",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 106.5
      }
    },
    {
      "id": "enigh-a004",
      "name": "Tortilla de maíz (de todo tipo y color)",
      "category": "cereales",
      "unit": "kg",
      "basketIds": [
        "canasta-alimentaria"
      ],
      "gramsPerPersonMonth": {
        "rural": 6624,
        "urbano": 4197.6
      }
    }
  ],
  "productSeries": [
    {
      "productId": "enigh-a001",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 12.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 12.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 12.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 12.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 12.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 12.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 12.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 12.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 12.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 12.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 11.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 11.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a004",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 22.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 22.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 22.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 23.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 23.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 23.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 23.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 23.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 23.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 23.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 23.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a009",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 50.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 50.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 50.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 50.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 50.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 50.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 51.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 50.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 51.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 50.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 51.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 51.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a010",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 97.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 97.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 97.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 98.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 98.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 98.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 98.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 99.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 99.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 100.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 101.08,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 101.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a012",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 50.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 50.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 51.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 51.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 51.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 51.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 51.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 52.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 52.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 52.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 52.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 53.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a013",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 76.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 76.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 77.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 77.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 77.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 77.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 78.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 79.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 80.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 80.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 80.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 80.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a019",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 27.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 28.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 27.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 27.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 27.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 27.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 27.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 27.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 27.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 27.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 27.28,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 27.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a025",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 189.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 190.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 192.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 194.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 195,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 195.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 196.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 197.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 196.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 196.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 197.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 197.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a034",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 151.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 151.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 153.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 155.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 155.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 156.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 156.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 157.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 156.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 157.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 157.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 157.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a038",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 125.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 125.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 126.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 126.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 126.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 127.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 127.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 125.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 124.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 123.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 123.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 123.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a042",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 119.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 119.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 119.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 119.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 119.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 120.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 121.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 119.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 117.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 117.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 117.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 116.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a048",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 157.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 157.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 157.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 157.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 159.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 159.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 157.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 155.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 154.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 154.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 153.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a055",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 79.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 79.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 79.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 79.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 80.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 80.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 81.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 81.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 81.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 81.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 82.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 82.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a057",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 75.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 72.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 72.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 71.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 71.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 70.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 69.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 69.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 71.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 69.28,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 70.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 70.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a058",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 115.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 110.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 109.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 108.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 108,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 106.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 106.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 104.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 107.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 105.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 106.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 106.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a059",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 86.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 82.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 82.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 81.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 81.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 80.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 80.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 78.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 81.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 79.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 80.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 80.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a062",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 106.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 107.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 107.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 108.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 108.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 108.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 109.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 109.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 109.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 109.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 110.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 110.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a066",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 70.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 70.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 71.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 70.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 70.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 70.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 70.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 70.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 70.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 70.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 69.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 69.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a075",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 25.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 25.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 25.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 25.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 25.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 26.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 26.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 26.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 26.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 26.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 26.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 26.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a085",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 130.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 131.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 131.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 131.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 131.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 131.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 132.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 132.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 133.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 133.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 133.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 134.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a087",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 145.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 145.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 145.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 145.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 146.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 146.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 147.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 147.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 148.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 148.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 149.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 150.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a091",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 60.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 60.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 60.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 60.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 59.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 60.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 60.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 60.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 60.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 60.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 60.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 61.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a093",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 63.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 62.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 61.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 59.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 60.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 57.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 53.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 52.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 51.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 49.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 46.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 43.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a095",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 43.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 43.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 43.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 43.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 43.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 43.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 44.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 44.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 44.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 44.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 44.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 45.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a102",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 31.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 31.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 29.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 26.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 25.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 25.28,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 25.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 31.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 35.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 40.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 45.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 49.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a112",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 26.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 27.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 29.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 32.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 33.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 32.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 29.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 27.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 27.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 29.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 27.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 29.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a115-a118",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 53.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 57.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 60.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 58.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 63.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 67.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 58.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 54.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 67.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 89.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 76.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 58.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a124",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 30.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 27.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 26.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 25.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 29.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 29.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 29.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 36.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 51.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 61.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 60.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 37.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a137",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 35.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 35.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 34.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 34.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 34.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 33.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 33.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 32.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 32.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 31.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 31.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 31.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a154",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 30.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 33.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 33.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 30.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 28.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 29.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 36.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 45.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 53.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 45.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 37.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 34.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a158",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 31.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 31.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 31.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 31.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 31.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 31.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 31.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 32.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 33.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 33.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 34.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 34.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a160",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 22.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 22.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 20.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 18.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 17.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 16.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 16.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 16.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 16.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 16.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 17.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 19.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a166",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 22.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 21.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 20.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 19.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 19.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 18.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 20.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 23.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 24.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 21.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 20.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 20,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a173",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 26.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 25.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 25.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 25.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 25.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 26.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 27.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 27.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 27.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 26.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 27.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 27.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a200",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 148.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 148.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 148.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 148.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 148.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 149.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 150.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 150.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 150.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 150.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 151.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 151.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a215",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 1.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 1.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 1.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 1.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 1.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 1.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 2.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 2.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 2.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 2.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 2.08,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 2.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a220",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 21.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 22.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 22.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 22.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 22.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 22.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 23.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 23.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 24.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 24.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 24.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a243-a245",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 1.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 1.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 1.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 1.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 1.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 1.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 1.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 1.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 1.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 1.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 1.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 1.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a202",
      "kind": "precio",
      "geography": "rural",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 1.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 1.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 1.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 1.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 1.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 1.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 1.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 1.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 1.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 1.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 1.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 1.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a004",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 23.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 23.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 23.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 23.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 23.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 23.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 23.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 23.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 23.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 23.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 23.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a009",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 49.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 50.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 50.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 50.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 50.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 50.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 50.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 50.08,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 50.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 50.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 50.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 50.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a010",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 107.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 108.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 108.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 108.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 109.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 108.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 109.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 109.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 110.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 110.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 112.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 112.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a012",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 52.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 52.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 52.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 52.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 52.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 53.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 53.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 54.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 54.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 54.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 54.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a013",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 89.28,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 89.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 89.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 90.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 90.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 90.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 91.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 92.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 93.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 93.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 93.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 93.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a015",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 90.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 91.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 91.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 92.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 92.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 92.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 92.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 92.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 92.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 92.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 92.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 92.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a019",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 29.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 29.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 29.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 29.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 29.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 29.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 29.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 28.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 28.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 28.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 28.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 28.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a021",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 91.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 91.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 93.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 93.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 93.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 94.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 93.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 92.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 92.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 94.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 94.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a025",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 194.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 195.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 197.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 199.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 199.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 200.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 201.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 202.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 201.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 201.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 202.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 202.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a034",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 155,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 155.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 160.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 160.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 161.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 161.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 161.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 161.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a038",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 128.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 128.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 128.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 128.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 128.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 130.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 130.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 128.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 126.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 126.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 126.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 125.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a042",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 123.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 123.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 123.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 123.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 124.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 125.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 125.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 123.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 122.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 121.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 121.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 120.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a049",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 118.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 119.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 119.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 120.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 121.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 121.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 122.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 122.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 122.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 122.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 122.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 122.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a052",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 130.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 131.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 132.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 131.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 131.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 131.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 131.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 132.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 132.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 132.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 133.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 134.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a057",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 83.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 79.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 79.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 78.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 78.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 77.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 77.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 76.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 78.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 76.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 77.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 77.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a058",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 127.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 122,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 121.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 119.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 119.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 118.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 117.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 116.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 119.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 116.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 118.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 118.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a059",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 87.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 83.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 83.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 82.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 81.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 80.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 80.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 79.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 81.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 79.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 81.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 80.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a066",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 96.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 96.28,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 96.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 96.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 95.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 95.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 96.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 96.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 95.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 94.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 94.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a067",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 141.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 141.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 142.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 141.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 140.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 140.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 141.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 141.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 139.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 141.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 138.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 138.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a068",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 125.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 125.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 125.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 124.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 126.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 126.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 127.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 127.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 126.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 128.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 129.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 129.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a075",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 24.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 24.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 25.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 25.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 25.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 25.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 25.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 25.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 25.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 25.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 26.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 26.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a085",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 131.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 132.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 132.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 132.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 132.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 132.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 133.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 133.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 134.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 134.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 135.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 136.08,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a087",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 148.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 148.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 148.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 149.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 149.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 149.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 150.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 151.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 151.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 152.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 153.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 154.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a091",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 59.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 59.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 59.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 59.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 59.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 60.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 60.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 60.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 60.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 60.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 60.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 60.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a093",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 59.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 59.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 57.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 56.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 56.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 54.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 50.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 49.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 48.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 46.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 44.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 40.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a095",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 43.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 43.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 43.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 43.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 43.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 43.08,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 43.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 43.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 43.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 43.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 44.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 44.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a102",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 30.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 31.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 29.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 26.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 25.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 25.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 25.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 31.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 35.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 40.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 45.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 49.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a112",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 25.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 27.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 29.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 32.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 32.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 32.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 29.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 27.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 26.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 28.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 27.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 29.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a115-a118",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 53.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 57.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 60.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 58.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 64.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 67.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 58.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 54.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 67.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 89.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 76.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 58.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a124",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 30.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 27.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 26.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 25.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 29.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 29.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 29.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 36.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 51.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 61.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 61.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 37.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a137",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 37.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 37.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 36.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 36.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 35.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 35.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 34.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 34.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 33.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 33.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 33.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 32.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a154",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 29.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 32.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 32.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 29.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 27.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 28.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 35.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 44.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 52.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 44.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 36.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 33.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a158",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 34.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 34.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 34.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 34.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 34.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 34.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 34.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 35.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 36.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 37.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 38.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 38.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a160",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 23.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 23.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 21.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 19.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 18.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 17.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 17.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 16.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 17.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 17.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 18.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 20.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a166",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 23.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 22.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 21.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 20.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 19.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 18.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 21.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 23.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 24.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 22.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 21.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 20.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a173",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 26.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 26.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 26.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 26.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 25.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 27.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 28.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 28.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 28.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 27.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 27.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 27.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a200",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 156.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 156.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 157.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 157.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 158.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 159.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 159.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 159.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 159.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 160.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 160.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a215",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 2.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 2.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 2.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 2.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 2.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 2.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 2.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 2.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 2.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 2.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 2.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 2.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a218",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 27.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 27.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 27.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 27.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 27.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 27.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 28.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 29.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 29.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 29.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 29.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 29.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a220",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 21.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 21.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 21.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 21.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 21.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 23.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 23.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 23.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 23.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 23.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 23.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a243-a245",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 1.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 1.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 1.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 1.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 1.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 1.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 1.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 1.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 1.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 1.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 1.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 1.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a202",
      "kind": "precio",
      "geography": "urbano",
      "unit": "MXN_unidad",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 1.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 1.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 1.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 1.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 1.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 1.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 1.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 1.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 1.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 1.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 1.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 1.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a001",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 19.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 19.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 19.08,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 19.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 18.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 18.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 18.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 18.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 18.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 18.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 18.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 18.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a004",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 151.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 152.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 152.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 152.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 152.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 152.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 153.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 153.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 153.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 154.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 155.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 156.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a009",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 12.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 12.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 12.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 12.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 12.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 12.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 12.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 12.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 12.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 12.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 12.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 12.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a010",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 13.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 13.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 13.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 13.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 13.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 13.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 13.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 13.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 13.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 13.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 14.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 14.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a012",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 18.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 18.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 18.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 19.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 19.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 19.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 19.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 19.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 19.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 19.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 19.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 19.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a013",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 63.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 63.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 63.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 64.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 64.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 64.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 65.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 65.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 66.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 66.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 66.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 66.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a019",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 12.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 12.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 12.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 12.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 12.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 12.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 12.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 12.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 12.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 12.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 12.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 12.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a025",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 106.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 107.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 108.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 109.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 109.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 110.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 110.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 111.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 110.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 110.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 111.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 111.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a034",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 62.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 62.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 63.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 64.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 64.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 64.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 64.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 65.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 64.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 65.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 65.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 65.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a038",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 11.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 11.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 12.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 12.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 12.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 12.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 11.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 11.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 11.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 11.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 11.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a042",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 10.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 10.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 10.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 10.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 10.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 10.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 10.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 10.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 9.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 9.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 9.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 9.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a048",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 9.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 9.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 9.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 9.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 9.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 9.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 9.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 9.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 9.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 9.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 9.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 9.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a055",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 8.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 8.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 8.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 8.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 8.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 8.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 8.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 8.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 8.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 8.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 8.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 8.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a057",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 64.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 61.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 61.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 60.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 60.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 59.47,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 59.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 58.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 60.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 58.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 59.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 59.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a058",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 9.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 9.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 9.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 9.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 9.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 9.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 9.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 8.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 9.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 8.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 9.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 9.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a059",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 85.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 81.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 81.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 80.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 80.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 79.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 78.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 77.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 80.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 78.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 79.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 79.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a062",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 10.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 10.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 10.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 10.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 10.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 10.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 10.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 10.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 10.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 10.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 10.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 10.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a066",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 13.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 13.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 13.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 13.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 13.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 13.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 13.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 13.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 13.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 13.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 13.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 13.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a075",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 92.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 92.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 93.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 93.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 93.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 95.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 96.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 96.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 96.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 96.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 97.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 96.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a085",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 28.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 28.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 28.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 29.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 29.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 29.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 29.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 29.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 29.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 29.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 29.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 29.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a087",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 8.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 8.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 8.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 8.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 8.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 8.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 8.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 8.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 8.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 8.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 9.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 9.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a091",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 8.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 8.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 8.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 8.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 8.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 8.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 8.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 8.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 8.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 8.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 8.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 8.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a093",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 81.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 81.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 79.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 77.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 77.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 74.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 69.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 67.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 65.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 63.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 60.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 56.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a095",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 24.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 24.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 24.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 24.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 24.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 24.08,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 24.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 24.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 24.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 24.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 24.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 24.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a102",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 30.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 31.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 28.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 26.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 25.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 25.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 25.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 30.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 35.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 39.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 44.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 49.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a112",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 31.28,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 33.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 35.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 38.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 39.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 38.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 35.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 32.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 32.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 34.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 32.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 35.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a115-a118",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 21.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 23.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 24.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 23.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 25.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 27.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 23.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 22.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 27.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 36.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 30.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 23.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a124",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 62.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 55.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 54.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 52.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 60.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 60.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 60.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 74.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 105.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 125.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 124.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 75.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a137",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 68.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 68.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 67.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 66.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 66.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 65.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 64.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 63.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 62.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 61.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 60.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 60.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a154",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 20.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 22.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 22.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 20.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 19.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 20.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 24.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 30.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 36.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 31.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 25.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 23.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a158",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 24.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 24.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 24.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 24.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 24.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 24.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 24.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 25.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 26.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 26.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 27.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 27.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a160",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 16.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 16.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 15.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 13.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 13.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 12.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 12.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 12.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 12.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 12.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 13.28,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 14.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a166",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 22.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 21.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 20.28,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 19.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 18.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 18.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 20.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 22.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 23.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 21.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 20.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 19.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a173",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 15.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 15.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 15.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 15.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 15.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 15.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 16.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 16.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 16.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 16.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 16.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 16.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a200",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 26.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 26.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 26.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 26.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 26.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 27.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 27.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 27.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 27.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 27.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 27.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 27.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a215",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 23.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 23.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 23.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 23.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 23.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 23.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 24.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 24.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 24.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 24.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 24.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 24.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a220",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 81.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 81.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 81.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 82.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 82.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 83.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 87.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 88.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 88.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 89.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 89.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 89.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a243-a245",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 408.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 409.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 411.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 412.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 414.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 416.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 420.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 423.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 425.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 427.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 428.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 430.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a202",
      "kind": "valor-mensual",
      "geography": "rural",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 73.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 73.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 74.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 74.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 74.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 74.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 75.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 75.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 75.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 75.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 75.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 76.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a004",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 98.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 98.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 98.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 98.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 98.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 98.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 98.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 99.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 99.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 99.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 100.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 100.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a009",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 8.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 8.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 8.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 8.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 8.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 8.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 8.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 8.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 8.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 8.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 8.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 8.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a010",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 13.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 13.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 13.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 13.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 13.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 13.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 13.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 13.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 13.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 13.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 13.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 13.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a012",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 41.08,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 41.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 41.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 41.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 41.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 41.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 42.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 42.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 42.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 42.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 42.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 42.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a013",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 92.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 92.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 93.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 93.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 93.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 95.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 96.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 96.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 96.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 97.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 97.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a015",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 18.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 18.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 18.73,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 18.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 18.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 18.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 18.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 18.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 18.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 18.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 18.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 18.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a019",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 10.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 10.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 10.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 10.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 10.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 9.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 10.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 9.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 9.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 9.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 9.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 9.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a021",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 11.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 11.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 11.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 11.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 11.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 11.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 11.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 11.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 11.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 12.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 12.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a025",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 124.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 125.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 126.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 127.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 127.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 128.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 129.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 129.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 129.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 129.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 129.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 129.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a034",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 65.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 65.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 66.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 67.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 67.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 67.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 67.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 68.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 67.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 68.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 68.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 68.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a038",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 10.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 10.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 10.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 10.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 10.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 10.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 11.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 10.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 10.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 10.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 10.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 10.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a042",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 76.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 76.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 76.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 76.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 76.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 77.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 77.19,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 76.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 75.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 74.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 74.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 74.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a049",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 14.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 14.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 14.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 15.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 15.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 15.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 15.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 15.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 15.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 15.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 15.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 15.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a052",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 13.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 13.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 13.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 13.71,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 13.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 13.78,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 13.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 13.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 13.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 13.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 13.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 14.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a057",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 50.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 48.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 48.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 47.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 47.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 46.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 46.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 45.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 47.28,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 46.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 46.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 46.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a058",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 31.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 29.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 29.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 29.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 29.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 28.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 28.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 28.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 29.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 28.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 28.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 28.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a059",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 34.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 33.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 32.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 32.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 32.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 32.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 31.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 31.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 32.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 31.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 32.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 32.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a066",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 7.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 7.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 7.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 7.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 7.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 7.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 7.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 7.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 7.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 7.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 7.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 7.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a067",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 11.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 11.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 11.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 11.02,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 10.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 10.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 11.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 11.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 10.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 11.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 10.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 10.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a068",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 11.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 11.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 11.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 11.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 11.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 11.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 11.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 11.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 11.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 11.68,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 11.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 11.79,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a075",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 153.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 153.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 154.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 154.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 156.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 158.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 159.92,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 160.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 160.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 160.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 161.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 160.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a085",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 19.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 19.95,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 19.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 20.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 20.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 20.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 20.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 20.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 20.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 20.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 20.37,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 20.53,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a087",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 13.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 13.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 13.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 13.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 13.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 13.98,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 14.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 14.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 14.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 14.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 14.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 14.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a091",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 13.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 13.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 13.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 13.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 13.36,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 13.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 13.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 13.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 13.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 13.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 13.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 13.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a093",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 66.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 65.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 64.4,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 62.97,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 63.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 60.45,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 56.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 55.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 53.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 51.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 49.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 45.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a095",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 14.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 14.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 14.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 14.04,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 14.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 14.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 14.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 14.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 14.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 14.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 14.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 14.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a102",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 41.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 42.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 39.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 36.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 35.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 34.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 34.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 42.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 48.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 54.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 61.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 66.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a112",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 33.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 35.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 38.11,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 41.1,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 42.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 41.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 38.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 34.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 34.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 37.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 34.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 37.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a115-a118",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 18.66,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 20.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 21.27,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 20.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 22.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 23.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 20.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 19.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 23.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 31.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 26.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 20.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a124",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 58.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 51.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 51.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 49.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 56.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 56.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 56.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 69.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 98.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 117.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 116.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 71.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a137",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 57.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 57.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 56.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 55.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 55.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 54.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 53.6,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 52.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 51.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 51.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 50.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 50.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a154",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 23.55,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 25.5,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 25.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 23.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 21.59,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 22.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 27.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 34.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 41.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 35.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 28.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 26.13,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a158",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 31.42,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 31.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 31.2,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 31.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 31.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 31.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 31.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 32.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 33.34,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 33.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 34.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 34.64,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a160",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 20.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 20.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 18.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 16.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 16.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 15.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 15.09,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 14.75,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 14.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 15.31,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 16.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 17.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a166",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 24.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 23.18,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 22.12,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 21.32,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 20.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 19.83,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 22.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 24.82,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 25.86,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 23.41,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 22.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 21.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a173",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 9.58,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 9.39,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 9.3,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 9.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 9.24,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 9.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 9.99,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 10.01,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 9.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 9.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 9.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 9.93,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a200",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 40.49,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 40.51,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 40.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 40.62,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 40.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 40.8,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 41.06,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 41.08,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 41.28,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 41.28,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 41.43,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 41.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a215",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 36.21,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 36.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 36.54,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 36.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 36.88,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 36.96,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 37.85,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 38.23,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 38.26,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 38.46,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 38.67,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 38.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a218",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 46.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 47.08,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 47.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 46.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 47.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 47.57,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 49.22,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 49.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 49.89,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 50.15,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 50.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 50.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a220",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 102.61,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 103.07,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 103.33,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 103.63,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 103.91,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 104.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 110.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 111.65,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 112.16,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 112.29,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 112.69,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 112.87,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a243-a245",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 748.9,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 751.72,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 754.48,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 756.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 760.81,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 764.17,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 771.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 776.7,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 781.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 784.03,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 782.94,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 790.74,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    },
    {
      "productId": "enigh-a202",
      "kind": "valor-mensual",
      "geography": "urbano",
      "unit": "MXN_persona_mes",
      "sourceId": "inegi-lp-boletin",
      "points": [
        {
          "period": "2025-07",
          "value": 133.56,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 133.84,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 134.25,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 134.38,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 134.77,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 135.14,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 136.05,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 137,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 137.44,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 137.35,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 137.52,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 138.76,
          "sourceId": "inegi-lp-boletin",
          "confidence": "high"
        }
      ]
    }
  ],
  "places": [
    {
      "id": "nacional",
      "name": "Nacional",
      "kind": "nacional",
      "stateCode": null
    },
    {
      "id": "ent-01",
      "name": "Aguascalientes",
      "kind": "entidad",
      "stateCode": "01"
    },
    {
      "id": "ent-02",
      "name": "Baja California",
      "kind": "entidad",
      "stateCode": "02"
    },
    {
      "id": "ent-03",
      "name": "Baja California Sur",
      "kind": "entidad",
      "stateCode": "03"
    },
    {
      "id": "ent-04",
      "name": "Campeche",
      "kind": "entidad",
      "stateCode": "04"
    },
    {
      "id": "ent-05",
      "name": "Coahuila de Zaragoza",
      "kind": "entidad",
      "stateCode": "05"
    },
    {
      "id": "ent-06",
      "name": "Colima",
      "kind": "entidad",
      "stateCode": "06"
    },
    {
      "id": "ent-07",
      "name": "Chiapas",
      "kind": "entidad",
      "stateCode": "07"
    },
    {
      "id": "ent-08",
      "name": "Chihuahua",
      "kind": "entidad",
      "stateCode": "08"
    },
    {
      "id": "ent-09",
      "name": "Ciudad de México",
      "kind": "entidad",
      "stateCode": "09"
    },
    {
      "id": "ent-10",
      "name": "Durango",
      "kind": "entidad",
      "stateCode": "10"
    },
    {
      "id": "ent-11",
      "name": "Guanajuato",
      "kind": "entidad",
      "stateCode": "11"
    },
    {
      "id": "ent-12",
      "name": "Guerrero",
      "kind": "entidad",
      "stateCode": "12"
    },
    {
      "id": "ent-13",
      "name": "Hidalgo",
      "kind": "entidad",
      "stateCode": "13"
    },
    {
      "id": "ent-14",
      "name": "Jalisco",
      "kind": "entidad",
      "stateCode": "14"
    },
    {
      "id": "ent-15",
      "name": "México",
      "kind": "entidad",
      "stateCode": "15"
    },
    {
      "id": "ent-16",
      "name": "Michoacán",
      "kind": "entidad",
      "stateCode": "16"
    },
    {
      "id": "ent-17",
      "name": "Morelos",
      "kind": "entidad",
      "stateCode": "17"
    },
    {
      "id": "ent-18",
      "name": "Nayarit",
      "kind": "entidad",
      "stateCode": "18"
    },
    {
      "id": "ent-19",
      "name": "Nuevo León",
      "kind": "entidad",
      "stateCode": "19"
    },
    {
      "id": "ent-20",
      "name": "Oaxaca",
      "kind": "entidad",
      "stateCode": "20"
    },
    {
      "id": "ent-21",
      "name": "Puebla",
      "kind": "entidad",
      "stateCode": "21"
    },
    {
      "id": "ent-22",
      "name": "Querétaro",
      "kind": "entidad",
      "stateCode": "22"
    },
    {
      "id": "ent-23",
      "name": "Quintana Roo",
      "kind": "entidad",
      "stateCode": "23"
    },
    {
      "id": "ent-24",
      "name": "San Luis Potosí",
      "kind": "entidad",
      "stateCode": "24"
    },
    {
      "id": "ent-25",
      "name": "Sinaloa",
      "kind": "entidad",
      "stateCode": "25"
    },
    {
      "id": "ent-26",
      "name": "Sonora",
      "kind": "entidad",
      "stateCode": "26"
    },
    {
      "id": "ent-27",
      "name": "Tabasco",
      "kind": "entidad",
      "stateCode": "27"
    },
    {
      "id": "ent-28",
      "name": "Tamaulipas",
      "kind": "entidad",
      "stateCode": "28"
    },
    {
      "id": "ent-29",
      "name": "Tlaxcala",
      "kind": "entidad",
      "stateCode": "29"
    },
    {
      "id": "ent-30",
      "name": "Veracruz",
      "kind": "entidad",
      "stateCode": "30"
    },
    {
      "id": "ent-31",
      "name": "Yucatán",
      "kind": "entidad",
      "stateCode": "31"
    },
    {
      "id": "ent-32",
      "name": "Zacatecas",
      "kind": "entidad",
      "stateCode": "32"
    },
    {
      "id": "ciu-zmcm",
      "name": "Zona Metropolitana de la Ciudad de México",
      "kind": "ciudad",
      "stateCode": null
    },
    {
      "id": "ciu-acapulco",
      "name": "Acapulco",
      "kind": "ciudad",
      "stateCode": "12",
      "stateName": "Guerrero"
    },
    {
      "id": "ciu-aguascalientes",
      "name": "Aguascalientes",
      "kind": "ciudad",
      "stateCode": "01",
      "stateName": "Aguascalientes"
    },
    {
      "id": "ciu-atlacomulco",
      "name": "Atlacomulco",
      "kind": "ciudad",
      "stateCode": "15",
      "stateName": "México"
    },
    {
      "id": "ciu-campeche",
      "name": "Campeche",
      "kind": "ciudad",
      "stateCode": "04",
      "stateName": "Campeche"
    },
    {
      "id": "ciu-cancun",
      "name": "Cancún",
      "kind": "ciudad",
      "stateCode": "23",
      "stateName": "Quintana Roo"
    },
    {
      "id": "ciu-cd-acuna",
      "name": "Cd. Acuña",
      "kind": "ciudad",
      "stateCode": "05",
      "stateName": "Coahuila de Zaragoza"
    },
    {
      "id": "ciu-cd-jimenez",
      "name": "Cd. Jiménez",
      "kind": "ciudad",
      "stateCode": "08",
      "stateName": "Chihuahua"
    },
    {
      "id": "ciu-cd-juarez",
      "name": "Cd. Juárez",
      "kind": "ciudad",
      "stateCode": "08",
      "stateName": "Chihuahua"
    },
    {
      "id": "ciu-chetumal",
      "name": "Chetumal",
      "kind": "ciudad",
      "stateCode": "23",
      "stateName": "Quintana Roo"
    },
    {
      "id": "ciu-chihuahua",
      "name": "Chihuahua",
      "kind": "ciudad",
      "stateCode": "08",
      "stateName": "Chihuahua"
    },
    {
      "id": "ciu-coatzacoalcos",
      "name": "Coatzacoalcos",
      "kind": "ciudad",
      "stateCode": "30",
      "stateName": "Veracruz"
    },
    {
      "id": "ciu-colima",
      "name": "Colima",
      "kind": "ciudad",
      "stateCode": "06",
      "stateName": "Colima"
    },
    {
      "id": "ciu-cordoba",
      "name": "Córdoba",
      "kind": "ciudad",
      "stateCode": "30",
      "stateName": "Veracruz"
    },
    {
      "id": "ciu-cortazar",
      "name": "Cortazar",
      "kind": "ciudad",
      "stateCode": "11",
      "stateName": "Guanajuato"
    },
    {
      "id": "ciu-cuernavaca",
      "name": "Cuernavaca",
      "kind": "ciudad",
      "stateCode": "17",
      "stateName": "Morelos"
    },
    {
      "id": "ciu-culiacan",
      "name": "Culiacán",
      "kind": "ciudad",
      "stateCode": "25",
      "stateName": "Sinaloa"
    },
    {
      "id": "ciu-durango",
      "name": "Durango",
      "kind": "ciudad",
      "stateCode": "10",
      "stateName": "Durango"
    },
    {
      "id": "ciu-esperanza",
      "name": "Esperanza",
      "kind": "ciudad",
      "stateCode": "26",
      "stateName": "Sonora"
    },
    {
      "id": "ciu-fresnillo",
      "name": "Fresnillo",
      "kind": "ciudad",
      "stateCode": "32",
      "stateName": "Zacatecas"
    },
    {
      "id": "ciu-guadalajara",
      "name": "Guadalajara",
      "kind": "ciudad",
      "stateCode": "14",
      "stateName": "Jalisco"
    },
    {
      "id": "ciu-hermosillo",
      "name": "Hermosillo",
      "kind": "ciudad",
      "stateCode": "26",
      "stateName": "Sonora"
    },
    {
      "id": "ciu-huatabampo",
      "name": "Huatabampo",
      "kind": "ciudad",
      "stateCode": "26",
      "stateName": "Sonora"
    },
    {
      "id": "ciu-iguala",
      "name": "Iguala",
      "kind": "ciudad",
      "stateCode": "12",
      "stateName": "Guerrero"
    },
    {
      "id": "ciu-izucar-de-matamoros",
      "name": "Izúcar de Matamoros",
      "kind": "ciudad",
      "stateCode": "21",
      "stateName": "Puebla"
    },
    {
      "id": "ciu-jacona",
      "name": "Jacona",
      "kind": "ciudad",
      "stateCode": "16",
      "stateName": "Michoacán"
    },
    {
      "id": "ciu-la-paz",
      "name": "La Paz",
      "kind": "ciudad",
      "stateCode": "03",
      "stateName": "Baja California Sur"
    },
    {
      "id": "ciu-leon",
      "name": "León",
      "kind": "ciudad",
      "stateCode": "11",
      "stateName": "Guanajuato"
    },
    {
      "id": "ciu-matamoros",
      "name": "Matamoros",
      "kind": "ciudad",
      "stateCode": "28",
      "stateName": "Tamaulipas"
    },
    {
      "id": "ciu-merida",
      "name": "Mérida",
      "kind": "ciudad",
      "stateCode": "31",
      "stateName": "Yucatán"
    },
    {
      "id": "ciu-mexicali",
      "name": "Mexicali",
      "kind": "ciudad",
      "stateCode": "02",
      "stateName": "Baja California"
    },
    {
      "id": "ciu-monclova",
      "name": "Monclova",
      "kind": "ciudad",
      "stateCode": "05",
      "stateName": "Coahuila de Zaragoza"
    },
    {
      "id": "ciu-monterrey",
      "name": "Monterrey",
      "kind": "ciudad",
      "stateCode": "19",
      "stateName": "Nuevo León"
    },
    {
      "id": "ciu-morelia",
      "name": "Morelia",
      "kind": "ciudad",
      "stateCode": "16",
      "stateName": "Michoacán"
    },
    {
      "id": "ciu-oaxaca",
      "name": "Oaxaca",
      "kind": "ciudad",
      "stateCode": "20",
      "stateName": "Oaxaca"
    },
    {
      "id": "ciu-pachuca",
      "name": "Pachuca",
      "kind": "ciudad",
      "stateCode": "13",
      "stateName": "Hidalgo"
    },
    {
      "id": "ciu-puebla",
      "name": "Puebla",
      "kind": "ciudad",
      "stateCode": "21",
      "stateName": "Puebla"
    },
    {
      "id": "ciu-queretaro",
      "name": "Querétaro",
      "kind": "ciudad",
      "stateCode": "22",
      "stateName": "Querétaro"
    },
    {
      "id": "ciu-saltillo",
      "name": "Saltillo",
      "kind": "ciudad",
      "stateCode": "05",
      "stateName": "Coahuila de Zaragoza"
    },
    {
      "id": "ciu-san-andres-tuxtla",
      "name": "San Andrés Tuxtla",
      "kind": "ciudad",
      "stateCode": "30",
      "stateName": "Veracruz"
    },
    {
      "id": "ciu-san-luis-potosi",
      "name": "San Luis Potosí",
      "kind": "ciudad",
      "stateCode": "24",
      "stateName": "San Luis Potosí"
    },
    {
      "id": "ciu-tampico",
      "name": "Tampico",
      "kind": "ciudad",
      "stateCode": "28",
      "stateName": "Tamaulipas"
    },
    {
      "id": "ciu-tapachula",
      "name": "Tapachula",
      "kind": "ciudad",
      "stateCode": "07",
      "stateName": "Chiapas"
    },
    {
      "id": "ciu-tehuantepec",
      "name": "Tehuantepec",
      "kind": "ciudad",
      "stateCode": "20",
      "stateName": "Oaxaca"
    },
    {
      "id": "ciu-tepatitlan",
      "name": "Tepatitlán",
      "kind": "ciudad",
      "stateCode": "14",
      "stateName": "Jalisco"
    },
    {
      "id": "ciu-tepic",
      "name": "Tepic",
      "kind": "ciudad",
      "stateCode": "18",
      "stateName": "Nayarit"
    },
    {
      "id": "ciu-tijuana",
      "name": "Tijuana",
      "kind": "ciudad",
      "stateCode": "02",
      "stateName": "Baja California"
    },
    {
      "id": "ciu-tlaxcala",
      "name": "Tlaxcala",
      "kind": "ciudad",
      "stateCode": "29",
      "stateName": "Tlaxcala"
    },
    {
      "id": "ciu-toluca",
      "name": "Toluca",
      "kind": "ciudad",
      "stateCode": "15",
      "stateName": "México"
    },
    {
      "id": "ciu-torreon",
      "name": "Torreón",
      "kind": "ciudad",
      "stateCode": "05",
      "stateName": "Coahuila de Zaragoza"
    },
    {
      "id": "ciu-tulancingo",
      "name": "Tulancingo",
      "kind": "ciudad",
      "stateCode": "13",
      "stateName": "Hidalgo"
    },
    {
      "id": "ciu-tuxtla-gutierrez",
      "name": "Tuxtla Gutiérrez",
      "kind": "ciudad",
      "stateCode": "07",
      "stateName": "Chiapas"
    },
    {
      "id": "ciu-veracruz",
      "name": "Veracruz",
      "kind": "ciudad",
      "stateCode": "30",
      "stateName": "Veracruz"
    },
    {
      "id": "ciu-villahermosa",
      "name": "Villahermosa",
      "kind": "ciudad",
      "stateCode": "27",
      "stateName": "Tabasco"
    },
    {
      "id": "ciu-zacatecas",
      "name": "Zacatecas",
      "kind": "ciudad",
      "stateCode": "32",
      "stateName": "Zacatecas"
    }
  ],
  "placeSeries": [
    {
      "placeId": "nacional",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.837,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.759,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.957,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.887,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.305,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.03,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.484,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.309,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.766,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.113,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.298,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.199,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.791,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.052,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.311,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.133,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.018,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.468,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.24,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.725,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.087,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.555,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.806,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.551,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.488,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.261,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.221,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.147,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.549,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.927,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.456,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.791,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.9,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.401,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.706,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.472,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 129.083,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 130.608,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 131.947,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 133.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 135.506,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 137.231,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 138.916,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 139.602,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 139.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 141.051,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 142.455,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 143.06,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.237,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 143.745,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 144.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 144.37,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 145.645,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 146.666,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.344,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 146.745,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 147.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 149.583,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 152.385,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 150.34,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 150.369,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 151.857,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 152.445,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 153.393,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 156.234,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 155.259,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 154.357,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 155.694,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.332,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.201,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 155.75,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 156.639,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.128,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 160.43,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 160.775,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 161.291,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 160.956,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 161.115,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 160.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 161.756,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 161.947,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 163.117,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 164.439,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 167.396,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 168.115,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 167.329,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 164.876,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-01",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.095,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.882,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.45,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.307,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.44,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.716,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.418,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.294,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.187,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.998,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.754,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.413,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.124,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.738,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.399,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.879,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 111.092,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 112.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.717,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 113.496,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 114.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 114.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.818,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.54,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.674,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.827,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.93,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.963,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.188,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 123.014,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.633,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.074,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.694,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 128.554,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.229,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 134.65,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 136.695,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 139.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 140.96,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.651,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 143.322,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 145.888,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 145.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.08,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 146.613,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 147.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 148.784,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 149.641,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.94,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 149.365,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 150.541,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 152.737,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 154.098,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 151.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 152.505,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 154.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 154.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 155.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 158.978,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 158.644,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 157.746,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 157.304,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 157.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 159.273,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 160.004,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 158.912,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 160.695,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 163.082,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 164.345,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 165.018,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 166.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 167.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 166.403,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 166.523,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 166.558,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 168.923,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 169.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 170.844,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 173.561,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 173.132,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 170.407,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 169.019,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-02",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.67,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.83,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 102.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.584,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.749,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.208,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.021,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.793,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.496,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.759,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.13,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.07,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.174,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.678,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.924,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.328,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.459,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.588,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.301,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.762,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.921,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.51,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.414,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.866,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.39,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.63,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 125.235,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.108,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 129.063,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 130.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.961,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 131.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.353,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 134.603,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 136.744,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.847,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 142.029,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 143.23,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 143.153,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 143.375,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 143.635,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.602,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 143.675,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 144.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 144.317,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.752,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 145.322,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 145.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 146.405,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 147.582,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 150.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 150.915,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 149.844,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 149.93,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 149.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 149.161,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 151.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 151.442,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 152.303,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.412,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 154.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 155.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.685,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 156.475,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 157.197,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 159.197,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 160.252,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 160.159,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 160.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 159.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 161.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 161.427,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 160.499,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 161.858,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 163.144,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 165.099,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 166.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 165.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.937,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-03",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.04,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 102.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 102.114,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.681,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.028,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.626,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.376,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.516,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.151,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.83,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.405,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.692,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.417,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.937,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.178,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.641,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.602,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.492,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.828,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.044,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.125,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.2,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 117.869,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.174,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.659,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.16,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.361,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.12,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.565,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.059,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 127.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 130.15,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.094,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.627,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.83,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 140.618,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 141.375,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 141.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.093,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 142.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 143.111,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.128,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.267,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 145.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 145.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.225,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 147.972,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.607,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 148.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 148.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 148.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 148.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 150.2,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 151.361,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 151.878,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.465,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 153.987,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 154.114,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 153.751,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.412,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 156.407,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 155.099,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 155.475,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 156.124,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.476,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 158.059,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 156.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 157.291,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 158.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 158.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 159.897,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 162.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 161.437,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 160.053,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-04",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.736,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.067,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.811,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.481,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.13,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.531,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.373,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.099,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 105.078,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.901,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.391,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.252,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.781,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.003,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.294,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.542,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.854,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.476,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.237,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.842,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.751,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.327,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.552,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.33,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.406,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 122.969,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.918,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.217,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 130.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 133.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 134.586,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 135.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 137.12,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.418,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 140.357,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 142.061,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.555,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 143.716,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 146.527,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 149.161,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 149.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 148.819,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 149.129,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 150.356,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 151.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 152.488,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 153.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 154.363,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 154.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 154.076,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 155.779,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 157.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 156.501,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 157.539,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 158.327,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 158.766,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 160.26,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 162.263,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 161.803,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 162.24,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 163.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 163.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 163.634,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 163.031,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 162.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 163.229,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 163.906,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 166.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 167.915,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 168.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 167.917,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 168.284,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 168.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 168.572,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 168.167,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 171.373,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 172.754,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 174.404,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 175.455,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 175.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 173.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-05",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.871,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.011,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.827,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.146,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.909,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.68,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.773,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.313,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.479,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.333,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.863,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.876,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.303,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.138,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.877,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.366,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.828,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.952,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.557,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.903,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.755,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.682,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.914,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.446,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.432,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.134,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.158,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.467,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.04,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.474,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 123.868,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 125.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.746,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.869,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 129.519,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 131.413,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 132.812,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 134.908,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 141.131,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.378,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 140.996,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 142.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 142.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 143.048,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 143.513,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 143.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 144.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 145.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 146.151,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.019,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 146.72,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 146.75,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 148.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 150.112,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 149.605,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 150.161,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 151.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 151.971,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 152.258,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 154.621,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 154.107,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 154.108,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 155.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.157,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 155.903,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.357,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 156.479,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 157.784,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.228,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 159.811,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 159.862,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 160,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 160.905,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 161.573,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 161.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 161.999,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 162.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 164.401,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 165.426,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 167.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 168.503,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 167.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 166.178,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-06",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.637,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.898,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.49,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.145,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.224,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.442,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.438,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.554,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.267,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.368,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.912,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.811,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.839,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.376,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.18,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.388,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.957,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.411,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.891,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.504,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.925,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.445,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.852,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.941,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.488,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.229,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.823,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.058,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.009,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 128.145,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.423,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.468,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 138.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 140.195,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 140.658,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 141.532,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 142.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 143.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 146.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.925,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 147.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 147.437,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 149.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 151.693,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 150.489,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 150.394,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 151.438,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 152.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 152.627,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 155.694,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 155.355,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 154.261,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 156.111,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 157.274,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.867,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.893,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 157.018,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 157.295,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.508,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 160.483,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 161.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 162.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 162.477,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 163.777,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 163.601,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 164.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 164.506,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 165.374,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 166.791,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.799,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 171.192,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 171.142,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 169.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-07",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.52,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.324,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.555,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.609,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.774,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 103.542,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 103.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 104.833,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.41,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 106.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 105.862,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 107.313,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 108.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 109.093,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.454,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.34,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.107,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 110.863,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 111.81,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.432,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.08,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 111.811,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 112.605,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.088,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.196,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.572,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.591,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.529,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 120.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 122.604,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 123.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.086,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.298,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.75,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 131.25,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 133.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 135.481,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 137.135,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 138.681,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 138.684,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 139.02,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 139.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 141.895,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 142.557,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 144.463,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 144.372,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 145.592,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 146.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 147.68,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 148.546,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 148.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 149.426,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 151.609,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 154.348,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 152.614,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 152.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 153.323,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 152.95,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 153.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 156.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 156.341,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 154.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 154.582,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 155.902,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.051,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 155.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 154.747,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 154.725,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.399,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.75,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 161.047,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 162.35,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 161.466,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 159.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.467,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 160.19,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 160.186,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 161.258,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 162.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 165.98,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 166.103,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 165.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.609,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-08",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.723,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.064,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.076,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.482,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.965,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.077,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.505,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.89,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.445,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.312,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.111,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.825,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.322,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.776,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.824,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.847,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.19,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.853,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.888,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 113.067,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 114.043,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.551,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 113.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 115.188,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 114.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 115.539,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 116.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 115.163,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.055,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.355,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.791,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 117.162,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.293,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.387,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.416,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.784,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 123.986,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 125.427,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.093,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 128.011,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.087,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.125,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 131.712,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.565,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.018,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.307,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 141.297,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.382,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 142.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 142.255,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 142.853,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.269,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 143.51,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 144.029,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 143.284,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.45,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 145.319,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 146.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 147.089,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 147.432,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 148.524,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 150.423,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 149.907,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 150.03,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 151.393,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 151.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 151.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 153.221,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.948,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 154.382,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 155.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.528,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.868,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 157.063,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 155.759,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 156.759,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.07,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 159.677,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 159.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 160.984,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 160.478,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 161.152,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 162.142,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 162.047,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 162.843,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 163.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 164.152,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 165.236,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 167.745,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 166.917,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 164.962,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-09",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.757,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.62,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.635,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 105.112,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.946,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.152,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.683,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.446,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.644,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.153,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.094,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.261,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.416,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.786,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.322,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.227,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.692,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.385,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.266,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.252,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.986,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.963,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.964,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.36,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.332,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.072,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.408,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.609,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.039,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.366,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.971,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 128.192,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.707,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.853,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 133.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 134.346,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.264,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.086,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 137.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 140.469,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 141.154,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.995,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 141.881,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.007,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 142.499,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 143.787,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.616,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 143.444,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 144.62,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 147.784,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 150.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 147.669,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 150.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 150.679,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 152.785,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 155.66,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.869,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 152.687,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.846,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.877,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 153.96,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 153.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 153.693,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 154.83,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 156.469,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 159.257,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 159.428,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 159.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 158.662,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 159.104,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 158.569,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.676,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 159.755,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 160.797,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 161.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 165.375,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 163.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 161.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-10",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.177,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.934,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.014,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.443,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.514,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.11,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.121,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.842,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.993,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.376,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.969,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.007,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.801,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.221,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.872,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.02,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.069,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.155,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.637,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.434,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.176,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.013,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.793,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.328,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.866,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.881,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.906,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.861,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.311,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.496,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.555,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.075,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.168,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.18,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.784,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.321,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 142.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 144.233,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 145.313,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.912,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.806,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.803,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 147.614,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 147.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 148.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 148.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 151.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 151.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 153.609,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 153.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 154.527,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 152.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 151.775,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 154.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 154.885,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 157.92,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 157.79,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 157.937,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 158.931,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 159.435,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 159.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 158.76,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 159.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 159.89,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 160.725,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 161.791,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 161.9,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 164.296,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 165.419,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 165.096,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 164.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 164.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 165.387,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 164.923,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 166.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 169.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 171.021,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 170.243,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 167.724,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-11",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.179,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.886,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.519,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.793,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.298,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.243,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.984,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.415,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.501,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.391,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.148,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.196,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.988,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.072,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.286,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.168,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.04,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.717,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.49,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.774,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.79,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.099,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.157,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.465,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.388,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.757,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.345,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.232,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.18,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.444,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.676,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.868,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 126.771,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 128.316,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.957,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.457,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 134.258,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.915,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 138.308,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.752,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 140.332,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 141,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 141.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 142.691,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 142.636,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 143.04,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 143.771,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 145.298,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 146.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.497,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 146.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 147.012,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 149.313,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 151.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 150.693,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 150.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 150.457,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 151.128,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 151.217,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 153.697,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 152.211,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 152.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.495,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 154.779,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 154.601,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 154.372,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 154.627,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 154.658,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 156.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.025,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 158.595,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 159.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 158.776,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 158.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 158.733,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.686,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 160.439,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 160.54,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 161.675,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 164.147,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 165.439,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.712,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-12",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.005,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.867,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.776,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.792,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.03,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.73,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.733,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.841,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.966,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.646,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.896,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.623,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.141,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.61,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.172,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.232,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 113.392,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.119,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.007,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.853,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 111.771,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.684,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.387,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.093,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.803,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.24,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.948,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 117.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.556,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.745,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.182,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.451,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 125.106,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.043,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.976,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 128.312,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.726,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.986,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 132.717,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 134.191,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 136.801,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 135.884,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 137.689,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 139.143,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 140.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 140.43,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.732,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 141.44,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 140.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 141.027,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 142.333,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 142.763,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 143.236,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 142.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 143.702,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 145.029,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 149.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 146.591,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 146.753,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 148.312,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 150.115,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 150.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 152.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 151.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 149.857,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 150.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 152.044,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 152.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 150.858,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 149.587,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 150.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 152.664,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 155.197,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 154.997,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 155.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 155.156,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 155.549,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 154.499,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 155.897,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 155.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 155.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 156.586,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 160.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 163.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 161.514,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 157.825,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-13",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.695,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.245,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.61,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.31,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.914,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.528,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.115,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.604,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.47,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.183,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.601,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.004,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.7,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.788,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.279,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.151,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.164,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.712,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.551,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.858,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 117.556,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.685,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.442,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.273,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.242,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 125.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.745,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.392,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.261,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.021,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 136.269,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.264,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 141.251,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 140.972,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 140.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 142.181,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 144.481,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 145.761,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 145.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 145.947,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 146.779,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 147.183,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 148.943,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 150.276,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 150.374,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 148.892,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 149.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 152.912,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 155.539,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 152.615,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 153.114,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 155.684,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 156.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 157.81,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 160.417,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 158.07,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 155.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 157.337,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 158.009,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 158.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 157.309,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 156.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 157.399,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 159.399,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 163.671,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 163.607,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 162.95,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 161.769,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 161.341,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 160.77,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 162.681,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 162.374,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 163.385,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 164.771,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 167.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 168.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 166.454,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.761,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-14",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.745,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.483,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.261,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.909,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.753,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.201,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.02,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.396,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.901,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.057,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.206,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 107.019,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.521,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 108.187,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.672,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.179,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.5,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.597,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.63,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.993,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 116.144,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.61,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 117.581,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.541,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.231,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.094,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.417,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.25,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 125.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 128.682,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 130.321,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.084,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.348,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.531,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.672,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.526,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.868,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 142.366,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 143.777,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.168,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 145.931,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.757,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 147.552,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.327,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 149.861,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 150.597,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 151.791,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 151.584,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 152.183,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 152.96,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 156.061,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 154.694,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 154.272,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 154.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.733,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 156.919,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 160.707,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 159.911,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 158.964,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 160.141,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 160.646,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 160.766,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 161.517,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 161.745,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 162.97,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 164.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 165.89,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 166.636,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 167.588,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 168.068,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 168.254,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 167.834,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 167.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 168.856,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 172.664,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 173.97,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 176.577,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 177.715,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 178.162,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 175.769,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-15",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.228,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 99.791,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 99.401,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.342,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.973,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.757,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.077,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.051,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.412,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.355,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.003,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 102.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 102.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 102.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 103.791,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.653,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.319,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.798,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.408,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 109.894,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 109.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 110.054,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 110.415,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 110.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 110.432,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 112.206,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.168,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.134,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.507,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.02,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.234,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 119.994,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 120.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.273,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 122.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 123.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 124.252,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 126.573,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.096,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.564,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 132.746,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.816,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.725,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.306,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.128,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 139.639,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 141.376,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 141.406,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 141.059,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 142.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.311,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 141.786,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 143.857,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 143.844,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 144.234,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 142.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 144.119,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.341,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 149.289,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 144.801,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 145.687,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 149.198,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 150.363,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 150.44,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 153.693,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 151.012,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 150.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 152.415,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.416,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 152.67,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 151.822,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 150.826,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.087,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 157.572,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 158.071,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 157.841,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 155.736,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.1,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 159.565,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 159.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 162.233,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 166.298,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 164.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 163.738,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 160.658,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-16",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.332,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.834,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.83,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.275,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.217,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.012,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.058,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.464,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.865,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.11,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.356,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.083,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.393,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.766,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.985,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.611,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.558,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.039,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.758,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 114.21,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.575,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.726,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.844,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.412,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.15,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.787,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.635,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.402,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.79,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.488,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 126.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.905,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 129.799,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 131.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.381,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.204,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 140.549,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 142.002,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 142.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 143.043,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 144.484,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.68,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.43,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.31,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.579,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 146.507,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 146.716,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 148.523,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 150.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 151.489,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 151.425,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 151.528,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 153.443,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 155.819,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 153.991,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 152.977,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 154.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 155.94,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 159.925,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 158.99,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 156.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 157.301,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 157.649,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 157.719,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.921,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 157.77,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 158.837,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 159.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 162.244,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 162.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 163.218,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 162.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 163.247,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 162.03,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 162.906,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 162.634,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 162.892,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 164.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 168.392,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 169.013,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 169.168,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 166.578,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-17",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 99.739,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 99.995,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.353,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.747,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.947,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.046,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.637,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.238,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.876,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.976,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.098,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.757,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.888,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 113.716,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.284,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 113.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.99,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.027,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.47,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.456,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.244,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.674,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 119.016,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.199,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.106,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.801,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.26,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 127.409,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.833,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.962,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.725,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 136.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.113,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 140.764,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.868,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 143.126,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 144.498,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 145.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.53,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.927,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 146.553,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 146.509,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 147.919,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 148.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.011,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 148.296,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 149.039,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 151.456,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 154.956,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 152.41,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 153.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 155.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.934,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 156.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 159.649,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 157.297,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 155.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 158.237,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 158.489,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 157.268,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.797,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 156.678,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 157.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 160.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 162.129,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 162.052,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 162.174,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 162.158,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 162.768,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 161.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 163.208,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 164.057,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 163.636,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 164.944,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 169.893,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 167.455,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 165.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-18",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.597,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.781,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.446,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.939,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.323,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.198,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.202,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.506,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.69,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.316,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.505,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.132,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.541,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.161,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.238,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.037,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.451,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.094,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 111.843,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.318,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.064,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.651,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.808,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 116.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 117.634,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 120.805,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 122.807,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 123.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.648,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.383,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 128.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.147,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.591,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 130.611,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.076,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.503,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 136.675,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.921,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.306,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.593,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 140.966,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 142.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 143.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 143.516,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 143.925,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.621,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 145.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.363,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 147.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 148.129,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 149.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 151.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 149.657,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 150.164,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 150.492,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 150.871,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 151.222,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 154.697,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 153.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 154.54,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 154.545,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 155.356,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.363,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 155.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 156.474,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.712,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 160.013,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 161.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 161.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 161.553,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 162.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 162.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 162.756,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 164.053,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 166.204,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 168.077,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 171.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 171.349,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 167.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-19",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.545,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.265,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 99.785,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 100.977,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.63,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.424,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.592,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 101.895,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 102.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 102.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.528,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.676,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.532,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.498,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.223,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.277,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.361,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.515,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.61,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.12,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.31,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.724,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.105,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.121,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.333,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 115.495,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 116.468,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 117.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.439,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.753,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.157,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.049,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.47,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 128.848,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.626,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.997,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.671,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.919,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 136.578,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 137.885,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.451,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.233,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 139.903,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 140.484,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 141.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 141.378,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 142.583,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 143.252,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 143.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 144.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 144.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.053,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 148.535,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.991,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 148.476,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 149.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 149.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 150.124,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 152.768,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.446,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 153.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 155.89,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.147,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 155.571,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 156.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 157.497,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 159.189,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 159.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 160.318,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 161.243,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 161.806,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 162.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 163.245,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 164.139,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 164.633,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 165.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 167.009,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 167.577,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 168.171,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 166.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-20",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.523,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.495,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.69,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.332,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.163,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.692,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.154,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 107.321,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.76,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.496,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.755,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 108.73,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.864,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.923,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 113.227,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 113.316,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 115.359,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 115.005,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 114.582,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 114.638,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 114.045,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 115.299,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 115.051,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.254,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.316,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.985,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 117.63,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.671,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.369,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.905,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.166,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.11,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 125.955,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 126.635,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.719,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.904,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 133.445,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 135.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 138.103,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 139.515,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 141.129,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 142.688,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 144.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 145.183,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 146.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 147.717,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.984,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.889,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 148.154,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.36,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 150.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 151.823,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 151.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 151.253,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 152.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 154.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 158.323,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 157.385,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 155.945,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 156.969,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 157.977,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 160.722,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 164.607,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 162.96,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 159.763,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 161.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 162.648,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 163.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 162.147,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 160.363,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 160.723,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 161.678,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 165.177,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 166.896,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 169.514,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 167.345,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 166.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 166.409,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 168.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 167.876,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 169.066,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 169.307,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 172.462,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 173.785,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 171.021,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 169.582,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-21",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.1,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.328,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 105.404,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.548,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.491,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.918,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.856,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.497,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.449,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.027,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.848,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.415,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 111.516,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.776,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.247,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.669,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.891,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.832,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.491,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.263,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.043,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.291,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.891,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.424,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.571,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.924,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.111,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.761,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.341,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.7,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.413,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.103,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 136.244,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.513,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.043,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.372,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.683,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 144.276,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 146.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 147.097,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.195,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.341,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 146.354,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 146.39,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 148.097,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 149.098,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.249,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 148.3,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 150.409,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 153.582,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 157.434,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 152.955,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 152.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 155.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 156.923,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 160.41,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 157.913,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 156.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 158.786,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 159.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 158.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 157.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 156.924,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 157.844,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.931,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 161.143,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 161.57,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 161.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 159.874,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 159.957,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.172,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 161.135,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 161.369,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 162.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 165.237,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 169.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 169.675,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 168.09,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 163.187,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-22",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.447,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.173,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.952,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 106.212,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.711,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.391,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.029,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.828,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.558,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.095,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.403,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.18,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.924,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 108.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.477,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.397,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.953,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.847,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.427,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.944,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.257,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.224,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.611,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.861,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.235,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.191,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.151,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.77,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.608,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.103,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 126.712,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 127.45,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 127.722,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 130.067,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.265,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 133.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 135.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 135.829,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 136.909,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.198,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 139.803,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 140.614,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 140.527,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 140.211,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 141.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 143.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 143.597,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 142.913,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 144.396,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 145.891,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 148.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 146.231,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 146.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 148.21,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 149.625,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 150.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 152.153,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 151.375,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 149.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 152.155,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.545,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 153.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 153.158,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 153.138,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.023,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 157.109,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 158.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 160.157,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 159.645,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 158.595,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 158.979,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 160.953,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 160.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 160.373,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 162.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 166.391,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 167.386,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 165.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-23",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.821,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.013,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.013,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.83,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.762,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.759,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.493,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.778,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.684,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.65,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.232,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.173,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.179,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.404,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.844,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.23,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 107.913,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.409,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.132,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.842,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.326,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.071,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 111.265,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 110.626,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 110.254,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 110.757,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 111.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 111.45,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 112.597,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 113.519,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 114.713,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 115.437,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 116.369,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 117.346,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 118.011,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 118.728,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 119.277,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 120.584,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 123.13,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 124.807,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 125.266,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 125.869,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 127.498,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 129.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 131.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 132.592,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 133.625,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 133.91,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 134.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 135.605,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 136.798,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 137.324,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 137.931,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 138.816,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 139.177,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 139.633,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 140.143,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 140.656,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 141.296,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 141.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 142.235,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 144.255,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 144.667,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 145.018,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 146.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 146.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 146.869,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 148.416,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 148.789,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 148.895,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 150.296,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 150.372,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 150.374,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 150.345,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 149.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 150.653,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 151.357,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 151.982,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 152.293,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 154.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 154.273,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 154.212,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 154.722,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 153.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 154.736,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 158.878,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 160.707,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 163.57,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 164.293,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 164.508,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 163.23,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-24",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.948,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 102.159,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.782,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 106.067,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 105.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 105.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 105.317,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.504,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.95,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 107.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.629,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.955,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 110.063,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.609,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.816,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.886,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.315,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.232,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 113.505,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 114.893,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 116.087,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 115.783,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 115.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 117.272,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 117.321,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 118.212,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 119.451,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 120.839,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.406,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 123.475,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 125.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 125.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 127.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 128.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 129.061,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 130.066,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 132.82,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 133.945,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 137.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.952,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 141.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 143.174,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 143.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 144.394,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.827,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 147.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.531,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 148.611,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.918,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 150.355,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 151.505,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 153.046,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 152.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 153.275,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 154.824,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 157.113,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 156.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 155.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 157.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 158.085,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 158.028,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 160.789,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 159.939,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 158.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 160.046,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 160.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 160.756,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 160.689,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 159.449,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 160.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 162.995,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 164.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 164.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 165.265,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 165.423,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 165.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 164.961,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 165.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 165.897,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 166.076,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 167.327,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.744,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 172.15,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 171.229,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 169.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-25",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.894,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.415,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.424,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 102.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.196,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.679,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.052,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.867,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.706,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.263,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.677,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.088,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.203,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.017,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.941,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.434,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.196,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 111.735,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.089,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.954,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.577,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.881,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 115.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 116.894,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.976,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.95,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.09,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.629,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.027,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.834,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 128.699,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.806,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 130.945,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 136.078,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.328,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 138.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.713,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.896,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 141.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 141.738,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 141.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.427,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 142.737,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 143.291,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.544,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.492,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 145.407,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 145.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 147.783,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.242,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 146.88,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 147.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 147.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 148.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 151.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 151.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 152.353,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.091,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.731,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 153.424,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 153.495,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 152.731,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.266,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 156.889,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 156.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 157.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 158.048,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 158.625,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.338,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 158.937,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 158.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 158.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 160.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 162.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 163.685,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 163.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-26",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.871,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.437,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.496,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.254,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.685,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.88,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 102.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 102.826,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.879,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.263,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.965,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.802,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.313,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.696,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.19,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.593,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.587,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.417,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.403,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.459,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.336,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.095,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.812,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.49,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.896,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 114.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 115.548,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 116.634,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 118.023,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 119.706,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.303,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 122.025,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 122.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.829,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 125.747,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 126.684,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 127.855,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 129.303,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.881,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 136.114,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 136.365,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 136.143,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 135.529,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 135.885,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 136.99,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 137.373,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 136.929,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 137.822,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 138.166,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 139.559,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 140.618,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 141.807,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 141.528,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 141.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 142.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 145.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 144.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 144.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 144.793,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 144.591,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 145.526,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 147.982,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 149.579,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 149.853,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 150.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 151.267,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 151.277,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 151.397,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 150.991,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 151.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 152.447,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 154.047,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 154.135,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 154.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 154.114,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 155.456,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 155.154,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 155.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 155.338,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 155.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 156.163,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 158.195,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 159.188,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 159.55,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 159.294,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-27",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.267,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.493,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.392,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 100.913,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 101.666,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 102.406,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.523,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.94,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.821,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.77,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.574,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.507,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.228,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.903,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.501,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.826,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.615,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.846,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 115.048,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 114.574,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 114.939,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.775,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.578,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.541,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.591,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.98,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 117.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.009,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.853,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.277,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.121,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.988,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.158,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.607,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 130.758,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.846,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.783,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.044,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.545,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 135.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 136.435,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 136.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 137.564,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.962,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 141.232,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 142.364,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 142.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.269,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 141.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 142.133,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.074,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.197,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 144.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 145.276,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.091,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 148.996,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 146.766,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 148.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 149.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 148.822,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 149.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 152.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 151.35,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 150.444,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 151.203,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 152.151,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 151.898,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 152.789,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 151.948,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.095,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 153.792,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.911,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 158.551,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 158.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 155.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 156.062,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 156.176,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 157.391,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 156.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 158.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 159.85,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 162.908,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 163.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 163.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 160.763,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-28",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.516,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.493,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.344,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.732,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.364,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.733,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.483,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 102.328,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.067,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.516,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.719,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.888,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.044,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.359,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 104.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.274,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 106.584,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 107.855,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 108.593,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.521,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.107,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.343,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 111.177,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 111.564,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 111.781,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 111.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.63,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 112.444,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.88,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.895,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.833,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.775,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.264,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.546,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.793,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.016,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.939,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.172,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 128.687,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.411,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.508,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.906,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 138.154,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 139.508,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 140.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 140.911,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 141.059,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 142.075,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 142.484,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 143.028,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 143.939,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 144.319,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 144.23,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 145.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.517,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 148.077,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 148.174,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 147.911,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 148.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 150.171,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 150.695,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 152.071,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 152.505,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 152.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 154.082,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 155.142,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 155.407,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 155.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 154.681,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 155.211,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 156.774,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 159.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 158.963,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 159.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 160.895,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 161.961,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 161.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 161.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 161.948,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 161.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 161.945,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 163.313,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 164.658,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 161.756,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-29",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.955,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.402,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 104.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 105.667,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.522,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.959,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.996,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.242,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.445,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.109,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.579,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.602,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.187,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.384,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.293,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.336,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 112.146,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.929,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.269,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.691,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.599,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 111.573,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.722,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.159,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.354,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.307,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.561,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.599,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.529,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.381,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.141,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.823,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.032,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 128.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 128.442,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.862,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.231,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.821,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 134.359,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 135.982,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 137.476,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 139.266,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 140.786,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 142.191,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 143.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 145.417,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 147.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 148.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.783,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 147.321,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 146.901,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 148.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 150.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.987,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 149.164,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 151.799,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 154.374,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 159.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 153.626,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 153.2,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 156.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 157.105,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 160.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 157.878,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 155.192,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 159.213,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 159.917,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 159.004,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.569,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 156.524,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 157.382,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.996,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 163.235,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 162.907,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 163.889,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 162.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 160.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.386,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 161.542,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 161.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 160.985,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 164.298,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.039,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 168.877,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 167.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 160.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-30",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.991,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.166,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.575,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.291,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.861,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.093,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.345,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.059,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.509,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.843,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.825,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.621,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.895,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.993,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.945,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.433,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.163,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.727,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 113.656,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.124,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 114.197,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 114.724,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 114.726,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 115.864,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 115.517,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.987,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.653,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.484,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.578,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.871,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.463,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.984,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 123.697,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 128.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.465,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.741,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 133.671,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 135.375,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 137.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.106,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 140.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 143.068,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.814,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 144.075,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 145.337,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 146.678,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.719,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 147.044,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.564,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 147.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.075,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 149.373,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 150.966,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 151.418,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 150.797,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 152.039,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 154.311,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 158.581,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 154.858,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 154.818,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 156.356,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 157.096,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 158.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 161.587,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 159.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 158.388,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 160.055,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 160.595,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 160.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 160.824,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 158.837,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 159.401,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 161.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 165.599,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 165.687,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 165.521,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 164.901,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 165.093,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 164.488,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 165.636,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 165.62,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 167.117,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 168.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 171.863,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 173.304,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 173.584,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 169.877,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-31",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.9,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.381,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.04,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.75,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.36,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.47,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.961,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.854,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.307,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 106.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.539,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.686,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.9,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.521,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.805,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.442,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 111.649,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 111.816,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 112.583,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.323,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.301,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.41,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.26,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 118.588,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 119.858,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 119.522,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 120.598,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 121.464,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 122.988,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 124.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.731,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 128.462,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 130.749,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.201,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.173,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 135.735,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.412,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 139.104,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 140.542,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 142.449,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 143.318,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.946,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 144.652,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 144.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 145.39,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 146.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 146.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.478,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 147.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 148.726,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 150.142,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 152.25,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 152.964,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 152.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 152.738,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 153.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 154.72,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 155.408,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 155.024,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 154.905,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 156.036,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.991,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.874,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 157.173,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 157.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 158.144,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.993,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 159.372,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 159.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 158.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.605,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 158.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 163.144,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 163.85,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 164.812,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.664,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 166.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 165.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ent-32",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.998,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.664,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.986,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.532,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.887,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.912,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.21,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.363,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.839,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.879,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.593,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.297,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.915,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.786,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.211,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.357,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.09,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.332,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.984,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.92,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.181,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.773,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.388,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.706,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.411,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.697,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.925,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.871,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 120.245,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.245,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.459,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.02,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.756,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.368,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 128.678,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.887,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.71,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.715,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.338,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 136.606,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 140.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 142.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.498,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 144.51,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 146.076,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 146.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 147.3,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 147.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 148.527,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 149.674,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 151.577,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 152.463,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 152.39,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 153.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 154.787,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 156.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 154.45,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 154.615,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 156.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 158.96,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 157.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 161.349,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 160.322,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 159.499,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 160.539,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 161.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 160.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 159.969,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 160.91,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 162.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 163.863,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 165.022,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 164.697,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 166.026,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 166.373,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 167.07,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 166.739,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 167.929,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 167.193,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 167.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 169.727,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 173.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 174.533,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 174.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 171.915,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-zmcm",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.887,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.757,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.62,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.635,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 105.112,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.946,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.152,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.683,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.446,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.644,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.153,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.094,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.261,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.416,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.786,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.322,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.227,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.692,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.385,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.266,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.252,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.986,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.963,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.964,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.36,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.332,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.072,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.408,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.609,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.039,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.366,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.971,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 128.192,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.707,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.853,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 133.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 134.346,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.264,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.086,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 137.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 140.469,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 141.154,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.995,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 141.881,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.007,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 142.499,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 143.787,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.616,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 143.444,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 144.62,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 147.784,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 150.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 147.669,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 150.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 150.679,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 152.785,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 155.66,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.869,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 152.687,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.846,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.877,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 153.96,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 153.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 153.693,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 154.83,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 156.469,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 159.257,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 159.428,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 159.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 158.662,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 159.104,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 158.569,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.676,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 159.755,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 160.797,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 161.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 165.375,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 163.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 161.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-acapulco",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.99,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.269,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.467,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 105.059,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 106.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.862,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.984,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.919,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.675,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.437,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.683,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.258,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.493,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.788,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.651,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.034,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.946,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.66,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.423,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.9,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 114.141,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.255,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.055,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.658,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.692,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.247,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.76,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 117.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 119.76,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 120.646,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.924,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 123.991,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.876,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.036,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 127.14,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 126.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.105,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.169,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 133.166,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.472,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 136.268,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.495,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.558,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.595,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 140.534,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 142.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 143.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.304,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 145.149,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 144.237,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 144.902,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 144.303,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 143.758,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.254,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 145.285,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.899,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 144.558,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 145.66,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 147.897,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 151.62,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 148.163,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 148.645,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 150.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 151.529,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 150.927,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 153.939,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.439,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 151.793,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.3,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.897,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 154.237,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 151.737,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 151.729,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 152.621,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 154.777,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 157.02,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 157.81,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 157.336,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 157.149,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.404,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 156.002,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 157.607,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 157.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 156.552,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 156.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 160.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 163.869,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 162.598,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 158.085,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-aguascalientes",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100.024,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.095,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.882,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.45,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.307,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.44,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.716,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.418,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.294,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.187,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.998,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.754,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.413,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.124,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.738,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.399,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.879,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 111.092,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 112.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.717,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 113.496,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 114.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 114.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.818,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.54,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.674,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.827,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.93,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.963,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.188,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 123.014,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.633,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.074,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.694,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 128.554,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.229,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 134.65,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 136.695,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 139.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 140.96,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.651,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 143.322,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 145.888,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 145.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.08,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 146.613,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 147.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 148.784,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 149.641,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.94,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 149.365,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 150.541,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 152.737,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 154.098,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 151.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 152.505,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 154.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 154.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 155.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 158.978,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 158.644,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 157.746,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 157.304,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 157.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 159.273,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 160.004,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 158.912,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 160.695,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 163.082,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 164.345,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 165.018,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 166.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 167.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 166.403,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 166.523,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 166.558,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 168.923,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 169.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 170.844,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 173.561,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 173.132,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 170.407,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 169.019,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-atlacomulco",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.542,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.189,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.036,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.94,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 106.328,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 108.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.477,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.09,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.771,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.683,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.91,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.581,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 103.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 103.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.662,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.33,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.356,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.962,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 112.24,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.402,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 113.82,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.492,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 109.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 109.428,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 109.92,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 110.372,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 111.1,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 110.053,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.807,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 112.949,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.199,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.467,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.886,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.112,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.046,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.157,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 120.506,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.405,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.331,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.112,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.119,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.048,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.676,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 132.427,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.083,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 136.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 138.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 138.829,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 139.823,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 142.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.141,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 144.943,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 144.477,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 144.986,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 145.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 144.238,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 146.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 146.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.208,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 146.55,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 148.092,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 149.802,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 153.871,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 148.34,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 148.982,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 152.801,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 153.493,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 154.376,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 158.426,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 155.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 154.024,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 156.489,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 157.309,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.253,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 155.818,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 154.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 156.329,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.023,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 161.737,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 162.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 162.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 163.772,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 163.623,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 162.319,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 166.577,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 165.709,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 167.049,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 170.573,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 175.686,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 174.774,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 171.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 167.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-campeche",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.736,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.067,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.811,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.481,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.13,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.531,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.373,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.099,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 105.078,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.901,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.391,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.252,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.781,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.003,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.294,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.542,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.854,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.476,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.237,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.842,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.751,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.327,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.552,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.33,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.406,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 122.969,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.918,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.217,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 130.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 133.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 134.586,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 135.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 137.12,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.418,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 140.357,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 142.061,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.555,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 143.716,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 146.527,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 149.161,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 149.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 148.819,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 149.129,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 150.356,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 151.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 152.488,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 153.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 154.363,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 154.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 154.076,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 155.779,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 157.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 156.501,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 157.539,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 158.327,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 158.766,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 160.26,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 162.263,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 161.803,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 162.24,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 163.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 163.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 163.634,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 163.031,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 162.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 163.229,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 163.906,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 166.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 167.915,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 168.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 167.917,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 168.284,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 168.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 168.572,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 168.167,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 171.373,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 172.754,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 174.404,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 175.455,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 175.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 173.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-cancun",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.614,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.857,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.084,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.364,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.508,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.356,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.316,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.831,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.911,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.916,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.578,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.982,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.556,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.443,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.295,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.693,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.244,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.678,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.366,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 110.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 111.713,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 110.721,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 110.242,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 109.565,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 110.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 110.652,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 111.314,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 112.45,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 113.574,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 114.588,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 115.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 116.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 117.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 118.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 119.414,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 119.771,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 121.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 123.711,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 125.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 125.945,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 126.276,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 127.664,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 129.477,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 131.629,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 133.029,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 133.695,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 133.805,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 134.498,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 135.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 136.882,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 137.594,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 137.962,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 138.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 138.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 139.153,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 139.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 140.258,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 141.025,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 140.732,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 141.455,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 143.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 144.874,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 144.645,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 145.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 146.792,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 146.755,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 148.181,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 148.691,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 148.903,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 150.229,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 150.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 150.369,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 150.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 150.046,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 151.579,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 152.096,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 152.393,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 152.932,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 154.238,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 154.131,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 154.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 154.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 153.604,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 155.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 159.69,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 161.361,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 164.348,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.026,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 165.434,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 163.727,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-cd-acuna",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.881,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.963,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.941,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 100.648,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.299,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.397,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.778,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.693,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.431,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.275,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.096,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.651,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.156,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.798,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.454,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.135,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.635,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.941,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.556,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.342,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.806,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.929,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.729,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 111.67,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 111.501,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 112.555,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.694,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.293,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.363,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.265,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 117.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.519,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.106,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.1,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.963,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.953,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.507,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 128.281,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.495,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.752,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 133.206,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 135.633,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.211,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 139.167,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 138.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.23,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.561,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.264,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 140.054,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.872,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 142.336,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.68,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 142.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.588,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 145.086,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 144.771,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 145.777,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 148.364,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.315,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 148.382,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 150.011,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 150.941,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 151.833,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 153.923,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.736,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 152.906,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.91,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 154.457,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 154.161,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 155.11,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 153.898,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 154.848,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.994,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.913,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 158.689,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 159.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 160.493,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 160.349,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.61,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.628,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 158.306,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 159.47,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 161.564,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 163.297,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 164.629,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 164.721,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.678,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-cd-jimenez",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.793,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.328,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.063,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 100.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.691,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.841,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.588,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.007,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.251,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.966,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.998,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.674,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.331,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.378,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.921,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 114.497,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.154,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 114.783,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 114.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 114.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 115.345,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 115.3,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.953,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 116.308,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 117.233,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.897,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.284,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.012,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.172,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 124.666,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 126.083,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 127.412,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 128.317,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 129.747,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 131.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 132.844,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 134.493,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 136.479,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 139.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 141.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 142.616,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 144.591,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 145.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 144.609,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 145.264,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 146.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 147.031,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 147.193,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.662,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 147.971,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 147.474,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 149.521,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 150.697,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 152.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 152.832,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 153.656,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 155.276,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 156.921,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 156.208,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 155.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 157.341,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 157.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 157.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 159.213,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 158.866,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 157.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 158.525,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 159.168,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 159.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 160.055,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 157.72,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 159.357,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.862,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 160.228,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 160.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 160.923,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 160.905,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 160.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 162.253,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 163.329,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 165.051,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 165.105,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 165.296,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 166.482,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 170.159,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 166.397,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.934,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-cd-juarez",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.915,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.592,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.663,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.592,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.843,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.573,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.418,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.322,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.68,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.816,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.997,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.364,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.755,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.552,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 107.036,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 109.062,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 110.034,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.526,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 113.788,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 115.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.535,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 114.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 116.607,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 116.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 116.017,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 117.489,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 115.191,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.064,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.439,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 117.269,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.445,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.924,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.188,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.945,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.834,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.308,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 126.66,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.136,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.104,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 129.154,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 130.474,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 132.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 133.97,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 135.413,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.346,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 139.548,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 139.1,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 139.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 140.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.639,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 140.099,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.628,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 140.651,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 140.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 139.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 139.956,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 140.235,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 141.934,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 142.296,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 142.233,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 143.087,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 145.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 144.658,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 145.243,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 146.67,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 147.063,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 146.829,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 148.67,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 149.789,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 150.747,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 151.85,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 154.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 155.051,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 153.837,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 154.304,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 156.315,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 157.178,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 158.392,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 157.16,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 158.887,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 160.202,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.243,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 160.197,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 160.786,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 161.614,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 162.096,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 163.855,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 163.199,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 161.645,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-chetumal",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.198,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.487,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.853,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.684,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.739,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.675,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.221,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.11,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.839,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.255,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.959,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.656,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.089,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.593,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 106.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 106.663,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 107.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 108.896,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 109.929,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.188,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.703,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.937,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.721,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.249,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 111.321,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 111.503,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 111.879,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 111.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 111.695,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 112.863,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 113.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 114.939,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 114.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 115.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 116.561,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 116.965,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 117.487,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 118.383,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 119.61,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 122.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 124.148,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 124.036,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 125.131,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 127.197,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 129.111,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 130.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 131.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 133.5,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 134.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 134.535,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 135.728,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 136.644,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 136.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 137.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 139.657,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 140.621,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 140.503,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 140.699,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 141.376,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 141.787,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 142.425,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 143.649,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 145.697,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 144.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 145.693,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 147.067,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 147.307,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 147.076,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 148.842,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 148.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 148.922,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 150.45,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 150.91,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 150.424,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 150.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 149.416,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 149.151,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 150.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 151.336,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 151.269,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 154.164,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 154.551,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 154.121,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 154.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 153.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 154.171,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 157.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 159.66,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 162.318,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 163.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 163.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.447,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-chihuahua",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.908,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.435,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.912,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.131,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.402,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.591,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.534,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.788,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 105.24,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.119,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.877,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.3,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 107.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 107.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.721,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.829,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.634,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.328,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.128,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.755,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.753,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 115.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 116.107,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 115.285,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.021,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.997,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.145,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.671,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.685,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.206,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.927,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 123.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 125.284,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 126.703,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.763,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 129.267,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 131.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 132.232,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 133.862,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 135.513,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.004,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.931,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.017,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 141.93,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 142.336,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 143.016,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.487,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 143.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 145.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 144.991,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 146.003,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 147.341,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 148.397,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 148.498,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 148.964,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 149.949,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 151.855,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 151.443,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 151.588,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 152.571,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 152.741,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 152.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 154.161,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 154.737,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 155.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 155.911,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.685,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.267,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 155.097,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 156.439,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 157.454,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 159.541,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 161.242,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 161.296,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 161.244,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 161.77,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 162.222,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 162.69,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 163.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 164.089,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 165.677,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 168.598,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 168.19,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 166.191,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-coatzacoalcos",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.345,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.186,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.311,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.467,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.052,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.344,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 102.734,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.978,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.734,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.574,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 103.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 103.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 104.778,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.54,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.743,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 107.488,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.411,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.221,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.904,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.526,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.052,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.973,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 112.75,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 112.888,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.16,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 115.824,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 115.863,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 116.336,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 117.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 119.087,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 118.843,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 121.604,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 121.236,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 123.716,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 126.275,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 127.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 127.41,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 129.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 131.902,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.36,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 136.032,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 136.554,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 135.863,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 136.921,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 138.182,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 139.749,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.188,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 140.142,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 139.697,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 139.61,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 141.078,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 143.306,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 144.078,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 143.886,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 143.741,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 150.285,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.032,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 147.294,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 148.503,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 149.465,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 150.372,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 154.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.454,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 151.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 154.776,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.004,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 154.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 152.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 160.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 160.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 160.33,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 159.684,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 159.626,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.735,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 160.34,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 160.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 161.444,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 162.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 165.171,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 166.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 166.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.317,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-colima",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.637,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.898,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.49,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.145,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.224,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.442,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.438,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.554,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.267,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.368,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.912,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.811,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.839,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.376,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.18,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.388,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.957,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.411,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.891,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.504,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.925,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.445,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.852,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.941,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.488,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.229,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.823,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.058,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.009,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 128.145,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.423,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.468,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 138.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 140.195,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 140.658,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 141.532,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 142.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 143.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 146.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.925,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 147.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 147.437,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 149.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 151.693,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 150.489,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 150.394,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 151.438,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 152.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 152.627,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 155.694,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 155.355,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 154.261,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 156.111,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 157.274,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.867,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.893,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 157.018,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 157.295,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.508,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 160.483,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 161.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 162.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 162.477,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 163.777,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 163.601,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 164.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 164.506,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 165.374,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 166.791,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.799,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 171.192,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 171.142,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 169.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-cordoba",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.841,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.167,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.479,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.676,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 105.141,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.464,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.876,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.569,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.766,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.994,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.09,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.13,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.415,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.646,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 108.542,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.978,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.021,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.937,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 115.157,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.91,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 115.264,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 116.149,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 116.156,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 117.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 117,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 116.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 116.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 116.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 118.186,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 120.979,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 121.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 122.208,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 124.401,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 125.333,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 126.364,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 126.176,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 129.096,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 129.286,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 129.85,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 131.564,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 134.338,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 136.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 138.799,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 140.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 141.223,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 143.772,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 146.492,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 147.277,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 147.497,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 149.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 150.276,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 149.571,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 150.206,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 150.683,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 151.242,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 151.525,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 152.899,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 154.184,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 154.558,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 153.987,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 155.916,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 158.378,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 162.672,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 158.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 158.524,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 160.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 160.787,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 162.417,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 164.658,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 161.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 161.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 164.635,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 164.51,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 163.91,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 164.423,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 162.508,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 163.862,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 167.311,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 169.055,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 170.323,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 169.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 168.355,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 169.228,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 168.231,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 170.392,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 171.136,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 171.229,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 172.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 176.847,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 178.413,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 177.413,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 170.927,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-cortazar",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.638,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.889,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.431,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 105.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 106.114,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.752,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.957,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.196,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.754,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.782,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.665,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.593,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.088,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.79,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.091,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 111.072,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 112.247,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.598,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.621,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.872,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 114.236,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 115.024,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 115.121,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.933,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 115.477,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 115.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.977,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.988,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.258,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.167,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.135,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.88,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 123.449,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.254,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.877,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.268,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.858,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 131.724,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 133.33,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 136.187,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.047,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 139.808,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.115,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 142.778,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 143.034,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 143.234,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 144.781,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 144.972,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 144.406,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 144.918,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 146.646,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 148.048,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.285,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 148.822,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 148.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 151.378,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 154.52,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 154.466,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 153.782,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 152.679,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 153.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 153.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 155.723,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.892,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 153.581,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 154.739,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 155.65,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 156.468,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 155.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 156.183,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 159.509,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 160.049,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 159.203,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 158.878,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.314,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.818,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 160.484,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 161.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 162.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 163.295,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.025,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 165.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.726,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-cuernavaca",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 99.739,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 99.995,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.353,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.747,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.947,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.046,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.637,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.238,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.876,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.976,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.098,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.757,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.888,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 113.716,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.284,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 113.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.99,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.027,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.47,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.456,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.244,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.674,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 119.016,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.199,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.106,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.801,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.26,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 127.409,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.833,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.962,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.725,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 136.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.113,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 140.764,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.868,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 143.126,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 144.498,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 145.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.53,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.927,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 146.553,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 146.509,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 147.919,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 148.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.011,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 148.296,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 149.039,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 151.456,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 154.956,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 152.41,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 153.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 155.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.934,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 156.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 159.649,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 157.297,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 155.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 158.237,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 158.489,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 157.268,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.797,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 156.678,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 157.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 160.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 162.129,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 162.052,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 162.174,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 162.158,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 162.768,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 161.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 163.208,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 164.057,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 163.636,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 164.944,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 169.893,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 167.455,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 165.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-culiacan",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.535,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.894,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.415,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.424,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 102.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.196,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.679,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.052,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.867,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.706,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.263,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.677,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.088,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.203,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.017,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.941,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.434,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.196,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 111.735,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.089,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.954,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.577,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.881,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 115.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 116.894,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.976,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.95,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.09,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.629,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.027,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.834,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 128.699,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.806,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 130.945,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 136.078,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.328,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 138.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.713,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.896,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 141.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 141.738,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 141.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.427,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 142.737,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 143.291,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.544,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.492,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 145.407,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 145.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 147.783,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.242,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 146.88,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 147.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 147.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 148.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 151.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 151.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 152.353,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.091,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.731,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 153.424,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 153.495,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 152.731,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.266,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 156.889,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 156.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 157.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 158.048,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 158.625,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.338,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 158.937,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 158.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 158.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 160.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 162.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 163.685,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 163.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-durango",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.723,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.177,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.934,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.014,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.443,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.514,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.11,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.121,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.842,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.993,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.376,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.969,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.007,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.801,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.221,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.872,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.02,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.069,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.155,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.637,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.434,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.176,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.013,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.793,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.328,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.866,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.881,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.906,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.861,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.311,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.496,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.555,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.075,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.168,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.18,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.784,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.321,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 142.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 144.233,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 145.313,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.912,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.806,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.803,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 147.614,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 147.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 148.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 148.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 151.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 151.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 153.609,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 153.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 154.527,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 152.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 151.775,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 154.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 154.885,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 157.92,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 157.79,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 157.937,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 158.931,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 159.435,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 159.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 158.76,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 159.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 159.89,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 160.725,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 161.791,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 161.9,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 164.296,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 165.419,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 165.096,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 164.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 164.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 165.387,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 164.923,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 166.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 169.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 171.021,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 170.243,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 167.724,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-esperanza",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.897,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.476,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.447,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.843,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 102.02,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 101.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 101.596,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 101.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 101.773,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.403,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.089,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.047,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.623,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 104.709,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 104.721,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 104.947,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 105.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 105.408,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 107.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 108.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 107.965,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 109.66,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 110.147,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 110.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 111.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 111.529,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 109.93,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 111.648,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 111.399,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 111.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 112.133,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 112.827,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 113.797,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 115.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 117.025,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 118.81,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 119.578,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 120.247,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 121.437,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 123.173,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 123.889,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 124.066,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 124.513,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 124.91,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 127.083,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 129.906,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 132.384,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 133.393,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 133.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 133.284,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 133.262,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 133.653,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 134.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 135.35,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 135.976,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 136.143,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 137.499,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 139.897,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 139.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 140.681,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 141.08,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 140.963,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 142.625,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 144.769,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 143.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 142.018,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 143.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 143.193,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 144.068,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 146.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 147.587,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 147.907,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 148.465,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 148.802,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 149.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 148.918,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 147.717,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 148.095,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 149.605,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 151.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 151.971,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 151.39,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 151.348,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 153.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 154.364,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 154.685,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 154.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 154.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 155.807,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 156.996,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 158.052,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 158.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 158.326,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-fresnillo",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.789,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.268,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 102.025,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 102.024,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.263,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 105.553,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 106.979,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 105.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.211,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.834,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.082,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.391,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.392,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.736,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.464,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.988,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.73,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.739,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.444,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.477,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.558,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.628,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.108,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.682,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.317,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.852,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.684,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.722,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.685,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.738,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.785,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 119.132,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 120.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.091,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.293,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.503,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 127.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.196,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 128.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 130.355,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 132.397,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.699,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.948,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 136.693,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 140.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 143.059,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.331,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 144.921,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 146.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 146.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 147.517,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 147.431,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 148.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 149.745,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 151.583,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 152.986,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 152.575,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 154,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 154.771,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 156.953,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 154.895,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 155.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 156.53,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 159.633,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 157.887,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 162.504,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 160.366,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 159.456,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 160.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 161.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 160.262,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 159.133,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 159.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 161.381,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 162.715,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 163.368,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 163.085,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 164.982,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 164.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 165.319,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 163.785,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 165.378,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 165.637,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 165.275,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 166.485,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.33,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 171.808,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 171.419,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 168.051,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-guadalajara",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.934,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.775,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.771,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.501,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.409,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.222,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.397,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.153,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.204,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.599,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.253,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.559,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.305,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 107.517,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 108.247,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 108.906,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.44,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.592,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.017,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.432,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.117,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.945,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 116.212,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.887,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.061,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 120.223,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 121.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.831,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 123.228,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 124.237,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 125.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.593,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.737,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 129.188,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 130.878,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.67,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 133.071,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.602,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.14,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.286,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.904,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.556,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 142.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 142.695,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 144.166,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.823,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 147.14,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.626,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 148.251,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 149.096,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 150.93,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 151.534,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 152.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 152.242,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 152.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 153.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 156.286,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 154.96,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 154.579,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 155.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 156.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 157.879,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 161.857,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 160.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 159.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 161.19,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 161.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 161.694,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 162.52,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 162.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 164.263,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 165.833,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 167.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 167.906,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 168.789,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 169.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 169.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 168.821,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 168.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 169.646,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 173.701,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 175.054,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 177.581,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 178.811,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 179.043,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 176.862,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-hermosillo",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.757,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.892,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.365,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.507,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.953,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.072,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.184,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 102.212,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.672,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.344,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.876,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 104.924,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.717,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.915,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.481,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.077,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.769,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.896,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.555,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.236,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.411,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.431,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.824,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.045,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.203,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.944,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 114.509,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 115.423,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 116.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 117.857,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 119.704,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.49,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 122.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 123.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 126.508,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 127.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.287,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 130.483,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.353,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 136.478,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 136.58,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 136.473,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 135.348,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 135.701,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 136.893,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 137.012,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 136.33,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 137.433,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 137.507,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 139.11,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 140.681,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 141.789,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 141.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 141.526,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 142.378,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 144.023,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 142.616,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 143.625,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 144.596,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 144.349,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 145.084,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 147.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 148.95,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 149.295,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 150.189,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 150.918,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 150.688,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 151.082,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 150.993,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 151.274,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 152.149,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 153.872,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 153.904,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 154.125,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 154.07,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 155.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 154.036,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 154.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 154.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 154.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 155.096,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 157.556,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 158.616,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 159.167,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 158.783,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-huatabampo",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.71,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.802,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 102.078,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.825,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.26,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.588,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.806,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.798,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.438,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.773,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.113,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.96,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.897,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 108.289,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 108.592,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.382,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.031,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.977,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.601,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.183,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.652,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.963,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.645,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.294,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.857,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.99,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.623,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.021,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.147,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.245,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.082,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.057,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.548,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.319,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.548,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.517,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.281,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 123.774,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.492,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.594,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 125.683,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 126.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 127.526,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 128.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.417,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.445,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 138.315,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.113,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.049,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 138.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 139.304,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.054,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 139.117,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 140.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 140.218,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 140.212,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 141.544,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 142.902,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 142.616,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 143.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 144.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 147.889,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 147.09,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 146.5,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 146.427,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 147.848,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 150.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 152.962,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 152.761,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 154.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 154.747,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 154.163,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 153.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 154.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.985,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 156.575,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 155.434,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 155.255,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 155.688,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 158.885,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 158.644,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 157.739,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 158.12,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 158.412,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 159.63,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 159.977,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 159.898,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 159.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-iguala",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.253,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.927,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 102.053,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 102.187,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.666,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.821,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.937,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.62,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.319,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.168,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.733,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 103.969,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.183,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 104.801,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.427,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.037,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.57,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.97,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.898,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.21,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.326,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 110.982,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 110.745,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 111.905,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 111.343,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 111.171,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.133,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.824,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.244,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.95,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.885,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.105,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.969,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.477,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.828,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.184,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.481,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 123.755,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 124.274,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 126.028,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 126.976,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 128.198,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 129.879,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 131.55,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 132.674,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 133.768,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 132.167,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 134.071,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 135.711,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 136.812,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 136.657,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 137.931,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 138.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 137.711,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 138.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 140.798,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 140.746,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 141.107,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 140.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 142.136,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 142.736,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 147.409,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 145.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 145.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 146.827,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 148.985,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 149.703,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 151.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 150.636,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 148.228,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 148.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 150.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 150.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 150.712,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 147.669,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 148.644,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 150.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 153.766,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 152.18,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 153.499,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 153.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 154.076,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 153.508,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 154.627,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 153.627,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 154.901,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 157.457,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 162.672,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 163.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 161.158,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 158.593,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-izucar-de-matamoros",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.323,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.058,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.017,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.848,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 105.7,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 106.841,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.492,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.531,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.23,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.614,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.202,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.592,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 103.2,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.028,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.921,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.931,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.957,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.922,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.784,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 113.318,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.856,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.236,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.15,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.73,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.885,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 111.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.919,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.679,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 117.887,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.829,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.896,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.771,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.808,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.584,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.984,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.504,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.082,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.839,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.155,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.104,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.515,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 140.649,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 143.683,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 146.306,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 147.195,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 145.907,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.583,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 146.843,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 145.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 147.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 148.718,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 148.411,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 147.542,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 150.041,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 152.314,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 155.337,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 151.819,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 151.046,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 155.308,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 155.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 159.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 155.644,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 154.316,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 156.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.772,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 155.821,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 152.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 150.677,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 152.498,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 153.994,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 156.735,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 156.195,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 156.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 154.761,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 153.818,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 152.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 155.44,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 154.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 154.191,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 157.007,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 161.747,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 162.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 160.638,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 154.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-jacona",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.799,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.52,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 102.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.937,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.507,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.899,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 105.193,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.923,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.499,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.406,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.068,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.65,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 108.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.993,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 111.803,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 112.717,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 114.388,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 115.206,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 114.254,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 114.198,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 115.392,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 115.924,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 116.813,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 115.529,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 116.289,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 116.451,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 116.891,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 117.364,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.061,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.868,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 121,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.431,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.097,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 123.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.741,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 128.399,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 130.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 131.888,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 132.135,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 133.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 135.095,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 136.34,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.946,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 142.163,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 143.58,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 145.041,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 145.144,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 146.53,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 147.854,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 148.853,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 148.597,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 148.605,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 148.473,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.39,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 150.138,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 152.384,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 153.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 153.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 153.41,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 155.014,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 157.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 156.656,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 155.083,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 156.295,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 158.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 157.613,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 160.732,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 160.284,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 157.68,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 157.901,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 158.831,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 158.966,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 158.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 159.528,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 161.525,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 162.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 164.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 166.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 166.478,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 164.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 165.3,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 165.095,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 165.231,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 165.345,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 165.404,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 167.872,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 171.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 172.355,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 172.525,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 169.397,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-la-paz",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.867,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.04,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 102.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 102.114,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.681,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.028,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.626,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.376,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.516,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.151,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.83,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.405,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.692,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.417,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.937,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.178,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.641,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.602,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.492,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.828,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.044,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.125,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.2,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 117.869,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.174,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.659,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.16,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.361,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.12,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.565,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.059,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 127.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 130.15,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.094,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.627,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.83,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 140.618,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 141.375,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 141.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.093,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 142.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 143.111,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.128,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.267,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 145.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 145.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.225,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 147.972,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.607,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 148.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 148.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 148.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 148.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 150.2,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 151.361,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 151.878,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.465,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 153.987,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 154.114,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 153.751,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.412,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 156.407,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 155.099,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 155.475,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 156.124,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.476,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 158.059,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 156.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 157.291,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 158.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 158.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 159.897,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 162.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 161.437,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 160.053,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-leon",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.774,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 99.908,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.332,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.788,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.911,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.134,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.578,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.018,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.305,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.943,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.972,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.134,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.032,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 104.031,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 104.94,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 106.231,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.044,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 107.232,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 108.572,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 109.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.646,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 108.428,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 109.18,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 109.707,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 109.99,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 109.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 110.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 111.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 111.49,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 112.604,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 115.272,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 115.092,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 116.39,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 117.54,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 118.961,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 120.129,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 122.386,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 123.107,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 123.308,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 124.04,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 125.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 126.301,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 127.65,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 129.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 131.739,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 133.131,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 133.922,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 134.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 135.666,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 137.136,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 138.343,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 139.44,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 139.961,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 139.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 141.255,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 142.273,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 143.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.52,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.163,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 144.293,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 144.683,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.615,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 148.415,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 145.764,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 146.366,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 147.553,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 148.222,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 148.272,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 151.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 149.944,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 150.373,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 151.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 152.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 152.387,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 152.474,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 152.199,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.592,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.206,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 156.753,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 157.02,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 157.378,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 157.659,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 158.097,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 157.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 158.841,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 159.672,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 159.219,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 160.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 164.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.085,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 164.346,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 161.964,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-matamoros",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100.031,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 102.267,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.96,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.393,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.459,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.3,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.268,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.977,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.35,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.477,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.919,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.491,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.721,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.08,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.977,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.778,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.208,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 113.871,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 113.898,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 114.308,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.867,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.15,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.89,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.558,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.227,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.306,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.82,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.966,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.66,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.722,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.236,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 125.261,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 126.368,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.961,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.761,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 128.641,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 131.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.115,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 134.633,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.153,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.598,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 141.056,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.789,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 142.078,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 142.907,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 143.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 143.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 144.487,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.222,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 147.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 146.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 146.746,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 147.386,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.215,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 147.323,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 148.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 149.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 151.496,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 151.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 152.213,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 153.055,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 154.522,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 155.593,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 157.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 158.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 158.498,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 159.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 161.418,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 161.695,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 160.977,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 160.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 160.63,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 162.664,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 164.882,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 164.707,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 165.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 166.889,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 167.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 167.337,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 166.89,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 167.115,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 167.348,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 166.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 167.888,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 170.159,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 170.36,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 167.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-merida",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.844,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.9,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.381,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.04,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.75,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.36,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.47,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.961,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.854,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.307,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 106.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.539,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.686,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.9,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.521,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.805,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.442,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 111.649,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 111.816,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 112.583,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.323,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.301,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.41,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.26,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 118.588,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 119.858,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 119.522,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 120.598,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 121.464,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 122.988,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 124.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.731,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 128.462,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 130.749,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.201,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.173,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 135.735,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.412,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 139.104,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 140.542,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 142.449,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 143.318,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.946,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 144.652,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 144.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 145.39,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 146.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 146.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.478,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 147.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 148.726,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 150.142,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 152.25,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 152.964,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 152.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 152.738,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 153.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 154.72,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 155.408,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 155.024,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 154.905,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 156.036,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.991,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.874,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 157.173,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 157.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 158.144,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.993,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 159.372,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 159.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 158.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.605,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 158.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 163.144,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 163.85,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 164.812,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.664,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 166.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 165.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-mexicali",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100.004,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.922,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.744,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.445,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.994,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.61,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 105.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 105.025,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.825,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.984,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.867,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.803,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 104.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.279,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.616,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.501,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.411,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.759,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.803,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 113.036,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.187,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.899,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.5,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.649,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.413,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 115.357,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.73,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.741,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.305,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.771,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 126.305,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 128.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.306,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.091,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 130.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 132.639,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 133.152,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 135.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 139.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.094,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 142.126,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 142.599,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 142.775,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 143.233,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.528,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 143.596,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 143.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 144.046,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.234,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.157,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 145.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 145.55,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 149.595,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 150.135,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 149.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 149.639,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 149.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 148.786,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 150.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 150.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 150.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 152.338,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.361,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 154.293,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 155.647,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 155.618,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 156.539,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 157.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 157.237,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 158.064,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 158.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 159.034,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 158.493,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.867,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.781,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 158.684,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 159.53,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 161.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 164.293,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.495,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 164.024,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 161.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-monclova",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.861,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.708,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 102.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.545,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.348,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.346,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.999,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.324,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.306,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.884,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.284,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.296,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.822,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.678,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.893,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.032,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.996,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.274,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 110.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.06,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.174,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.481,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.051,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.396,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.188,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 117.94,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.306,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.774,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.238,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.721,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 125.907,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 127.261,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.839,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.451,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.024,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.638,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 136.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 136.691,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 136.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 136.431,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 136.777,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 136.922,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 137.136,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 137.489,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 137.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 138.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 138.91,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 139.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 141.222,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 141.601,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 141.34,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 142.397,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 143.25,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 143.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 143.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 144.112,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 144.204,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 144.24,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 146.542,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 147.597,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 148.221,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 149.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 150.254,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 149.71,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 150.043,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 150.004,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 150.572,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 152.022,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 154.311,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 155.07,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 155.586,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 155.853,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 155.694,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 155.943,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 156.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 157.763,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 158.392,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 159.455,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 161.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 163.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 162.711,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 161.049,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-monterrey",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.545,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.265,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 99.785,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 100.977,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.63,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.424,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.592,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 101.895,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 102.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 102.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.528,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.676,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.532,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.498,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.223,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.277,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.361,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.515,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.61,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.12,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.31,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.724,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.105,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.121,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.333,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 115.495,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 116.468,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 117.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.439,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.753,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.157,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.049,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.47,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 128.848,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.626,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.997,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.671,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 135.919,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 136.578,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 137.885,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.451,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.233,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 139.903,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 140.484,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 141.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 141.378,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 142.583,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 143.252,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 143.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 144.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 144.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.053,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 148.535,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.991,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 148.476,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 149.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 149.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 150.124,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 152.768,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.446,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 153.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 155.89,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.147,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 155.571,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 156.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 157.497,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 159.189,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 159.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 160.318,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 161.243,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 161.806,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 162.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 163.245,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 164.139,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 164.633,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 165.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 167.009,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 167.577,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 168.171,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 166.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-morelia",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.731,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.1,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 99.998,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 99.876,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 100.463,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 101.826,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 102.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 100.684,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 100.557,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 100.755,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 101.793,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.031,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.3,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 103.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 103.637,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 104.973,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.086,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.251,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 108.181,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 109.289,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.304,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.741,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.093,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 111.812,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 111.5,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 110.825,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 111.895,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 115.953,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.854,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.869,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.394,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.966,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.176,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.596,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.15,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 126.913,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 131.265,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 134.375,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.556,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.054,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 139.467,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 140.449,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 141.957,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 142.995,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 143.437,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.487,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 144.077,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 144.08,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 144.648,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 146.529,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 148.279,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 148.83,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 149.086,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 149.206,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 151.502,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 153.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 150.7,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 150.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 151.882,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 152.949,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 153.876,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 158.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 157.699,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 155.225,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 156.649,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.462,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.472,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 155.148,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 156.054,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 156.267,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 157.258,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 159.663,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 159.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 160.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 160.333,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 161.258,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.113,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 160.667,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 160.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 160.481,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 161.47,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 165.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 165.978,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 163.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-oaxaca",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.894,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.551,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.55,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.003,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.731,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.104,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.573,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.722,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.407,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.048,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.824,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 108.263,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.615,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.104,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.61,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 114.231,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.973,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.089,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.488,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.552,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.027,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.954,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.856,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 112.876,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.733,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.906,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 118.099,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.326,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.234,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.174,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 123.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 125.653,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 126.539,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.08,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 133.677,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 135.55,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 137.703,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 139.078,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 140.473,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 142.451,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 144.588,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 145.344,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 146.886,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 147.449,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.553,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.737,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 148.273,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.326,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 150.548,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 151.837,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 151.242,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 151.159,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 152.519,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 154.396,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 158.822,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 157.509,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 156.164,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 157.643,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 158.446,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 161.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 165.273,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 163.388,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 160.111,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 161.648,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 163.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 164.528,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 162.738,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 160.925,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 161.336,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 162.353,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 165.625,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 167.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 170.548,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 168.641,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 168.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 167.548,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 170.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 169.017,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 170.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 170.281,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 173.552,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 174.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 171.776,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 170.342,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-pachuca",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.058,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.337,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.911,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.625,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.2,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.561,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.449,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.674,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.234,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.337,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.08,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.085,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 111.112,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.907,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.894,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.891,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.607,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 111.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 111.714,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.068,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.564,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.985,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.415,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.976,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 117.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.111,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.719,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.768,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.238,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.551,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.343,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.467,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.833,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.066,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 136.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.49,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 141.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.636,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 142.969,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.557,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.103,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 147.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.378,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 150.08,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 151.681,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 151.917,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 150.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 151.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 154.625,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 157.503,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 154.526,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 155.319,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 157.934,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 158.057,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 160.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 162.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 159.778,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 157.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 159.249,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 159.899,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 160.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 159.606,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 158.672,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 159.667,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 161.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 166.124,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 165.677,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 165.03,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 163.711,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 163.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 162.872,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 164.926,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 164.402,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 165.613,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 167.017,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.384,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 170.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 169.085,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 165.161,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-puebla",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.711,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.306,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.526,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 104.046,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 105.326,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.206,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.034,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.669,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.294,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.737,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.805,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.826,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.319,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 108.189,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.808,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 111.928,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 112.002,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.628,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.963,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.885,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.329,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.277,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.084,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.099,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.603,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.341,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.212,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.767,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.195,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.465,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.76,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.364,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.462,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.872,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.996,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.1,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.425,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 136.532,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 137.534,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.027,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.801,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 144.432,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 146.554,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 147.072,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 146.277,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 146.225,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 146.548,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 148.252,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 149.199,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 148.501,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 150.506,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 153.918,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 157.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 153.255,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 153.309,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 156.159,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.886,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 157.172,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 160.656,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 158.442,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 157.024,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 159.277,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 159.778,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 159.465,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 158.904,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 158.253,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 158.991,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 159.997,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 162.104,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 162.725,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 162.106,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 160.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 161.264,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 160.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 162.355,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 162.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 164.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 166.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 171.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 171.098,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 169.666,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 164.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-queretaro",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100.135,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.447,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.173,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.952,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 106.212,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.711,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.391,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.029,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.828,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.558,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.095,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.403,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 106.18,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.924,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 108.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.477,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.397,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.953,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.847,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.427,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.944,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.257,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.224,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.611,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.861,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.235,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.191,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.151,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.77,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.608,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.103,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 126.712,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 127.45,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 127.722,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 130.067,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.265,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 133.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 135.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 135.829,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 136.909,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.198,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.511,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 139.803,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 140.614,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 140.527,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 140.211,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 141.992,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 143.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 143.597,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 142.913,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 144.396,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 145.891,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 148.137,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 146.231,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 146.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 148.21,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 149.625,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 150.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 152.153,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 151.375,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 149.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 152.155,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 153.545,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 153.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 153.158,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 153.138,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 155.023,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 157.109,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 158.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 160.157,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 159.645,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 158.595,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 158.979,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 160.953,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 160.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 160.373,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 162.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 166.391,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 167.386,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 165.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-saltillo",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.692,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.943,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.818,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.819,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.717,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.314,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.041,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.13,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.604,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.559,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.856,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.167,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.426,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.999,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.977,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.582,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.717,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.592,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.439,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.93,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.747,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.061,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.905,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.887,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.094,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.317,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.446,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.781,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.841,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 125.322,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.914,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 127.672,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 128.956,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 130.58,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 131.825,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 133.604,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 135.729,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.504,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.091,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.234,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 140.663,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 141.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 142.196,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 142.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.788,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 143.778,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 144.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 145.227,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 145.9,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 146.534,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 146.994,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 147.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 146.616,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 147.57,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 149.758,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 150.218,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 150.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 151.14,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 151.606,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 151.497,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 153.602,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.228,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 153.356,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 154.624,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 156.291,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 156.354,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.37,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 156.289,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 156.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 157.177,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.999,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 158.902,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 157.821,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 158.52,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 159.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.387,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 160.227,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 161.911,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 163.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 163.039,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 164.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.996,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 166.232,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 164.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-san-andres-tuxtla",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.872,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.813,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.266,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.423,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.826,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.666,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.388,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 105.124,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 106.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 106.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 107.469,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.218,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.731,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.995,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.602,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 108.516,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.047,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.474,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.148,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.552,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.331,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 114.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 114.434,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 115.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 115.188,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.79,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 116.215,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 116.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 117.088,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 119.531,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 121.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 121.49,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 122.354,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 123.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 124.26,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 123.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 127.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 128.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.449,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.824,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 134.198,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 135.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 138.1,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.462,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 140.438,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 143.059,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 144.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 145.569,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 146.172,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 148.472,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 148.509,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 148.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 150.63,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 150.683,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 150.465,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 151.564,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 153.553,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 154.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 153.291,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 154.303,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 155.791,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 160.72,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 155.478,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 157.011,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 159.225,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 160.353,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 160.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 164.381,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 163.14,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 160.51,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 162.072,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 164.402,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 164.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 165.36,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 161.854,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 162.199,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 164.177,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 168.772,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 167.596,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 167.597,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 165.443,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 165.552,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 163.795,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 165.919,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 165.618,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 167.423,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 168.982,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 173.332,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 172.465,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 175.761,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 170.105,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-san-luis-potosi",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.948,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 102.159,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.782,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 106.067,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 105.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 105.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 105.317,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 105.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 106.504,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 106.95,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 107.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 107.629,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.955,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 110.063,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.609,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.816,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.886,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.315,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.232,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 113.505,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 114.893,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 116.087,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 115.783,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 115.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 117.272,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 117.321,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 118.212,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 119.451,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 120.839,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 121.406,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 123.475,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 125.165,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 125.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 127.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 128.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 129.061,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 130.066,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 132.82,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 133.945,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 137.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.952,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 141.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 143.174,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.936,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 143.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 144.394,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 145.827,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 147.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.531,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 148.611,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.918,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 150.355,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 151.505,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 153.046,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 152.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 153.275,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 154.824,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 157.113,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 156.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 155.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 157.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 158.085,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 158.028,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 160.789,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 159.939,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 158.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 160.046,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 160.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 160.756,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 160.689,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 159.449,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 160.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 162.995,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 164.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 164.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 165.265,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 165.423,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 165.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 164.961,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 165.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 165.897,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 166.076,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 167.327,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.744,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 172.15,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 171.229,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 169.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-tampico",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.995,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.606,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.181,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 100.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.16,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 102.979,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.292,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 101.833,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 101.012,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 101.598,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 100.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 102.192,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 102.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 102.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 102.651,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 102.997,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 103.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 104.919,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 105.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 105.905,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 106.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 109.098,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 108.88,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 109.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 109.366,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 109.383,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 109.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 110.13,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 110.248,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 111.344,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 110.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 112.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 113.953,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 115.132,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.077,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 117.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.028,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.095,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 120.163,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 121.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 122.556,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 123.59,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 125.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 126.192,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 126.864,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 127.893,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 129.262,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 130.984,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 132.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 135.805,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 135.73,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 136.223,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 137.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 137.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 138.893,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 138.772,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 139.309,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 140.052,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 140.015,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 140.548,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 141.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 142.388,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 142.167,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 142.595,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 144.235,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 145.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 146.047,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 145.041,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 145.657,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 147.269,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 147.428,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 148.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 148.525,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 148.552,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 150.08,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 150.749,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 151.005,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 152.107,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 151.06,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 151.672,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 152.785,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 155.147,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 155.144,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 155.831,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 156.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.927,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 157.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 158.376,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 158.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 158.146,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 159.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 160.711,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 161.921,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 160.95,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 158.019,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-tapachula",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 99.857,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 99.638,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 99.733,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.134,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.515,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 102.806,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 101.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 101.797,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 102.823,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.442,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 102.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 102.261,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 103.323,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 104.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 104.428,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 105.579,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 104.858,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 106.615,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 108.191,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 108.255,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.908,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 109.626,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 109.746,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 109.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 109.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 111.109,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 111.566,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 110.031,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 111.33,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 114.513,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.803,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 114.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 115.541,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 116.346,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 117.482,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 118.242,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 118.526,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 120.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 122.7,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 122.927,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 123.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 126.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 128.702,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.834,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.694,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.527,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.706,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 136.864,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.157,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.156,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 140.701,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 141.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 142.394,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 143.26,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.678,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 144.249,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.136,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 146.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 148.473,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 149.755,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 152.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 155.782,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 153.285,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 153.896,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 154.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 153.818,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 154.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 155.951,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 156.656,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 155.865,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 156.806,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 157.738,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 159.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 159.997,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 158.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 158.613,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.785,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 161.821,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 163.97,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 164.082,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 164.595,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 162.408,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 160.979,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 162.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 163.523,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 163.887,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 164.608,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 165.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 166.896,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 165.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 164.523,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-tehuantepec",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.851,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 102.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 102.626,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.494,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.931,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.949,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.761,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 106.212,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 108.73,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 108.649,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 108.478,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 108.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 108.904,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 109.58,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 110.318,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 112.412,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 116.171,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 116.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 117.411,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 118.048,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 117.51,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 117.456,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 116.877,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 116.66,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 116.916,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 116.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 116.972,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 117.115,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 118.263,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.949,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.713,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.446,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.177,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.807,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.15,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.324,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.504,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 126.808,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.867,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 133.022,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 135.541,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 138.83,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 140.31,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 142.322,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 143.118,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 144.447,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 144.89,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 146.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 148.205,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 147.378,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 147.5,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.399,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 147.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 149.497,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 151.797,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 151.85,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 151.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 152.033,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 155.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 157.414,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 157.158,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 155.545,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 155.744,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 157.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 159.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 163.395,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 162.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 159.615,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 160.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 162.127,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 162.431,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 161.11,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 159.418,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 159.594,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 160.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 164.697,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 165.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 166.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 163.704,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 163.233,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 163.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 164.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 164.823,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 165.44,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 166.888,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 169.635,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 170.715,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 169.431,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 167.964,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-tepatitlan",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.968,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.667,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.737,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 99.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.879,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.688,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.278,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.172,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.417,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.028,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.413,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.729,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.646,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.33,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.907,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 110.027,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.403,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.012,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 108.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.124,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.117,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.092,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 116.116,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.968,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.893,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.777,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.188,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.699,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.313,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.003,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 126.178,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.376,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 129.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 131.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 132.805,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.887,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.162,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.449,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 141.525,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 141.517,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 142.77,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 143.474,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 144.059,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 144.351,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 144.51,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 145.747,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 146.338,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 147.098,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 148.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.446,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 149.881,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 150.091,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 150.874,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 155.478,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 154.007,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 153.479,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 153.894,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 154.541,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 154.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 157.735,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 157.416,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 156.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 156.932,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 157.39,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 158.288,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 158.614,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 158.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 158.37,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 160.608,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 160.719,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 162.241,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 163.622,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 165.107,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 165.102,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 165.143,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 166.193,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 167.363,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 169.766,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 170.82,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 173.952,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 174.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 176.299,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 172.597,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-tepic",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.696,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.597,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.781,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.446,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.939,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.323,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.198,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.202,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.506,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.69,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.316,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.505,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.132,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.541,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.161,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.238,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.226,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.037,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.451,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.094,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 111.843,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.617,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.318,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.064,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.651,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.808,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 116.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 117.634,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 120.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 120.805,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 122.807,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 123.974,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.648,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.383,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 128.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.147,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.591,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 130.611,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.076,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.503,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 136.675,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.921,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.306,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.593,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 140.966,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 142.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 143.4,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 143.516,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 143.925,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.621,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 145.461,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 147.363,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 147.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 148.129,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 149.46,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 151.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 149.657,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 150.164,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 150.492,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 150.871,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 151.222,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 154.697,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 153.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 154.54,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 154.545,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 155.356,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.363,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 155.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 156.474,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.712,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 160.013,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 161.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 161.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 161.553,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 162.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 162.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 162.756,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 164.053,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 166.204,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 168.077,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 171.453,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 171.349,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 167.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-tijuana",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.81,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.798,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.743,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 102.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.653,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.04,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.411,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.459,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 104.407,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.571,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 104.182,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.195,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 105.25,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 105.479,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.326,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.325,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.944,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.69,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.846,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 110.413,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.908,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 110.882,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.13,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.161,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.591,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.333,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.98,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 115.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 115.825,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.669,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.557,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 117.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.044,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.92,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.451,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.104,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 124.478,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 126.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 127.372,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.873,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 129.544,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 130.986,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.79,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.196,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.035,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.026,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 139.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 141.777,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 142.922,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 144.283,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 143.681,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 143.948,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 144.019,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 143.673,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 143.75,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 144.432,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 144.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 146.359,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 146.432,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 146.692,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 147.221,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 148.335,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 151.072,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 151.66,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 150.229,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 150.208,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 150.105,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 149.52,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 152.169,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 152.09,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 153.524,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 154.425,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 155.45,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 155.915,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 157.669,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 157.305,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 157.857,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 159.297,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 160.969,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 162.218,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 161.778,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 161.466,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 161.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 162.469,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 162.932,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 162.148,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 163.944,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 164.697,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 165.891,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 167.841,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 166.667,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 163.88,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-tlaxcala",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.9,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.955,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.402,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 104.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 105.667,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.522,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.959,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.996,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.242,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.445,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.109,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.579,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.602,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.187,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.384,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.293,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 109.336,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 112.146,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.929,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.269,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.691,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.599,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 111.573,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.722,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.159,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.354,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.307,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.561,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.599,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 119.529,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.381,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.141,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.823,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.032,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 128.632,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 128.442,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 127.862,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.231,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.821,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 134.359,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 135.982,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 137.476,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 139.266,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 140.786,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 142.191,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 143.28,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 145.417,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 147.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 148.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.783,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.27,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 147.321,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 146.901,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 148.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 150.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.987,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 149.164,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 151.799,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 154.374,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 159.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 153.626,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 153.2,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 156.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.458,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 157.105,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 160.938,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 157.878,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 155.192,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 159.213,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 159.917,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 159.004,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 156.569,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 156.524,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 157.382,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 158.996,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 163.235,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 162.907,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 163.889,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 162.079,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 160.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.386,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 161.542,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 161.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 160.985,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 164.298,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 170.039,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 168.877,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 167.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 160.562,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-toluca",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 99.657,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 99.19,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 100.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.521,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.907,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 101.61,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 102.704,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 102.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.911,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 103.366,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 102.618,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 102.183,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 102.107,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 103.166,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.093,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 106.639,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.827,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.983,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.058,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.549,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 110.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 109.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 110.099,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 110.429,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 110.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 110.558,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 111.978,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 111.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 113.105,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 114.734,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 116.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.639,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.011,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 119.271,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 119.94,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 120.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.561,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 122.002,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 122.833,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 123.294,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 125.413,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 127.9,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 129.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.966,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.761,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.812,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 136.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 136.56,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 137.919,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.756,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 140.119,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 140.225,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 139.917,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 141.16,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 141.41,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 140.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 142.847,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 142.979,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 143.24,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 141.782,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 142.792,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 145.185,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 147.759,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 143.62,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 144.587,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 147.994,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 149.318,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 149.126,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 152.112,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 149.386,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 149.254,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 151.054,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 152.11,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 151.459,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 150.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 149.602,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 151.981,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 154.025,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 156.904,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 156.088,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 156.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 155.905,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 155.296,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 153.602,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 156.689,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 157.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 157.644,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 159.554,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 163.295,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 161.611,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 161.086,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 158.302,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-torreon",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.501,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.956,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.972,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.476,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.164,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.228,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 104.539,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.598,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.499,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.886,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.076,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.249,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.89,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.364,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.781,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.932,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 113.552,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.218,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 113.567,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.929,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 114.518,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.636,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 115.019,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.872,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.788,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.268,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.195,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 117.238,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.586,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 122.858,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 124.373,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 126.43,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 127.31,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 126.818,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 128.17,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.299,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 131.774,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 134.406,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 135.612,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 137.903,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 141.05,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 143.433,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 144.362,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 144.398,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 144.186,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 146.239,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 147.209,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.698,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 146.01,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 145.91,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 146.231,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 146.658,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 148.087,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 148.585,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.691,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 149.053,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 149.674,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 151.653,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 153.543,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 152.389,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 153.064,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 155.078,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 155.318,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 155.653,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 158.371,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 156.704,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 156.653,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 157.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 158.032,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 157.629,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 158.347,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 159.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 161.839,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 161.674,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 162.016,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 161.984,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 162.81,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 164.221,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 165.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 165.129,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 165.978,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 166.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 169.259,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 170.777,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 172.227,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 173.276,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 171.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 169.844,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-tulancingo",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.529,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 99.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 99.016,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 99.747,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 103.216,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 104.925,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 105.194,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.533,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.822,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 105.204,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 105.142,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 106.208,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 106.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.781,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.005,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.416,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 104.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 105.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.367,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.665,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 111.134,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 112.042,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 112.998,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 114.282,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 114.122,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 116.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 115.224,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.879,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.568,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 114.875,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 116.537,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 116.889,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.573,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.038,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 118.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.481,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.556,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 120.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.593,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.167,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.672,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.043,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.547,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.726,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 133.865,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.615,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 136.303,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.48,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 138.821,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 138.67,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.601,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 139.448,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 140.75,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 142.036,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 141.776,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 141.941,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 143.068,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 143.036,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 144.997,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 145.402,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.021,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 144.065,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 143.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.971,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 148.727,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 145.99,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 145.467,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 147.88,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 149.154,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 150.161,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 153.339,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 152.396,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 149.452,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 150.642,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 151.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 149.472,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 148.719,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 148.345,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 148.955,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 150.36,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 154.427,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 156.246,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 155.527,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 155.006,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 153.741,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 153.204,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 154.443,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 155.2,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 155.243,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 156.565,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 158.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 158.13,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 156.385,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 153.76,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-tuxtla-gutierrez",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 101.146,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 101.193,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.89,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.913,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.178,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.355,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.217,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.95,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 104.034,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.916,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 104.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.338,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.512,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.517,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.441,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.224,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.158,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.061,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 106.627,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 107.844,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 108.81,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 109.731,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 110.869,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.646,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.144,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 111.912,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.314,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.439,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.168,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 113.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 115.526,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 117.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 117.961,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.88,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.301,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.627,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 122.272,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 122.826,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 124.056,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 123.652,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 124.968,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.837,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 128.828,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 130.628,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 132.329,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 135.171,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 136.97,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 138.985,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 140.066,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 139.372,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 139.678,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 140.019,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 142.805,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 143.587,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 144.765,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 145.38,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 145.663,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 146.614,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 147.781,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 148.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 149.186,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 149.182,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 149.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 150.774,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 153.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 152.104,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 151.656,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 152.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 152.29,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 153.175,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 156.742,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 156.445,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 153.886,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 153.958,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 155.427,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 154.836,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 154.418,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 153.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.468,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 154.334,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 157.809,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 160.167,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 161.924,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 160.507,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 158.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 159.12,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 159.556,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 159.147,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 160.489,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 162.025,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 166.22,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 166.04,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 165.608,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 162.114,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-veracruz",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.712,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.307,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.943,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.868,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 101.769,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 103.304,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 103.715,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.68,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.217,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.352,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 103.286,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.479,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 103.8,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.123,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 104.179,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 105.481,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 106.879,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.178,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 108.436,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 109.19,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 109.368,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 111.815,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 111.881,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 112.303,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 112.354,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 112.083,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 112.315,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 112.51,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 112.369,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 112.472,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 112.65,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 112.87,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 113.411,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 115.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 117.484,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 117.596,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 118.207,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 119.857,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 119.74,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 122.721,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.748,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 125.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 126.081,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 127.529,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 129.024,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.114,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 132.546,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.652,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 137.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 137.862,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 138.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 138.975,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 140.062,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 141.323,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 140.589,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 140.524,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 141.539,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 141.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 142.476,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.219,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 144.665,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 143.64,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 143.95,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 145.663,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 149.913,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 147.548,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 146.743,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 147.69,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 148.202,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 149.569,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 154.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 153.307,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 151.694,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 152.71,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 152.999,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 153.244,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 153.232,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 151.659,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 151.864,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 153.819,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 157.736,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 157.883,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 157.58,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 157.467,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 157.579,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 157.023,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 157.909,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 157.84,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 159.6,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 161.345,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 164.075,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 165.859,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 166.037,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 163.641,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-villahermosa",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 99.657,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.267,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.493,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 100.392,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 100.913,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 101.666,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 102.406,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 102.101,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 102.538,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.523,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.536,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.94,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.821,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.77,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 104.574,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.507,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.228,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.903,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 107.501,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 107.826,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 108.615,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 112.846,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 115.048,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 113.817,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 114.574,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 114.939,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.775,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 114.578,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 114.256,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 114.541,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 114.591,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.98,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 117.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.009,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 118.853,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 119.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 120.277,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 121.121,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 121.988,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 123.838,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 124.563,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 126.158,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 128.421,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.607,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 130.758,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 130.846,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 131.783,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 133.044,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 134.545,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 135.794,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 136.435,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 136.471,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 137.564,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 139.962,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 141.232,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 142.364,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 142.989,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 142.269,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 141.073,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 142.133,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 144.074,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 145.197,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 144.379,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 145.276,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 146.091,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 148.996,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 146.766,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 148.008,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 149.001,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 148.822,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 149.619,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 152.576,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 151.35,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 150.444,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 151.203,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 152.151,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 151.898,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 152.789,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 151.948,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 153.095,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 153.792,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 158.911,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 158.551,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 158.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 155.655,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 156.062,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 156.176,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 157.391,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 156.214,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 158.377,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 159.85,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 162.908,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 163.358,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 163.32,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 160.763,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    },
    {
      "placeId": "ciu-zacatecas",
      "kind": "alimentos",
      "unit": "indice",
      "indexBase": "segunda quincena de julio de 2018 = 100",
      "sourceId": "inegi-inpc-territorio",
      "points": [
        {
          "period": "2018-07",
          "value": 100,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-08",
          "value": 100.556,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-09",
          "value": 100.802,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-10",
          "value": 101.075,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-11",
          "value": 102.532,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2018-12",
          "value": 102.858,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-01",
          "value": 104.098,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-02",
          "value": 103.849,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-03",
          "value": 103.42,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-04",
          "value": 103.186,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-05",
          "value": 103.184,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-06",
          "value": 102.933,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-07",
          "value": 104.04,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-08",
          "value": 104.36,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-09",
          "value": 105.024,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-10",
          "value": 105.796,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-11",
          "value": 106.348,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2019-12",
          "value": 107.422,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-01",
          "value": 108.864,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-02",
          "value": 109.829,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-03",
          "value": 111.16,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-04",
          "value": 110.322,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-05",
          "value": 109.845,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-06",
          "value": 109.78,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-07",
          "value": 111.312,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-08",
          "value": 113.654,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-09",
          "value": 113.519,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-10",
          "value": 113.629,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-11",
          "value": 113.804,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2020-12",
          "value": 113.68,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-01",
          "value": 113.962,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-02",
          "value": 115.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-03",
          "value": 117.153,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-04",
          "value": 118.444,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-05",
          "value": 119.86,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-06",
          "value": 120.498,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-07",
          "value": 120.73,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-08",
          "value": 121.608,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-09",
          "value": 123.668,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-10",
          "value": 124.148,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-11",
          "value": 126.257,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2021-12",
          "value": 127.705,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-01",
          "value": 128.532,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-02",
          "value": 129.121,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-03",
          "value": 130.583,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-04",
          "value": 132.741,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-05",
          "value": 134.978,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-06",
          "value": 136.462,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-07",
          "value": 138.942,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-08",
          "value": 140.394,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-09",
          "value": 142.361,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-10",
          "value": 143.772,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-11",
          "value": 143.835,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2022-12",
          "value": 146.183,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-01",
          "value": 146.904,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-02",
          "value": 146.943,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-03",
          "value": 147.486,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-04",
          "value": 147.931,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-05",
          "value": 148.329,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-06",
          "value": 148.658,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-07",
          "value": 149.559,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-08",
          "value": 151.565,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-09",
          "value": 151.605,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-10",
          "value": 152.086,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-11",
          "value": 152.711,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2023-12",
          "value": 154.813,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-01",
          "value": 155.546,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-02",
          "value": 153.72,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-03",
          "value": 153.915,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-04",
          "value": 155.223,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-05",
          "value": 157.857,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-06",
          "value": 156.196,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-07",
          "value": 159.457,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-08",
          "value": 159.133,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-09",
          "value": 158.365,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-10",
          "value": 159.463,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-11",
          "value": 160.594,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2024-12",
          "value": 159.388,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-01",
          "value": 159.284,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-02",
          "value": 160.301,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-03",
          "value": 161.631,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-04",
          "value": 163.327,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-05",
          "value": 164.766,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-06",
          "value": 164.418,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-07",
          "value": 165.415,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-08",
          "value": 166.164,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-09",
          "value": 166.854,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-10",
          "value": 167.211,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-11",
          "value": 168.162,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2025-12",
          "value": 166.864,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-01",
          "value": 167.967,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-02",
          "value": 170.341,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-03",
          "value": 173.584,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-04",
          "value": 174.818,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-05",
          "value": 174.527,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        },
        {
          "period": "2026-06",
          "value": 172.868,
          "sourceId": "inegi-inpc-territorio",
          "confidence": "high"
        }
      ]
    }
  ],
  "wholesale": {
    "sourceId": "inegi-denue-mayoristas",
    "edition": "05_2026",
    "editionDate": "2026-05-20",
    "classes": [
      {
        "code": "431110",
        "label": "Comercio al por mayor de abarrotes",
        "short": "Abarrotes"
      },
      {
        "code": "431121",
        "label": "Comercio al por mayor de carnes rojas",
        "short": "Carnes rojas"
      },
      {
        "code": "431122",
        "label": "Comercio al por mayor de carne de aves",
        "short": "Aves"
      },
      {
        "code": "431123",
        "label": "Comercio al por mayor de pescados y mariscos",
        "short": "Pescados y mariscos"
      },
      {
        "code": "431130",
        "label": "Comercio al por mayor de frutas y verduras frescas",
        "short": "Frutas y verduras"
      },
      {
        "code": "431140",
        "label": "Comercio al por mayor de huevo",
        "short": "Huevo"
      },
      {
        "code": "431150",
        "label": "Comercio al por mayor de semillas y granos alimenticios",
        "short": "Semillas y granos"
      },
      {
        "code": "431160",
        "label": "Comercio al por mayor de leche y otros productos lácteos",
        "short": "Lácteos"
      },
      {
        "code": "431170",
        "label": "Comercio al por mayor de embutidos",
        "short": "Embutidos"
      },
      {
        "code": "431191",
        "label": "Comercio al por mayor de pan y pasteles",
        "short": "Pan y pasteles"
      },
      {
        "code": "431193",
        "label": "Comercio al por mayor de conservas alimenticias",
        "short": "Conservas"
      },
      {
        "code": "431199",
        "label": "Comercio al por mayor de otros alimentos",
        "short": "Otros alimentos"
      },
      {
        "code": "431211",
        "label": "Comercio al por mayor de bebidas no alcohólicas y hielo",
        "short": "Bebidas no alcohólicas"
      }
    ],
    "states": [
      {
        "stateCode": "09",
        "stateName": "Ciudad de México",
        "total": 2431,
        "volume": 618,
        "inCentral": 1360,
        "byClass": {
          "431110": 413,
          "431121": 118,
          "431122": 86,
          "431123": 136,
          "431130": 1032,
          "431140": 66,
          "431150": 179,
          "431160": 138,
          "431170": 21,
          "431191": 28,
          "431193": 35,
          "431199": 71,
          "431211": 108
        }
      },
      {
        "stateCode": "14",
        "stateName": "Jalisco",
        "total": 2082,
        "volume": 609,
        "inCentral": 54,
        "byClass": {
          "431110": 384,
          "431121": 104,
          "431122": 51,
          "431123": 56,
          "431130": 784,
          "431140": 36,
          "431150": 243,
          "431160": 154,
          "431170": 30,
          "431191": 36,
          "431193": 30,
          "431199": 53,
          "431211": 121
        }
      },
      {
        "stateCode": "15",
        "stateName": "México",
        "total": 1911,
        "volume": 531,
        "inCentral": 418,
        "byClass": {
          "431110": 508,
          "431121": 152,
          "431122": 109,
          "431123": 9,
          "431130": 437,
          "431140": 115,
          "431150": 93,
          "431160": 167,
          "431170": 24,
          "431191": 54,
          "431193": 24,
          "431199": 70,
          "431211": 149
        }
      },
      {
        "stateCode": "21",
        "stateName": "Puebla",
        "total": 1481,
        "volume": 318,
        "inCentral": 426,
        "byClass": {
          "431110": 333,
          "431121": 77,
          "431122": 66,
          "431123": 8,
          "431130": 454,
          "431140": 129,
          "431150": 121,
          "431160": 49,
          "431170": 13,
          "431191": 23,
          "431193": 12,
          "431199": 47,
          "431211": 149
        }
      },
      {
        "stateCode": "16",
        "stateName": "Michoacán de Ocampo",
        "total": 1436,
        "volume": 422,
        "inCentral": 31,
        "byClass": {
          "431110": 231,
          "431121": 44,
          "431122": 38,
          "431123": 20,
          "431130": 765,
          "431140": 17,
          "431150": 86,
          "431160": 64,
          "431170": 11,
          "431191": 16,
          "431193": 9,
          "431199": 20,
          "431211": 115
        }
      },
      {
        "stateCode": "19",
        "stateName": "Nuevo León",
        "total": 1374,
        "volume": 448,
        "inCentral": 114,
        "byClass": {
          "431110": 265,
          "431121": 122,
          "431122": 169,
          "431123": 17,
          "431130": 444,
          "431140": 29,
          "431150": 93,
          "431160": 45,
          "431170": 39,
          "431191": 18,
          "431193": 15,
          "431199": 60,
          "431211": 58
        }
      },
      {
        "stateCode": "30",
        "stateName": "Veracruz de Ignacio de la Llave",
        "total": 1119,
        "volume": 365,
        "inCentral": 43,
        "byClass": {
          "431110": 329,
          "431121": 42,
          "431122": 66,
          "431123": 17,
          "431130": 253,
          "431140": 34,
          "431150": 75,
          "431160": 78,
          "431170": 17,
          "431191": 33,
          "431193": 5,
          "431199": 62,
          "431211": 108
        }
      },
      {
        "stateCode": "11",
        "stateName": "Guanajuato",
        "total": 1056,
        "volume": 353,
        "inCentral": 75,
        "byClass": {
          "431110": 227,
          "431121": 57,
          "431122": 31,
          "431123": 19,
          "431130": 325,
          "431140": 24,
          "431150": 129,
          "431160": 65,
          "431170": 18,
          "431191": 17,
          "431193": 9,
          "431199": 26,
          "431211": 109
        }
      },
      {
        "stateCode": "07",
        "stateName": "Chiapas",
        "total": 843,
        "volume": 198,
        "inCentral": 25,
        "byClass": {
          "431110": 244,
          "431121": 19,
          "431122": 32,
          "431123": 9,
          "431130": 133,
          "431140": 36,
          "431150": 139,
          "431160": 24,
          "431170": 7,
          "431191": 9,
          "431193": 8,
          "431199": 96,
          "431211": 87
        }
      },
      {
        "stateCode": "25",
        "stateName": "Sinaloa",
        "total": 789,
        "volume": 332,
        "inCentral": 50,
        "byClass": {
          "431110": 164,
          "431121": 45,
          "431122": 15,
          "431123": 77,
          "431130": 154,
          "431140": 16,
          "431150": 186,
          "431160": 35,
          "431170": 12,
          "431191": 9,
          "431193": 6,
          "431199": 32,
          "431211": 38
        }
      },
      {
        "stateCode": "26",
        "stateName": "Sonora",
        "total": 780,
        "volume": 262,
        "inCentral": 49,
        "byClass": {
          "431110": 205,
          "431121": 53,
          "431122": 9,
          "431123": 37,
          "431130": 186,
          "431140": 68,
          "431150": 71,
          "431160": 33,
          "431170": 13,
          "431191": 17,
          "431193": 9,
          "431199": 37,
          "431211": 42
        }
      },
      {
        "stateCode": "20",
        "stateName": "Oaxaca",
        "total": 734,
        "volume": 158,
        "inCentral": 22,
        "byClass": {
          "431110": 293,
          "431121": 21,
          "431122": 36,
          "431123": 9,
          "431130": 104,
          "431140": 30,
          "431150": 26,
          "431160": 44,
          "431170": 6,
          "431191": 16,
          "431193": 7,
          "431199": 60,
          "431211": 82
        }
      },
      {
        "stateCode": "08",
        "stateName": "Chihuahua",
        "total": 702,
        "volume": 291,
        "inCentral": 21,
        "byClass": {
          "431110": 221,
          "431121": 53,
          "431122": 6,
          "431123": 15,
          "431130": 134,
          "431140": 16,
          "431150": 85,
          "431160": 55,
          "431170": 16,
          "431191": 20,
          "431193": 5,
          "431199": 33,
          "431211": 43
        }
      },
      {
        "stateCode": "02",
        "stateName": "Baja California",
        "total": 693,
        "volume": 333,
        "inCentral": 50,
        "byClass": {
          "431110": 176,
          "431121": 52,
          "431122": 11,
          "431123": 60,
          "431130": 199,
          "431140": 9,
          "431150": 37,
          "431160": 25,
          "431170": 12,
          "431191": 16,
          "431193": 13,
          "431199": 40,
          "431211": 43
        }
      },
      {
        "stateCode": "24",
        "stateName": "San Luis Potosí",
        "total": 609,
        "volume": 152,
        "inCentral": 246,
        "byClass": {
          "431110": 123,
          "431121": 31,
          "431122": 9,
          "431123": 4,
          "431130": 251,
          "431140": 10,
          "431150": 54,
          "431160": 28,
          "431170": 7,
          "431191": 9,
          "431193": 2,
          "431199": 27,
          "431211": 54
        }
      },
      {
        "stateCode": "13",
        "stateName": "Hidalgo",
        "total": 466,
        "volume": 111,
        "inCentral": 86,
        "byClass": {
          "431110": 136,
          "431121": 21,
          "431122": 22,
          "431123": 1,
          "431130": 87,
          "431140": 26,
          "431150": 37,
          "431160": 35,
          "431170": 3,
          "431191": 13,
          "431193": 2,
          "431199": 18,
          "431211": 65
        }
      },
      {
        "stateCode": "28",
        "stateName": "Tamaulipas",
        "total": 447,
        "volume": 164,
        "inCentral": 3,
        "byClass": {
          "431110": 106,
          "431121": 42,
          "431122": 5,
          "431123": 42,
          "431130": 62,
          "431140": 19,
          "431150": 81,
          "431160": 17,
          "431170": 11,
          "431191": 12,
          "431193": 3,
          "431199": 16,
          "431211": 31
        }
      },
      {
        "stateCode": "31",
        "stateName": "Yucatán",
        "total": 446,
        "volume": 159,
        "inCentral": 3,
        "byClass": {
          "431110": 104,
          "431121": 25,
          "431122": 28,
          "431123": 71,
          "431130": 84,
          "431140": 20,
          "431150": 14,
          "431160": 18,
          "431170": 12,
          "431191": 18,
          "431193": 3,
          "431199": 16,
          "431211": 33
        }
      },
      {
        "stateCode": "12",
        "stateName": "Guerrero",
        "total": 441,
        "volume": 122,
        "inCentral": 8,
        "byClass": {
          "431110": 129,
          "431121": 28,
          "431122": 26,
          "431123": 5,
          "431130": 52,
          "431140": 13,
          "431150": 44,
          "431160": 32,
          "431170": 3,
          "431191": 16,
          "431193": 1,
          "431199": 21,
          "431211": 71
        }
      },
      {
        "stateCode": "01",
        "stateName": "Aguascalientes",
        "total": 416,
        "volume": 110,
        "inCentral": 11,
        "byClass": {
          "431110": 65,
          "431121": 47,
          "431122": 13,
          "431123": 4,
          "431130": 160,
          "431140": 10,
          "431150": 36,
          "431160": 27,
          "431170": 5,
          "431191": 7,
          "431193": 5,
          "431199": 14,
          "431211": 23
        }
      },
      {
        "stateCode": "05",
        "stateName": "Coahuila de Zaragoza",
        "total": 415,
        "volume": 148,
        "inCentral": 43,
        "byClass": {
          "431110": 117,
          "431121": 27,
          "431122": 14,
          "431123": 9,
          "431130": 66,
          "431140": 16,
          "431150": 41,
          "431160": 31,
          "431170": 15,
          "431191": 10,
          "431193": 1,
          "431199": 18,
          "431211": 50
        }
      },
      {
        "stateCode": "17",
        "stateName": "Morelos",
        "total": 402,
        "volume": 102,
        "inCentral": 38,
        "byClass": {
          "431110": 100,
          "431121": 18,
          "431122": 13,
          "431130": 148,
          "431140": 15,
          "431150": 27,
          "431160": 26,
          "431170": 5,
          "431191": 6,
          "431199": 8,
          "431211": 36
        }
      },
      {
        "stateCode": "22",
        "stateName": "Querétaro",
        "total": 380,
        "volume": 108,
        "inCentral": 58,
        "byClass": {
          "431110": 71,
          "431121": 34,
          "431122": 20,
          "431123": 7,
          "431130": 106,
          "431140": 11,
          "431150": 24,
          "431160": 28,
          "431170": 6,
          "431191": 6,
          "431193": 10,
          "431199": 19,
          "431211": 38
        }
      },
      {
        "stateCode": "18",
        "stateName": "Nayarit",
        "total": 337,
        "volume": 106,
        "inCentral": 6,
        "byClass": {
          "431110": 64,
          "431121": 31,
          "431122": 12,
          "431123": 40,
          "431130": 81,
          "431140": 4,
          "431150": 22,
          "431160": 27,
          "431170": 4,
          "431191": 5,
          "431193": 3,
          "431199": 13,
          "431211": 31
        }
      },
      {
        "stateCode": "10",
        "stateName": "Durango",
        "total": 326,
        "volume": 116,
        "inCentral": 53,
        "byClass": {
          "431110": 92,
          "431121": 29,
          "431122": 8,
          "431123": 1,
          "431130": 56,
          "431140": 16,
          "431150": 50,
          "431160": 27,
          "431170": 3,
          "431191": 3,
          "431193": 3,
          "431199": 13,
          "431211": 25
        }
      },
      {
        "stateCode": "27",
        "stateName": "Tabasco",
        "total": 283,
        "volume": 109,
        "inCentral": 23,
        "byClass": {
          "431110": 106,
          "431121": 11,
          "431122": 18,
          "431123": 3,
          "431130": 42,
          "431140": 4,
          "431150": 25,
          "431160": 12,
          "431170": 6,
          "431191": 10,
          "431193": 3,
          "431199": 14,
          "431211": 29
        }
      },
      {
        "stateCode": "32",
        "stateName": "Zacatecas",
        "total": 282,
        "volume": 84,
        "inCentral": 21,
        "byClass": {
          "431110": 82,
          "431121": 13,
          "431122": 13,
          "431123": 3,
          "431130": 13,
          "431140": 7,
          "431150": 80,
          "431160": 26,
          "431170": 4,
          "431191": 6,
          "431193": 4,
          "431199": 3,
          "431211": 28
        }
      },
      {
        "stateCode": "23",
        "stateName": "Quintana Roo",
        "total": 264,
        "volume": 115,
        "inCentral": 10,
        "byClass": {
          "431110": 81,
          "431121": 15,
          "431122": 12,
          "431123": 19,
          "431130": 40,
          "431140": 9,
          "431150": 2,
          "431160": 21,
          "431170": 7,
          "431191": 13,
          "431193": 5,
          "431199": 9,
          "431211": 31
        }
      },
      {
        "stateCode": "03",
        "stateName": "Baja California Sur",
        "total": 218,
        "volume": 92,
        "inCentral": 2,
        "byClass": {
          "431110": 49,
          "431121": 22,
          "431122": 4,
          "431123": 27,
          "431130": 47,
          "431140": 8,
          "431150": 6,
          "431160": 11,
          "431170": 4,
          "431191": 8,
          "431193": 5,
          "431199": 14,
          "431211": 13
        }
      },
      {
        "stateCode": "06",
        "stateName": "Colima",
        "total": 174,
        "volume": 69,
        "inCentral": 1,
        "byClass": {
          "431110": 41,
          "431121": 8,
          "431122": 2,
          "431123": 11,
          "431130": 50,
          "431140": 3,
          "431150": 8,
          "431160": 19,
          "431170": 4,
          "431191": 5,
          "431199": 4,
          "431211": 19
        }
      },
      {
        "stateCode": "04",
        "stateName": "Campeche",
        "total": 167,
        "volume": 52,
        "inCentral": 0,
        "byClass": {
          "431110": 36,
          "431121": 14,
          "431122": 6,
          "431123": 17,
          "431130": 19,
          "431140": 9,
          "431150": 12,
          "431160": 13,
          "431170": 2,
          "431191": 8,
          "431193": 1,
          "431199": 11,
          "431211": 19
        }
      },
      {
        "stateCode": "29",
        "stateName": "Tlaxcala",
        "total": 150,
        "volume": 38,
        "inCentral": 0,
        "byClass": {
          "431110": 56,
          "431121": 5,
          "431122": 15,
          "431130": 6,
          "431140": 15,
          "431150": 18,
          "431160": 9,
          "431170": 3,
          "431191": 3,
          "431193": 1,
          "431199": 4,
          "431211": 15
        }
      }
    ],
    "hubs": [
      {
        "id": "09-007",
        "stateCode": "09",
        "stateName": "Ciudad de México",
        "municipality": "Iztapalapa",
        "markets": [
          "CENTRAL DE ABASTOS CDMX",
          "CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTOS LA NUEVA VIGA",
          "ABARROTES Y VIVERES",
          "CENTRAL DE ABASTOS FLORES Y HORTALIZAS",
          "PUNTO FRESCO FRUTAS Y VERDURAS",
          "CENTRAL DE ABASTO FLORES Y HORTALIZAS",
          "CENTRAL DE ABASTO CDMX",
          "CENTRAL DE ABASTO DE LA CIUDAD DE MEXICO",
          "CENTRAL DE ABASTOS FRUTAS Y LEGUMBRES",
          "HORTALIZAS Y SUBASTA",
          "CENTRAL DE ABASTOS DE LA CIUDAD DE MEXICO",
          "CENTRAL DE ABASTO",
          "CENTRAL DE ABASTO DE LA CIUDAD DE MÉXICO",
          "CEDA",
          "LA NUEVA VIGA",
          "SIN NOMBRE",
          "CENTRAL DE ABASTOS DE LA CIUDAD DE MÉXICO",
          "CENTRAL DE ABASTOS IZTAPALAPA CIUDAD DE MEXICO",
          "MERCADO",
          "AREA FERAL CENTRAL DE ABASTOS",
          "CENTRAL DE PESCADOS Y MARISCOS LA NUEVA VIGA",
          "IZTAALAPA",
          "MERCADO DE AVES YCARNICOS",
          "ZONA AREA FEDERAL CENTRAL DE ABASTOS",
          "AREA FEDERAL CENTRAL DE ABASTOS",
          "BODEGA DE FRIGORIFICOS",
          "CENTRAL DE ABASTO IZTAPALA CIUDAD DE MEXICO",
          "CENTRAL DE ABASTO LA NUEVA VIGA",
          "CENTRAL DE ABASTOS IZTAPALAPA",
          "LA NUEVA VIGA CENTRAL DE ABASTOS DE LA CIUDAD DE MXICO"
        ],
        "total": 1359,
        "volume": 213,
        "byClass": {
          "431110": 110,
          "431121": 10,
          "431122": 10,
          "431123": 122,
          "431130": 943,
          "431140": 29,
          "431150": 92,
          "431160": 25,
          "431170": 3,
          "431193": 1,
          "431199": 4,
          "431211": 10
        }
      },
      {
        "id": "15-106",
        "stateCode": "15",
        "stateName": "México",
        "municipality": "Toluca",
        "markets": [
          "CENTRAL DE ABASTO TOLUCA",
          "CENTRAL DE ABASTOS",
          "MANOJEO",
          "CENABASTO",
          "CENTRAL DE ABASTOS TOLUCA",
          "SIN NOMBRE",
          "CENABASTO TOLUCA"
        ],
        "total": 341,
        "volume": 16,
        "byClass": {
          "431110": 6,
          "431121": 2,
          "431122": 7,
          "431130": 307,
          "431140": 9,
          "431150": 3,
          "431160": 4,
          "431170": 1,
          "431199": 1,
          "431211": 1
        }
      },
      {
        "id": "21-144",
        "stateCode": "21",
        "stateName": "Puebla",
        "municipality": "San Salvador Huixcolotla",
        "markets": [
          "BENITO JUAREZ",
          "UNION BENITO JUAREZ",
          "BENITO JUEREZ",
          "CENTRAL BENITO JUAREZ",
          "CENTRAL DE ABASTOS AREA DE COLES",
          "CENTRAL DE ABASTOS AREA DE CHILES VERDES Y SEMILLAS",
          "BENITO JUAREZ HUIXCOLOTLA",
          "CENTRAL DE ABASTOS AREA DE LECHUGAS",
          "CENTRAL DE ABASTOS AREA DE PEPINOS Y TOMATES",
          "UNION DE PRODUCTORES Y COMERCIANTES BENITO JUAREZ",
          "CENTRAL DE ABASTOS AREA DE LEGUMBRES Y HIERVAS",
          "CENTRAL DE BASTOS"
        ],
        "total": 251,
        "volume": 0,
        "byClass": {
          "431110": 8,
          "431122": 1,
          "431130": 215,
          "431140": 14,
          "431150": 10,
          "431211": 3
        }
      },
      {
        "id": "24-028",
        "stateCode": "24",
        "stateName": "San Luis Potosí",
        "municipality": "San Luis Potosí",
        "markets": [
          "CENTRAL DE ABASTOS",
          "ABASTOS",
          "CENTRAL DE ABASTO",
          "SIN NOMBRE",
          "ESTRELLA DE ORIENTE CENTRAL DE ABASTOS",
          "ABASTOS SAN LUIS",
          "CENTRO DE ABASTOS SAN LUIS POTOSI",
          "CENTRAL DE ABASTOS B. ANAYA"
        ],
        "total": 246,
        "volume": 20,
        "byClass": {
          "431110": 16,
          "431121": 1,
          "431130": 209,
          "431140": 1,
          "431150": 15,
          "431199": 1,
          "431211": 3
        }
      },
      {
        "id": "21-114",
        "stateCode": "21",
        "stateName": "Puebla",
        "municipality": "Puebla",
        "markets": [
          "CENTRAL DE ABASTO DE PUEBLA A C E",
          "CENTRAL DE ABASTO DE PUEBLA A C B",
          "CENTRAL DE ABASTO DE PUEBLA A C D",
          "CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTO DE PUEBLA A C C",
          "CABECERA PONIETE",
          "CENTRAL DE ABASTOS PUEBLA",
          "NAVE E",
          "AREA 4 NAVE D",
          "LA GRAN BODEGA",
          "NAVE B",
          "NAVE A",
          "NAVE A CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTO PUEBLA",
          "CENTRAL DE ABAST0",
          "CENTRAL DE ABASTOS DE PUEBLA",
          "CENTRAL DE ABASTO PUEBLA NAVE E",
          "SIN NOMBRE",
          "DE PUEBLA",
          "CENTRAL DE ABASTO 2DA SECCION NAVE B",
          "CENTRAL DE ABASTO",
          "NAVE F G",
          "HERRADURA CHICA",
          "SEGUNDA SECCION CENTRAL DE ABASTOS"
        ],
        "total": 175,
        "volume": 16,
        "byClass": {
          "431110": 16,
          "431121": 5,
          "431122": 4,
          "431130": 115,
          "431140": 16,
          "431150": 9,
          "431160": 4,
          "431170": 1,
          "431199": 1,
          "431211": 4
        }
      },
      {
        "id": "19-046",
        "stateCode": "19",
        "stateName": "Nuevo León",
        "municipality": "San Nicolás de los Garza",
        "markets": [
          "MERCADO DE ABASTOS ESTRELLA",
          "CENTRAL DE ABASTOS ESTRELLA",
          "SIN NOMBRE",
          "MERCADO DE ABASTOS ESTRESLLA",
          "MERCADO DE ABSTOS ESTRELLA",
          "MERCADO ESTRELLA",
          "LA ESTRELLA",
          "MERCADO DE ABASTOS",
          "ESTRELLA"
        ],
        "total": 96,
        "volume": 47,
        "byClass": {
          "431110": 7,
          "431121": 2,
          "431122": 1,
          "431130": 66,
          "431140": 7,
          "431150": 11,
          "431170": 1,
          "431199": 1
        }
      },
      {
        "id": "11-017",
        "stateCode": "11",
        "stateName": "Guanajuato",
        "municipality": "Irapuato",
        "markets": [
          "CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTOS LA NUMERO 1",
          "LA VENTA",
          "SIN NOMBRE",
          "IRAPUATO"
        ],
        "total": 61,
        "volume": 8,
        "byClass": {
          "431110": 4,
          "431130": 54,
          "431140": 2,
          "431150": 1
        }
      },
      {
        "id": "22-014",
        "stateCode": "22",
        "stateName": "Querétaro",
        "municipality": "Querétaro",
        "markets": [
          "CENTRAL DE ABASTOS QUERETARO",
          "PLAZA SAN JOSE",
          "MERCADO DE ABASTOS ACCESO B C"
        ],
        "total": 58,
        "volume": 4,
        "byClass": {
          "431110": 3,
          "431121": 2,
          "431130": 49,
          "431150": 4
        }
      },
      {
        "id": "15-033",
        "stateCode": "15",
        "stateName": "México",
        "municipality": "Ecatepec de Morelos",
        "markets": [
          "CENTRAL DE ABASTOS ECATEPEC",
          "CENTRAL DE ABASTO ECATEPEC",
          "LA CENTRALITA",
          "CEDA ECATEPEC",
          "CENTRAL DE ABASTOS",
          "SIN NOMBRE",
          "CENTRAL DE ABASTOS NAVE A",
          "CENTRAL DE ABASTOS DE ECATEPEC",
          "VENTA DE CARPIO"
        ],
        "total": 56,
        "volume": 25,
        "byClass": {
          "431110": 14,
          "431121": 2,
          "431122": 2,
          "431130": 21,
          "431140": 4,
          "431150": 4,
          "431160": 8,
          "431211": 1
        }
      },
      {
        "id": "14-039",
        "stateCode": "14",
        "stateName": "Jalisco",
        "municipality": "Guadalajara",
        "markets": [
          "MERCADO DE ABASTOS",
          "PLAZA ABASTOS",
          "MERCADO FELIPE ANGELES",
          "CENTRAL DE ABASTOS",
          "SIN NOMBRE",
          "MERCADO DE ABASTOS GUADALAJARA",
          "CENTRO COMERCIAL ABASTOS",
          "MERCADO DEL MAR"
        ],
        "total": 54,
        "volume": 21,
        "byClass": {
          "431110": 8,
          "431122": 3,
          "431123": 1,
          "431130": 30,
          "431140": 1,
          "431150": 7,
          "431160": 3,
          "431193": 1
        }
      },
      {
        "id": "13-048",
        "stateCode": "13",
        "stateName": "Hidalgo",
        "municipality": "Pachuca de Soto",
        "markets": [
          "CENTRAL DE ABASTOS PACHUCA",
          "CENTRAL DE ABASTOS"
        ],
        "total": 53,
        "volume": 1,
        "byClass": {
          "431110": 4,
          "431121": 1,
          "431122": 2,
          "431130": 33,
          "431140": 2,
          "431150": 3,
          "431160": 4,
          "431211": 4
        }
      },
      {
        "id": "02-004",
        "stateCode": "02",
        "stateName": "Baja California",
        "municipality": "Tijuana",
        "markets": [
          "CENTRAL DE ABASTOS",
          "LOS ALAMOS",
          "FABRICAS Y BODEGA S.C",
          "MERCADO DE ABASTOS",
          "MERCADO DE ABASTOS TIJUANA",
          "MERCADO DE ABASTO",
          "HOSPITAL NOVA",
          "MERCADO HIDALGO"
        ],
        "total": 43,
        "volume": 9,
        "byClass": {
          "431110": 6,
          "431130": 30,
          "431150": 4,
          "431170": 3
        }
      },
      {
        "id": "05-035",
        "stateCode": "05",
        "stateName": "Coahuila de Zaragoza",
        "municipality": "Torreón",
        "markets": [
          "MERCADO DE ABASTOS",
          "MERCADO DE ABASTOS DE LA LAGUNA",
          "ABASTOS DE LA LAGUNA"
        ],
        "total": 39,
        "volume": 17,
        "byClass": {
          "431110": 4,
          "431121": 4,
          "431122": 1,
          "431130": 23,
          "431140": 3,
          "431150": 1,
          "431160": 1,
          "431170": 2
        }
      },
      {
        "id": "26-030",
        "stateCode": "26",
        "stateName": "Sonora",
        "municipality": "Hermosillo",
        "markets": [
          "MERCADO DE ABASTOS OLIMPICO",
          "FRANCISCO I. MADERO DE HERMOSILLO A.C",
          "FRANCISCO I MADERO",
          "FRANCISCO Y MADERO",
          "CENTRAL DE ABASTOS",
          "FRANCISCO I. MADERO",
          "CENTRAL DE ABASTO",
          "CENTRAL DE ABASTOS FRANCISCO I. MADERO"
        ],
        "total": 36,
        "volume": 9,
        "byClass": {
          "431110": 2,
          "431121": 2,
          "431122": 2,
          "431130": 23,
          "431140": 3,
          "431150": 2,
          "431160": 1,
          "431193": 1
        }
      },
      {
        "id": "10-007",
        "stateCode": "10",
        "stateName": "Durango",
        "municipality": "Gómez Palacio",
        "markets": [
          "GOMEZ PALACIO",
          "CENTRAL DE ABASTOS",
          "ABASTOS GOMEZ",
          "CENTRAL DE ABASTOS GÓMEZ PALACIO",
          "MERCADO DE ABASTOS DE LA LAGUNA"
        ],
        "total": 32,
        "volume": 14,
        "byClass": {
          "431110": 5,
          "431121": 6,
          "431130": 8,
          "431140": 6,
          "431150": 4,
          "431160": 3
        }
      },
      {
        "id": "13-077",
        "stateCode": "13",
        "stateName": "Hidalgo",
        "municipality": "Tulancingo de Bravo",
        "markets": [
          "LOS SANTANEROS",
          "SECCION A",
          "SECCION D",
          "SEGUNDA SECCION",
          "BODEGAS C",
          "CENTRAL DE ABASTOS BODEGAS C",
          "CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTOS TULANCINGO",
          "CENTRAL DE ABASTO TULANCINGO"
        ],
        "total": 30,
        "volume": 1,
        "byClass": {
          "431110": 3,
          "431130": 25,
          "431150": 2
        }
      },
      {
        "id": "25-001",
        "stateCode": "25",
        "stateName": "Sinaloa",
        "municipality": "Ahome",
        "markets": [
          "LA YARDA",
          "CENTRAL DE ABASTO",
          "LA YARDA GRANDE",
          "SIN NOMBRE"
        ],
        "total": 28,
        "volume": 4,
        "byClass": {
          "431110": 1,
          "431121": 1,
          "431130": 23,
          "431150": 2,
          "431199": 1
        }
      },
      {
        "id": "17-006",
        "stateCode": "17",
        "stateName": "Morelos",
        "municipality": "Cuautla",
        "markets": [
          "CENTRAL DE ABASTO CUAUTLA",
          "CENTRAL DE ABASTO",
          "CUAUTLA",
          "CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTOS CUAUTLA",
          "PLAZA 12 DE OCTUBRE",
          "PLAZA AHORRA TODO"
        ],
        "total": 23,
        "volume": 9,
        "byClass": {
          "431110": 8,
          "431140": 3,
          "431150": 4,
          "431160": 4,
          "431211": 4
        }
      },
      {
        "id": "27-004",
        "stateCode": "27",
        "stateName": "Tabasco",
        "municipality": "Centro",
        "markets": [
          "CENTRAL DE ABASTO VILLAHERMOSA",
          "CENTRAL DE ABASTO",
          "BODEGA",
          "NAVE 2"
        ],
        "total": 23,
        "volume": 3,
        "byClass": {
          "431110": 3,
          "431130": 19,
          "431140": 1
        }
      },
      {
        "id": "20-067",
        "stateCode": "20",
        "stateName": "Oaxaca",
        "municipality": "Oaxaca de Juárez",
        "markets": [
          "CENTRAL DE ABASTOS",
          "ZONA COMERCIAL CENTRAL DE BASTOS",
          "CENTRAL DE ABASTOS OAXACA ZONA SECA",
          "ZONA COMERCIAL CENTRAL DE ABASTOS",
          "MÓDULOS DE LA CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTO ZONA HUMEDA",
          "CENTRAL DE ABASTO"
        ],
        "total": 22,
        "volume": 3,
        "byClass": {
          "431110": 5,
          "431121": 1,
          "431140": 1,
          "431150": 1,
          "431160": 2,
          "431193": 1,
          "431199": 11
        }
      },
      {
        "id": "07-101",
        "stateCode": "07",
        "stateName": "Chiapas",
        "municipality": "Tuxtla Gutiérrez",
        "markets": [
          "NAVE 1",
          "NAVE 2",
          "NAVE 7",
          "NAVE 6",
          "CENTRAL DE ABASTOS DE TUXTLA GUITIERRREZ",
          "NAVE 4",
          "CENTRAL DE ABASTOS TUXTLA",
          "CENTRAL DE ABASTOS"
        ],
        "total": 21,
        "volume": 8,
        "byClass": {
          "431110": 10,
          "431121": 1,
          "431122": 1,
          "431130": 3,
          "431140": 5,
          "431160": 1
        }
      },
      {
        "id": "10-005",
        "stateCode": "10",
        "stateName": "Durango",
        "municipality": "Durango",
        "markets": [
          "FRANCISCO VILLA",
          "CENTRAL DE ABASTOS EL REFUGIO",
          "MERCADO DE ABASTOS FRANCISCO VILLA",
          "MERCADO DE ABASTOS FRANCSICO VILLA"
        ],
        "total": 21,
        "volume": 8,
        "byClass": {
          "431110": 6,
          "431121": 1,
          "431130": 9,
          "431140": 2,
          "431160": 2,
          "431211": 1
        }
      },
      {
        "id": "25-006",
        "stateCode": "25",
        "stateName": "Sinaloa",
        "municipality": "Culiacán",
        "markets": [
          "MERCADO DE ABASTOS",
          "SIN NOMBRE",
          "MERCADO DE ABASTOS CULIACAN",
          "MERCADO DE ABASTOS DE CULIACAN"
        ],
        "total": 20,
        "volume": 12,
        "byClass": {
          "431110": 1,
          "431121": 3,
          "431122": 2,
          "431123": 1,
          "431130": 9,
          "431140": 2,
          "431150": 1,
          "431160": 1
        }
      },
      {
        "id": "32-056",
        "stateCode": "32",
        "stateName": "Zacatecas",
        "municipality": "Zacatecas",
        "markets": [
          "MERCADO DE ABASTOS",
          "CENTRAL DE ABASTOS ZACATECAS",
          "MERCADO DE ABASTOS TIANGUIS SABATINO"
        ],
        "total": 17,
        "volume": 3,
        "byClass": {
          "431110": 4,
          "431121": 3,
          "431130": 4,
          "431140": 4,
          "431150": 2
        }
      },
      {
        "id": "19-026",
        "stateCode": "19",
        "stateName": "Nuevo León",
        "municipality": "Guadalupe",
        "markets": [
          "CENTRAL DE ABASTOS MONTERREY",
          "GUADALUPE",
          "SIN NOMBRE",
          "CENTRAL DE ABASTOS",
          "MERCADO DE ABASTOS",
          "CENTRAL DE ABASTOS GUADALUPE",
          "MONTERREY",
          "MERCADO DE ABASTOS GUADALUPE"
        ],
        "total": 16,
        "volume": 10,
        "byClass": {
          "431110": 1,
          "431121": 10,
          "431122": 1,
          "431130": 2,
          "431150": 2
        }
      },
      {
        "id": "16-053",
        "stateCode": "16",
        "stateName": "Michoacán de Ocampo",
        "municipality": "Morelia",
        "markets": [
          "CENTRAL DE ABASTOS",
          "MERCADO DE ABASTOS",
          "SIN NOMBRE",
          "CENTRAL DE ABASTOS MORELIA",
          "2"
        ],
        "total": 15,
        "volume": 6,
        "byClass": {
          "431110": 3,
          "431121": 1,
          "431130": 3,
          "431140": 2,
          "431150": 4,
          "431160": 2
        }
      },
      {
        "id": "17-008",
        "stateCode": "17",
        "stateName": "Morelos",
        "municipality": "Emiliano Zapata",
        "markets": [
          "CENTRAL DE ABASTO EMILIANO ZAPATA",
          "EMILIANO ZAPATA"
        ],
        "total": 15,
        "volume": 2,
        "byClass": {
          "431110": 1,
          "431122": 1,
          "431130": 1,
          "431140": 2,
          "431150": 4,
          "431160": 4,
          "431211": 2
        }
      },
      {
        "id": "11-020",
        "stateCode": "11",
        "stateName": "Guanajuato",
        "municipality": "León",
        "markets": [
          "CENTRAL DE ABASTOS",
          "SIN NOMBRE",
          "CENTRAL DE ABASTOS LEON",
          "CENTRAL DE ABASTOS DE LEON",
          "CENTRAL DE ABASTOS LEON GUANAJUATO",
          "O",
          "K",
          "M"
        ],
        "total": 14,
        "volume": 5,
        "byClass": {
          "431110": 4,
          "431121": 1,
          "431130": 9
        }
      },
      {
        "id": "30-108",
        "stateCode": "30",
        "stateName": "Veracruz de Ignacio de la Llave",
        "municipality": "Minatitlán",
        "markets": [
          "MINATITLAN",
          "CENTRAL DE ABASTO MINATITLA",
          "SIN NOMBRE"
        ],
        "total": 14,
        "volume": 6,
        "byClass": {
          "431110": 3,
          "431123": 2,
          "431130": 4,
          "431140": 2,
          "431150": 1,
          "431170": 2
        }
      },
      {
        "id": "30-102",
        "stateCode": "30",
        "stateName": "Veracruz de Ignacio de la Llave",
        "municipality": "Martínez de la Torre",
        "markets": [
          "BASCULA SAN MANUEL",
          "BASCULA SAN MANUEL DE NARANJA",
          "BASCULA PLAZA VERDE"
        ],
        "total": 13,
        "volume": 0,
        "byClass": {
          "431130": 13
        }
      },
      {
        "id": "26-018",
        "stateCode": "26",
        "stateName": "Sonora",
        "municipality": "Cajeme",
        "markets": [
          "SIN NOMBRE",
          "CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTOS DE OBREGON",
          "NAVE A CENTRAL DE ABASTOS OBREGON",
          "MERCADITO UNION",
          "CENTRAL DE ABASTO OBREGON",
          "CENTRAL DE ABASTOS OBREGÓN"
        ],
        "total": 11,
        "volume": 8,
        "byClass": {
          "431110": 5,
          "431121": 1,
          "431122": 1,
          "431130": 4
        }
      },
      {
        "id": "01-001",
        "stateCode": "01",
        "stateName": "Aguascalientes",
        "municipality": "Aguascalientes",
        "markets": [
          "CENTRO COMERCIAL AGROPECUARIO",
          "AGROPECUARIO",
          "CENTRAL DE ABASTOS DE AGUASCALIENTES",
          "CENTRAL DE ABASTOS"
        ],
        "total": 10,
        "volume": 3,
        "byClass": {
          "431110": 3,
          "431121": 1,
          "431122": 1,
          "431130": 1,
          "431140": 2,
          "431150": 1,
          "431211": 1
        }
      },
      {
        "id": "16-069",
        "stateCode": "16",
        "stateName": "Michoacán de Ocampo",
        "municipality": "La Piedad",
        "markets": [
          "MERCADO DE ABASTOS 12 DE OCTUBRE"
        ],
        "total": 10,
        "volume": 0,
        "byClass": {
          "431130": 10
        }
      },
      {
        "id": "23-005",
        "stateCode": "23",
        "stateName": "Quintana Roo",
        "municipality": "Benito Juárez",
        "markets": [
          "CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTOS CANCUN",
          "CENTRAL DE ABASTO CANCUN",
          "CENTRAL DE ABASTO DE CANCUN",
          "CENTRAL DE ABASTOS CANCUN BENITO JUAREZ",
          "ONEST COMERCALIZADORA",
          "SANTA ANA"
        ],
        "total": 10,
        "volume": 6,
        "byClass": {
          "431110": 2,
          "431121": 1,
          "431123": 1,
          "431130": 2,
          "431140": 2,
          "431160": 2
        }
      },
      {
        "id": "08-019",
        "stateCode": "08",
        "stateName": "Chihuahua",
        "municipality": "Chihuahua",
        "markets": [
          "CHIHUAHUA",
          "CENTRAL DE ABASTOS CHIHUAHUA",
          "CENTRAL DE ABASTOS DE CHIHUAHUA",
          "SIN NOMBRE",
          "CETRAL DE ABASTOS"
        ],
        "total": 9,
        "volume": 6,
        "byClass": {
          "431130": 7,
          "431140": 1,
          "431193": 1
        }
      },
      {
        "id": "30-065",
        "stateCode": "30",
        "stateName": "Veracruz de Ignacio de la Llave",
        "municipality": "Emiliano Zapata",
        "markets": [
          "XALAPA",
          "CENTRAL DE ABASTOS XALAPA",
          "CENTRAL DE ABASTO",
          "CENTRAL DE ABASTOS DE XALAPA",
          "CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTO XALAPA"
        ],
        "total": 9,
        "volume": 3,
        "byClass": {
          "431110": 5,
          "431130": 1,
          "431150": 3
        }
      },
      {
        "id": "15-109",
        "stateCode": "15",
        "stateName": "México",
        "municipality": "Tultitlán",
        "markets": [
          "CENTRAL DE ABASTO TULTITLAN",
          "SIN NOMBRE",
          "CENTRAL DE ABASTOS TULTITLAN"
        ],
        "total": 8,
        "volume": 4,
        "byClass": {
          "431110": 2,
          "431122": 1,
          "431130": 1,
          "431140": 1,
          "431150": 2,
          "431160": 1
        }
      },
      {
        "id": "15-013",
        "stateCode": "15",
        "stateName": "México",
        "municipality": "Atizapán de Zaragoza",
        "markets": [
          "NAVE 17",
          "NAVE 19",
          "BODEGAS ATIZAPAN",
          "NAVE 4",
          "CENTRAL DE ABASTOS ATIZAPAN DE ZARAGOZA"
        ],
        "total": 8,
        "volume": 2,
        "byClass": {
          "431110": 2,
          "431122": 1,
          "431130": 4,
          "431140": 1
        }
      },
      {
        "id": "02-002",
        "stateCode": "02",
        "stateName": "Baja California",
        "municipality": "Mexicali",
        "markets": [
          "CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTOS DE MEXICALI",
          "BRAULIO MALDONADO"
        ],
        "total": 7,
        "volume": 6,
        "byClass": {
          "431110": 1,
          "431121": 1,
          "431130": 4,
          "431199": 1
        }
      },
      {
        "id": "08-037",
        "stateCode": "08",
        "stateName": "Chihuahua",
        "municipality": "Juárez",
        "markets": [
          "CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTO AEROPUERTO",
          "MERCADO DE ABASTOS AERONAUTICA",
          "CENTRAL DE ABASTO SANDERS",
          "CENTRAL DE ABASTOS AERONAUTICA",
          "MERCADO DE ABASTOS CIUDAD JUAREZ",
          "JUAREZ AERONAUTICA"
        ],
        "total": 7,
        "volume": 3,
        "byClass": {
          "431110": 2,
          "431130": 4,
          "431160": 1
        }
      },
      {
        "id": "12-001",
        "stateCode": "12",
        "stateName": "Guerrero",
        "municipality": "Acapulco de Juárez",
        "markets": [
          "CENTRAL DE ABASTOS SEGUNDA ETAPA",
          "CENTRAL DE ABASTO",
          "CENTRAL DE ABASTOS"
        ],
        "total": 6,
        "volume": 4,
        "byClass": {
          "431121": 1,
          "431130": 1,
          "431140": 1,
          "431170": 1,
          "431199": 2
        }
      },
      {
        "id": "18-017",
        "stateCode": "18",
        "stateName": "Nayarit",
        "municipality": "Tepic",
        "markets": [
          "NAYARABASTOS",
          "MERCADO DE ABASTOS TEPIC"
        ],
        "total": 6,
        "volume": 1,
        "byClass": {
          "431110": 2,
          "431130": 2,
          "431160": 1,
          "431193": 1
        }
      },
      {
        "id": "05-030",
        "stateCode": "05",
        "stateName": "Coahuila de Zaragoza",
        "municipality": "Saltillo",
        "markets": [
          "BENITO JUAREZ",
          "SIN NOMBRE",
          "MERCADO DE ABASTOS"
        ],
        "total": 4,
        "volume": 0,
        "byClass": {
          "431110": 3,
          "431140": 1
        }
      },
      {
        "id": "07-019",
        "stateCode": "07",
        "stateName": "Chiapas",
        "municipality": "Comitán de Domínguez",
        "markets": [
          "28 DE AGOSTO",
          "CENTRAL DE ABASTOS"
        ],
        "total": 4,
        "volume": 0,
        "byClass": {
          "431110": 2,
          "431130": 1,
          "431211": 1
        }
      },
      {
        "id": "08-021",
        "stateCode": "08",
        "stateName": "Chihuahua",
        "municipality": "Delicias",
        "markets": [
          "CENTRAL DE ABASTOS"
        ],
        "total": 4,
        "volume": 2,
        "byClass": {
          "431110": 1,
          "431130": 2,
          "431199": 1
        }
      },
      {
        "id": "15-029",
        "stateCode": "15",
        "stateName": "México",
        "municipality": "Chicoloapan",
        "markets": [
          "CENTRAL DE ABASTOS DE SAN VICENTE CHICOLOAPAN"
        ],
        "total": 4,
        "volume": 2,
        "byClass": {
          "431110": 1,
          "431140": 2,
          "431211": 1
        }
      },
      {
        "id": "32-010",
        "stateCode": "32",
        "stateName": "Zacatecas",
        "municipality": "Fresnillo",
        "markets": [
          "MERCADO DE ABASTOS FRESNILLO",
          "MERCADO DE ABASTOS FRESNILLO ZACATECAS",
          "CENTRO DE ABASTOS DE FRESNILLO"
        ],
        "total": 4,
        "volume": 2,
        "byClass": {
          "431110": 3,
          "431150": 1
        }
      },
      {
        "id": "13-028",
        "stateCode": "13",
        "stateName": "Hidalgo",
        "municipality": "Huejutla de Reyes",
        "markets": [
          "CENTRAL DE ABASTOS"
        ],
        "total": 3,
        "volume": 0,
        "byClass": {
          "431130": 3
        }
      },
      {
        "id": "16-108",
        "stateCode": "16",
        "stateName": "Michoacán de Ocampo",
        "municipality": "Zamora",
        "markets": [
          "MEGABASTOS LA RINCONADA",
          "CENTRAL DE ABASTOS CANINDO",
          "MEGABASTOS"
        ],
        "total": 3,
        "volume": 1,
        "byClass": {
          "431110": 1,
          "431130": 2
        }
      },
      {
        "id": "03-003",
        "stateCode": "03",
        "stateName": "Baja California Sur",
        "municipality": "La Paz",
        "markets": [
          "MERCADO DE ABASTOS",
          "MERCADO DE ABASTOS LA PAZ"
        ],
        "total": 2,
        "volume": 1,
        "byClass": {
          "431130": 2
        }
      },
      {
        "id": "12-035",
        "stateCode": "12",
        "stateName": "Guerrero",
        "municipality": "Iguala de la Independencia",
        "markets": [
          "CENTRAL DE ABASTO DE IGUALA"
        ],
        "total": 2,
        "volume": 1,
        "byClass": {
          "431110": 1,
          "431160": 1
        }
      },
      {
        "id": "16-102",
        "stateCode": "16",
        "stateName": "Michoacán de Ocampo",
        "municipality": "Uruapan",
        "markets": [
          "CENTRAL DE ABASTOS SIN NOMBRE"
        ],
        "total": 2,
        "volume": 1,
        "byClass": {
          "431110": 1,
          "431130": 1
        }
      },
      {
        "id": "19-048",
        "stateCode": "19",
        "stateName": "Nuevo León",
        "municipality": "Santa Catarina",
        "markets": [
          "MERCADO DE ABASTOS SANTA CATARINA",
          "MERCADO DE ABASTOS PONIENTE"
        ],
        "total": 2,
        "volume": 1,
        "byClass": {
          "431110": 1,
          "431160": 1
        }
      },
      {
        "id": "25-012",
        "stateCode": "25",
        "stateName": "Sinaloa",
        "municipality": "Mazatlán",
        "markets": [
          "YARDA MAZATLAN"
        ],
        "total": 2,
        "volume": 1,
        "byClass": {
          "431110": 1,
          "431130": 1
        }
      },
      {
        "id": "28-003",
        "stateCode": "28",
        "stateName": "Tamaulipas",
        "municipality": "Altamira",
        "markets": [
          "TAMPICO-ALTAMIRA",
          "CENTRAL DE ABASTOS"
        ],
        "total": 2,
        "volume": 2,
        "byClass": {
          "431122": 1,
          "431140": 1
        }
      },
      {
        "id": "30-193",
        "stateCode": "30",
        "stateName": "Veracruz de Ignacio de la Llave",
        "municipality": "Veracruz",
        "markets": [
          "CENTRAL DE ABASTOS",
          "CENTRAL DE ABASTOS VERACRUZ"
        ],
        "total": 2,
        "volume": 0,
        "byClass": {
          "431140": 1,
          "431170": 1
        }
      },
      {
        "id": "30-014",
        "stateCode": "30",
        "stateName": "Veracruz de Ignacio de la Llave",
        "municipality": "Amatlán de los Reyes",
        "markets": [
          "CENTRAL DE ABASTOS AMATLAN",
          "CORDOBA"
        ],
        "total": 2,
        "volume": 2,
        "byClass": {
          "431140": 1,
          "431160": 1
        }
      },
      {
        "id": "31-050",
        "stateCode": "31",
        "stateName": "Yucatán",
        "municipality": "Mérida",
        "markets": [
          "CENTRAL DE ABASTO MERIDA",
          "CENTRAL DE ABASTOS"
        ],
        "total": 2,
        "volume": 1,
        "byClass": {
          "431130": 2
        }
      },
      {
        "id": "01-005",
        "stateCode": "01",
        "stateName": "Aguascalientes",
        "municipality": "Jesús María",
        "markets": [
          "CENTRAL DE ABASTOS VIÑEDOS SAN MARCOS"
        ],
        "total": 1,
        "volume": 0,
        "byClass": {
          "431121": 1
        }
      },
      {
        "id": "06-009",
        "stateCode": "06",
        "stateName": "Colima",
        "municipality": "Tecomán",
        "markets": [
          "MERCADO DE ABASTOS"
        ],
        "total": 1,
        "volume": 0,
        "byClass": {
          "431130": 1
        }
      },
      {
        "id": "08-013",
        "stateCode": "08",
        "stateName": "Chihuahua",
        "municipality": "Casas Grandes",
        "markets": [
          "CENTRAL DE ABASTOS"
        ],
        "total": 1,
        "volume": 0,
        "byClass": {
          "431150": 1
        }
      },
      {
        "id": "09-006",
        "stateCode": "09",
        "stateName": "Ciudad de México",
        "municipality": "Iztacalco",
        "markets": [
          "NINGUNO"
        ],
        "total": 1,
        "volume": 1,
        "byClass": {
          "431160": 1
        }
      },
      {
        "id": "15-039",
        "stateCode": "15",
        "stateName": "México",
        "municipality": "Ixtapaluca",
        "markets": [
          "CENTRAL DE ABASTO AYOTLA"
        ],
        "total": 1,
        "volume": 1,
        "byClass": {
          "431150": 1
        }
      },
      {
        "id": "16-085",
        "stateCode": "16",
        "stateName": "Michoacán de Ocampo",
        "municipality": "Tangancícuaro",
        "markets": [
          "CENTRAL REGIONAL DE ABASTOS"
        ],
        "total": 1,
        "volume": 0,
        "byClass": {
          "431130": 1
        }
      },
      {
        "id": "26-043",
        "stateCode": "26",
        "stateName": "Sonora",
        "municipality": "Nogales",
        "markets": [
          "PARAJE"
        ],
        "total": 1,
        "volume": 0,
        "byClass": {
          "431110": 1
        }
      },
      {
        "id": "26-029",
        "stateCode": "26",
        "stateName": "Sonora",
        "municipality": "Guaymas",
        "markets": [
          "YARDA GUADALUPE"
        ],
        "total": 1,
        "volume": 0,
        "byClass": {
          "431130": 1
        }
      },
      {
        "id": "28-032",
        "stateCode": "28",
        "stateName": "Tamaulipas",
        "municipality": "Reynosa",
        "markets": [
          "CENTRAL DE ABASTOS REYNOSA"
        ],
        "total": 1,
        "volume": 0,
        "byClass": {
          "431130": 1
        }
      },
      {
        "id": "30-044",
        "stateCode": "30",
        "stateName": "Veracruz de Ignacio de la Llave",
        "municipality": "Córdoba",
        "markets": [
          "MERCADO DE ABASTOS CORDOBA 2000"
        ],
        "total": 1,
        "volume": 1,
        "byClass": {
          "431110": 1
        }
      },
      {
        "id": "30-131",
        "stateCode": "30",
        "stateName": "Veracruz de Ignacio de la Llave",
        "municipality": "Poza Rica de Hidalgo",
        "markets": [
          "CENTRAL DE ABASTOS POZA RICA"
        ],
        "total": 1,
        "volume": 0,
        "byClass": {
          "431122": 1
        }
      },
      {
        "id": "30-136",
        "stateCode": "30",
        "stateName": "Veracruz de Ignacio de la Llave",
        "municipality": "Rafael Lucio",
        "markets": [
          "CENTRAL DE ABASTOS"
        ],
        "total": 1,
        "volume": 1,
        "byClass": {
          "431150": 1
        }
      },
      {
        "id": "31-041",
        "stateCode": "31",
        "stateName": "Yucatán",
        "municipality": "Kanasín",
        "markets": [
          "MERCADO FRESCO"
        ],
        "total": 1,
        "volume": 1,
        "byClass": {
          "431130": 1
        }
      }
    ],
    "total": 23654,
    "volumeTotal": 7195,
    "inCentralTotal": 3350,
    "municipalities": 1424,
    "withContact": 15449
  },
  "retail": {
    "sourceId": "profeco-qqp",
    "edition": "2026",
    "lastQuincena": "05-2026_Q2",
    "lastObservation": "2026-05-29",
    "ageDays": 66,
    "periods": [
      "2026-01",
      "2026-02",
      "2026-03",
      "2026-04",
      "2026-05"
    ],
    "references": [
      {
        "id": "a004-granel",
        "claveEnigh": "A004",
        "label": "Tortilla de maíz, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a009-paquete-spaghetti",
        "claveEnigh": "A009",
        "label": "Pasta para sopa, spaghetti, paquete 200 g",
        "presentacionQqp": "Paquete 200 Gr. Spaghetti",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a015-paquete-620g",
        "claveEnigh": "A015",
        "label": "Pan de caja blanco rebanado, paquete 620 g",
        "presentacionQqp": "Paquete Grande 620 Gr. Rebanado Blanco",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a015-paquete-210g-tostado",
        "claveEnigh": "A015",
        "label": "Pan tostado clásico, paquete 210 g",
        "presentacionQqp": "Paquete 210 Gr. Tostado. Clásico",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a019-granel-grande",
        "claveEnigh": "A019",
        "label": "Arroz grano grande entero, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Grande Entero",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a019-bolsa-1kg-super-extra",
        "claveEnigh": "A019",
        "label": "Arroz super extra, bolsa 1 kg",
        "presentacionQqp": "Bolsa 1 Kg. Super Extra",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a019-granel-quebrado",
        "claveEnigh": "A019",
        "label": "Arroz chico quebrado, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Chico Quebrado",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a025-granel-diezmillo",
        "claveEnigh": "A025",
        "label": "Bistec de res (diezmillo), granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Bistec Diezmillo o Diezmillo Sin Hueso",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a025-granel-milanesa",
        "claveEnigh": "A025",
        "label": "Milanesa de res, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Milanesa o de Corte Delgado o de Pulpa Blanca",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a025-granel-espaldilla",
        "claveEnigh": "A025",
        "label": "Bistec de espaldilla, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Bistec de Espaldilla",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a034-granel-molida",
        "claveEnigh": "A034",
        "label": "Carne molida de res, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Molida",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a034-granel-molida-popular",
        "claveEnigh": "A034",
        "label": "Carne molida popular, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Molida. Popular/comercial",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a038-granel-milanesa",
        "claveEnigh": "A038",
        "label": "Milanesa de puerco, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Milanesa o Milanesa de Pierna",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "media",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a042-granel-chuleta",
        "claveEnigh": "A042",
        "label": "Chuleta de puerco, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Chuleta o Chuleta Natural o Fresca/chuleta de Puerco Entrecortada o Lomo Deshuesado de Puerco o Chuleta Natural Lomo de Puerco",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a049-granel-longaniza",
        "claveEnigh": "A049",
        "label": "Longaniza, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Longaniza",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "media",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a052-granel-pierna-horneado",
        "claveEnigh": "A052",
        "label": "Jamón de pierna horneado, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. de Pierna. Horneado",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a052-granel-pierna",
        "claveEnigh": "A052",
        "label": "Jamón de pierna, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. de Pierna",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a052-granel-pierna-horneado-especial",
        "claveEnigh": "A052",
        "label": "Jamón de pierna horneado especial, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. de Pierna. Horneado Especial",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a055-granel-viena",
        "claveEnigh": "A055",
        "label": "Salchicha viena, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Viena",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "media",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a057-granel-pechuga",
        "claveEnigh": "A057",
        "label": "Pechuga de pollo con hueso, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Pechuga con Hueso o Anatómica o Sin Rabadilla (con Piel)",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a057-granel-pierna",
        "claveEnigh": "A057",
        "label": "Pierna de pollo, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Pierna o Pierna Bate",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a057-granel-pierna-muslo",
        "claveEnigh": "A057",
        "label": "Pierna con muslo de pollo, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Pierna con Muslo",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a059-granel-entero",
        "claveEnigh": "A059",
        "label": "Pollo entero con vísceras, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Entero. con Vísceras o Tipo Super o Entero Supermercado o Canal Entera",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "media",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a062-granel-pavo",
        "claveEnigh": "A062",
        "label": "Embutido de pavo (jamón y salchicha), granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. de Pavo",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "media",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a062-granel-pavo-virginia",
        "claveEnigh": "A062",
        "label": "Jamón de pavo virginia, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. de Pavo. Virginia",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "media",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a062-paquete-290g-pavo-virginia",
        "claveEnigh": "A062",
        "label": "Jamón de pavo virginia, paquete 290 g",
        "presentacionQqp": "Paquete 290 Gr. de Pavo. Virginia",
        "forma": "empaque",
        "paridadCalidad": false,
        "confidence": "media",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a075-caja-1l-descremada",
        "claveEnigh": "A075",
        "label": "Leche parcialmente descremada, caja 1 L",
        "presentacionQqp": "Caja 1 Lt. Parcialmente Descremada. Azul",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "L"
      },
      {
        "id": "a075-caja-1l-entera",
        "claveEnigh": "A075",
        "label": "Leche entera, caja 1 L",
        "presentacionQqp": "Caja 1 Lt. Entera",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "L"
      },
      {
        "id": "a085-granel",
        "claveEnigh": "A085",
        "label": "Queso panela, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "media",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a087-granel",
        "claveEnigh": "A087",
        "label": "Queso oaxaca, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel",
        "forma": "granel",
        "paridadCalidad": false,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a093-granel-blanco",
        "claveEnigh": "A093",
        "label": "Huevo blanco, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Blanco",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a095-botella-1l",
        "claveEnigh": "A095",
        "label": "Aceite vegetal, botella 1 L",
        "presentacionQqp": "Botella 1 Lt. Vegetal",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "L"
      },
      {
        "id": "a095-botella-900ml",
        "claveEnigh": "A095",
        "label": "Aceite vegetal, botella 900 ml",
        "presentacionQqp": "Botella 900 Ml. Vegetal",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "L"
      },
      {
        "id": "a095-botella-500ml",
        "claveEnigh": "A095",
        "label": "Aceite vegetal, botella 500 ml",
        "presentacionQqp": "Botella 500 Ml. Vegetal",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "L"
      },
      {
        "id": "a173-granel-estandar",
        "claveEnigh": "A173",
        "label": "Azúcar estándar morena, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Estándar Morena",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a173-granel-refinada",
        "claveEnigh": "A173",
        "label": "Azúcar refinada, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Refinada",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a173-bolsa-1kg-estandar",
        "claveEnigh": "A173",
        "label": "Azúcar estándar, bolsa 1 kg",
        "presentacionQqp": "Bolsa Plástico 1 Kg. Estándar",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a102-granel-alfa",
        "claveEnigh": "A102",
        "label": "Papa alfa blanca, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Alfa/blanca",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a112-granel-blanca",
        "claveEnigh": "A112",
        "label": "Cebolla blanca sin rabo, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Blanca Sin Rabo",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a115-a118-granel-jalapeno",
        "claveEnigh": "A115-A118",
        "label": "Chile jalapeño, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Jalapeño o Cuaresmeño",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a115-a118-granel-poblano",
        "claveEnigh": "A115-A118",
        "label": "Chile poblano, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Poblano o para Rellenar",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a115-a118-granel-habanero",
        "claveEnigh": "A115-A118",
        "label": "Chile habanero, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Habanero",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a124-granel-saladette",
        "claveEnigh": "A124",
        "label": "Jitomate saladette sin grado, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Saladette/huaje o Tomate Saladette/huaje",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a124-granel-bola",
        "claveEnigh": "A124",
        "label": "Jitomate bola, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Bola/sinaloa o Tomate Bola",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a137-granel-negro",
        "claveEnigh": "A137",
        "label": "Frijol negro, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Negro",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a137-granel-pinto",
        "claveEnigh": "A137",
        "label": "Frijol pinto, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Pinto",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a137-granel-peruano",
        "claveEnigh": "A137",
        "label": "Frijol peruano, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Peruano",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a154-granel-agrio",
        "claveEnigh": "A154",
        "label": "Limón agrio con semilla, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Agrio con Semilla o Colima",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a154-granel-persa",
        "claveEnigh": "A154",
        "label": "Limón persa sin semilla, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Agrio Sin Semilla o Persa",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a158-granel-red-delicious",
        "claveEnigh": "A158",
        "label": "Manzana red delicious, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Red Delicious/roja/roja Mediana/roja Americana",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a158-granel-golden",
        "claveEnigh": "A158",
        "label": "Manzana golden, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Golden",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a158-granel-granny-smith",
        "claveEnigh": "A158",
        "label": "Manzana granny smith, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Granny Smith",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a160-granel-jugo",
        "claveEnigh": "A160",
        "label": "Naranja para jugo, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. para Jugo",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "media",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a160-granel-valencia",
        "claveEnigh": "A160",
        "label": "Naranja valencia, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Valencia",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "media",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a166-granel-tabasco",
        "claveEnigh": "A166",
        "label": "Plátano tabasco, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Tabasco/chiapas/roatán/portalimón",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a166-granel-macho",
        "claveEnigh": "A166",
        "label": "Plátano macho, granel, 1 kg",
        "presentacionQqp": "1 Kg. Granel. Macho",
        "forma": "granel",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "kg"
      },
      {
        "id": "a215-botella-15l",
        "claveEnigh": "A215",
        "label": "Agua natural embotellada, botella 1.5 L",
        "presentacionQqp": "Botella 1.5 Lt.",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "L"
      },
      {
        "id": "a220-lata-355ml",
        "claveEnigh": "A220",
        "label": "Refresco, lata 355 ml",
        "presentacionQqp": "Lata 355 Ml.",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "L"
      },
      {
        "id": "a220-botella-3l",
        "claveEnigh": "A220",
        "label": "Refresco, botella 3 L",
        "presentacionQqp": "Botella 3 Lt. No Retornable",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "L"
      },
      {
        "id": "a220-botella-1l",
        "claveEnigh": "A220",
        "label": "Refresco, botella 1 L",
        "presentacionQqp": "Botella 1 Lt. No Retornable",
        "forma": "empaque",
        "paridadCalidad": true,
        "confidence": "alta",
        "unit": "MXN_unidad",
        "denominador": "L"
      }
    ],
    "bands": [
      {
        "refId": "a004-granel",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a004-granel",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 26,
          "states": 6,
          "outlets": 6,
          "p10": 20,
          "p25": 21.63,
          "p50": 26,
          "p75": 27.75,
          "p90": 29,
          "ciLo": 22,
          "ciHi": 26
        },
        "anaquel": {
          "refId": "a004-granel",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 1096,
          "states": 30,
          "outlets": 315,
          "p10": 13,
          "p25": 13.5,
          "p50": 14.4,
          "p75": 14.5,
          "p90": 15,
          "ciLo": 14,
          "ciHi": 14.5
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a004-granel",
          "period": "2026-05",
          "pct": -41.43,
          "ciLo": -50.94,
          "ciHi": -31.76,
          "verdict": "central-mas-cara",
          "states": 6,
          "reason": null
        },
        "derivaMensualPct": 0,
        "derivaR2": 0
      },
      {
        "refId": "a009-paquete-spaghetti",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a009-paquete-spaghetti",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 47,
          "states": 10,
          "outlets": 17,
          "p10": 35.66,
          "p25": 37.5,
          "p50": 38.2,
          "p75": 42.5,
          "p90": 45,
          "ciLo": 37.5,
          "ciHi": 41.5
        },
        "anaquel": {
          "refId": "a009-paquete-spaghetti",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 758,
          "states": 30,
          "outlets": 227,
          "p10": 22.5,
          "p25": 22.5,
          "p50": 30,
          "p75": 50,
          "p90": 65,
          "ciLo": 30,
          "ciHi": 32.5
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a009-paquete-spaghetti",
          "period": "2026-05",
          "pct": -26.47,
          "ciLo": -43.5,
          "ciHi": 18.67,
          "verdict": "sin-diferencia",
          "states": 9,
          "reason": "El diferencial estimado es de -26.5 %, pero con 9 entidades pareadas el intervalo de confianza del 95 % va de -43.5 % a +18.7 % e incluye el cero. Con esta muestra no se puede afirmar una diferencia."
        },
        "derivaMensualPct": -1.17,
        "derivaR2": 0.802
      },
      {
        "refId": "a015-paquete-620g",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a015-paquete-620g",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 59,
          "states": 10,
          "outlets": 17,
          "p10": 73.92,
          "p25": 76.77,
          "p50": 78.87,
          "p75": 80.65,
          "p90": 83.87,
          "ciLo": 78.39,
          "ciHi": 79.03
        },
        "anaquel": {
          "refId": "a015-paquete-620g",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 1143,
          "states": 30,
          "outlets": 333,
          "p10": 69.35,
          "p25": 82.26,
          "p50": 86.94,
          "p75": 88.71,
          "p90": 90.16,
          "ciLo": 86.94,
          "ciHi": 87.1
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a015-paquete-620g",
          "period": "2026-05",
          "pct": 11.46,
          "ciLo": -1.92,
          "ciHi": 14.37,
          "verdict": "sin-diferencia",
          "states": 9,
          "reason": "El diferencial estimado es de +11.5 %, pero con 9 entidades pareadas el intervalo de confianza del 95 % va de -1.9 % a +14.4 % e incluye el cero. Con esta muestra no se puede afirmar una diferencia."
        },
        "derivaMensualPct": -0.04,
        "derivaR2": 0.033
      },
      {
        "refId": "a015-paquete-210g-tostado",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a015-paquete-210g-tostado",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 36,
          "states": 10,
          "outlets": 13,
          "p10": 153.81,
          "p25": 158.1,
          "p50": 165.71,
          "p75": 172.62,
          "p90": 177.62,
          "ciLo": 161.9,
          "ciHi": 171.43
        },
        "anaquel": {
          "refId": "a015-paquete-210g-tostado",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 910,
          "states": 30,
          "outlets": 314,
          "p10": 154.76,
          "p25": 183.33,
          "p50": 185.71,
          "p75": 188.1,
          "p90": 190,
          "ciLo": 185.71,
          "ciHi": 185.71
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a015-paquete-210g-tostado",
          "period": "2026-05",
          "pct": 14.71,
          "ciLo": 8.33,
          "ciHi": 20.74,
          "verdict": "anaquel-mas-caro",
          "states": 7,
          "reason": null
        },
        "derivaMensualPct": 0.39,
        "derivaR2": 0.133
      },
      {
        "refId": "a019-granel-grande",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a019-granel-grande",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 55,
          "states": 10,
          "outlets": 14,
          "p10": 17,
          "p25": 17.5,
          "p50": 20,
          "p75": 27,
          "p90": 38,
          "ciLo": 19,
          "ciHi": 22
        },
        "anaquel": null,
        "grade": "solo-rango",
        "gradeReason": "la mitad central de las 55 observaciones abarca el 47.5 % del precio y el tope es 40 %. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a019-granel-grande",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-canal",
          "states": 0,
          "reason": "El autoservicio no vende esta presentación: 0 observaciones en 2026-05. Comparar contra otra presentación cambiaría el bien, no el canal."
        },
        "derivaMensualPct": -0.97,
        "derivaR2": 0.13
      },
      {
        "refId": "a019-bolsa-1kg-super-extra",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a019-bolsa-1kg-super-extra",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 38,
          "states": 8,
          "outlets": 16,
          "p10": 16.14,
          "p25": 31.12,
          "p50": 33.25,
          "p75": 35.9,
          "p90": 38,
          "ciLo": 31.78,
          "ciHi": 35.61
        },
        "anaquel": {
          "refId": "a019-bolsa-1kg-super-extra",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 377,
          "states": 30,
          "outlets": 138,
          "p10": 37,
          "p25": 37,
          "p50": 38,
          "p75": 38,
          "p90": 39.9,
          "ciLo": 38,
          "ciHi": 38
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a019-bolsa-1kg-super-extra",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-pareo-suficiente",
          "states": 4,
          "reason": "Los dos canales coinciden en 4 entidades con muestra suficiente, y hacen falta 5. Un diferencial nacional calculado sobre 4 estados no es un margen, es una anécdota."
        },
        "derivaMensualPct": -2.83,
        "derivaR2": 0.963
      },
      {
        "refId": "a019-granel-quebrado",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a019-granel-quebrado",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 39,
          "states": 6,
          "outlets": 11,
          "p10": 13,
          "p25": 13.5,
          "p50": 15,
          "p75": 20,
          "p90": 20,
          "ciLo": 15,
          "ciHi": 20
        },
        "anaquel": null,
        "grade": "solo-rango",
        "gradeReason": "la mitad central de las 39 observaciones abarca el 43.3 % del precio y el tope es 40 %. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a019-granel-quebrado",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-canal",
          "states": 0,
          "reason": "El autoservicio no vende esta presentación: 0 observaciones en 2026-05. Comparar contra otra presentación cambiaría el bien, no el canal."
        },
        "derivaMensualPct": -1.29,
        "derivaR2": 0.506
      },
      {
        "refId": "a025-granel-diezmillo",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a025-granel-diezmillo",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 35,
          "states": 8,
          "outlets": 11,
          "p10": 191.6,
          "p25": 195,
          "p50": 210,
          "p75": 244,
          "p90": 254.5,
          "ciLo": 199,
          "ciHi": 232
        },
        "anaquel": {
          "refId": "a025-granel-diezmillo",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 384,
          "states": 29,
          "outlets": 147,
          "p10": 245,
          "p25": 255,
          "p50": 274.9,
          "p75": 274.9,
          "p90": 274.9,
          "ciLo": 274,
          "ciHi": 274.9
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a025-granel-diezmillo",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 0.85,
        "derivaR2": 0.172
      },
      {
        "refId": "a025-granel-milanesa",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a025-granel-milanesa",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 23,
          "states": 7,
          "outlets": 8,
          "p10": 167.2,
          "p25": 209,
          "p50": 232,
          "p75": 244,
          "p90": 248.9,
          "ciLo": 209,
          "ciHi": 244
        },
        "anaquel": {
          "refId": "a025-granel-milanesa",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 613,
          "states": 29,
          "outlets": 238,
          "p10": 223,
          "p25": 228,
          "p50": 229.9,
          "p75": 239,
          "p90": 239,
          "ciLo": 229,
          "ciHi": 236
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a025-granel-milanesa",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 1.07,
        "derivaR2": 0.5
      },
      {
        "refId": "a025-granel-espaldilla",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a025-granel-espaldilla",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 22,
          "states": 6,
          "outlets": 8,
          "p10": 216.5,
          "p25": 216.5,
          "p50": 232,
          "p75": 244,
          "p90": 248.9,
          "ciLo": 216.5,
          "ciHi": 244
        },
        "anaquel": null,
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a025-granel-espaldilla",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 1.32,
        "derivaR2": 0.604
      },
      {
        "refId": "a034-granel-molida",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a034-granel-molida",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 33,
          "states": 9,
          "outlets": 11,
          "p10": 138.18,
          "p25": 162.5,
          "p50": 209,
          "p75": 244,
          "p90": 248,
          "ciLo": 162.5,
          "ciHi": 228
        },
        "anaquel": {
          "refId": "a034-granel-molida",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 193,
          "states": 26,
          "outlets": 82,
          "p10": 98.9,
          "p25": 138.9,
          "p50": 147,
          "p75": 229.8,
          "p90": 229.8,
          "ciLo": 147,
          "ciHi": 147
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a034-granel-molida",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": -1.56,
        "derivaR2": 0.203
      },
      {
        "refId": "a034-granel-molida-popular",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a034-granel-molida-popular",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 20,
          "states": 7,
          "outlets": 8,
          "p10": 109,
          "p25": 114.24,
          "p50": 145,
          "p75": 160.5,
          "p90": 184,
          "ciLo": 115.99,
          "ciHi": 154
        },
        "anaquel": null,
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a034-granel-molida-popular",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": -2.01,
        "derivaR2": 0.927
      },
      {
        "refId": "a038-granel-milanesa",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a038-granel-milanesa",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 31,
          "states": 9,
          "outlets": 11,
          "p10": 85,
          "p25": 101.25,
          "p50": 110,
          "p75": 129,
          "p90": 135,
          "ciLo": 109.5,
          "ciHi": 128
        },
        "anaquel": {
          "refId": "a038-granel-milanesa",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 779,
          "states": 29,
          "outlets": 284,
          "p10": 109,
          "p25": 116,
          "p50": 123,
          "p75": 132,
          "p90": 135,
          "ciLo": 122,
          "ciHi": 126
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a038-granel-milanesa",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": -2.48,
        "derivaR2": 0.761
      },
      {
        "refId": "a042-granel-chuleta",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a042-granel-chuleta",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 58,
          "states": 10,
          "outlets": 13,
          "p10": 74,
          "p25": 79.99,
          "p50": 104,
          "p75": 114,
          "p90": 142,
          "ciLo": 95,
          "ciHi": 105
        },
        "anaquel": {
          "refId": "a042-granel-chuleta",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 914,
          "states": 30,
          "outlets": 298,
          "p10": 85,
          "p25": 97,
          "p50": 108.9,
          "p75": 122,
          "p90": 129,
          "ciLo": 107,
          "ciHi": 109
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a042-granel-chuleta",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 1.09,
        "derivaR2": 0.478
      },
      {
        "refId": "a049-granel-longaniza",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a049-granel-longaniza",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 22,
          "states": 6,
          "outlets": 8,
          "p10": 84.8,
          "p25": 92,
          "p50": 112,
          "p75": 129,
          "p90": 135.3,
          "ciLo": 92,
          "ciHi": 129
        },
        "anaquel": {
          "refId": "a049-granel-longaniza",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 721,
          "states": 26,
          "outlets": 242,
          "p10": 99.9,
          "p25": 108,
          "p50": 108,
          "p75": 117,
          "p90": 176,
          "ciLo": 108,
          "ciHi": 114
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a049-granel-longaniza",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": -0.27,
        "derivaR2": 0.03
      },
      {
        "refId": "a052-granel-pierna-horneado",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a052-granel-pierna-horneado",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 19,
          "states": 4,
          "outlets": 10,
          "p10": 100,
          "p25": 123.38,
          "p50": 140,
          "p75": 149.5,
          "p90": 159,
          "ciLo": 123.38,
          "ciHi": 149
        },
        "anaquel": {
          "refId": "a052-granel-pierna-horneado",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 212,
          "states": 18,
          "outlets": 88,
          "p10": 150,
          "p25": 150,
          "p50": 150,
          "p75": 150,
          "p90": 163.4,
          "ciLo": 150,
          "ciHi": 150
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a052-granel-pierna-horneado",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": -1.1,
        "derivaR2": 0.283
      },
      {
        "refId": "a052-granel-pierna",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a052-granel-pierna",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 7,
          "states": 3,
          "outlets": 3,
          "p10": 183,
          "p25": 185,
          "p50": 236.59,
          "p75": 372.8,
          "p90": 372.8,
          "ciLo": null,
          "ciHi": null
        },
        "anaquel": {
          "refId": "a052-granel-pierna",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 1387,
          "states": 26,
          "outlets": 235,
          "p10": 179,
          "p25": 315.5,
          "p50": 358,
          "p75": 370.9,
          "p90": 389,
          "ciLo": 354,
          "ciHi": 358
        },
        "grade": "solo-rango",
        "gradeReason": "sólo 7 observaciones en el mes y el mínimo para publicar un punto son 12; la mitad central de las 7 observaciones abarca el 79.4 % del precio y el tope es 40 %. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a052-granel-pierna",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": null,
        "derivaR2": null
      },
      {
        "refId": "a052-granel-pierna-horneado-especial",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a052-granel-pierna-horneado-especial",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 6,
          "states": 2,
          "outlets": 3,
          "p10": 114,
          "p25": 120.5,
          "p50": 140,
          "p75": 141.5,
          "p90": 146,
          "ciLo": null,
          "ciHi": null
        },
        "anaquel": {
          "refId": "a052-granel-pierna-horneado-especial",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 388,
          "states": 25,
          "outlets": 159,
          "p10": 150,
          "p25": 150,
          "p50": 166.9,
          "p75": 179,
          "p90": 179,
          "ciLo": 164,
          "ciHi": 172.99
        },
        "grade": "solo-rango",
        "gradeReason": "sólo 6 observaciones en el mes y el mínimo para publicar un punto son 12; sólo 2 entidades con observación y el mínimo son 3. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a052-granel-pierna-horneado-especial",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": null,
        "derivaR2": null
      },
      {
        "refId": "a055-granel-viena",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a055-granel-viena",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 13,
          "states": 3,
          "outlets": 6,
          "p10": 38.18,
          "p25": 44.88,
          "p50": 48.9,
          "p75": 54.33,
          "p90": 61.24,
          "ciLo": 44.88,
          "ciHi": 60
        },
        "anaquel": {
          "refId": "a055-granel-viena",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 19,
          "states": 1,
          "outlets": 5,
          "p10": 54,
          "p25": 55,
          "p50": 81.5,
          "p75": 81.5,
          "p90": 90.5,
          "ciLo": 55,
          "ciHi": 81.5
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a055-granel-viena",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 1.17,
        "derivaR2": 0.298
      },
      {
        "refId": "a057-granel-pechuga",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a057-granel-pechuga",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 35,
          "states": 8,
          "outlets": 10,
          "p10": 98,
          "p25": 107,
          "p50": 120,
          "p75": 140,
          "p90": 159.6,
          "ciLo": 110,
          "ciHi": 130
        },
        "anaquel": {
          "refId": "a057-granel-pechuga",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 519,
          "states": 29,
          "outlets": 214,
          "p10": 107,
          "p25": 139,
          "p50": 149,
          "p75": 149,
          "p90": 149,
          "ciLo": 148.9,
          "ciHi": 149
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a057-granel-pechuga",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 4.96,
        "derivaR2": 0.911
      },
      {
        "refId": "a057-granel-pierna",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a057-granel-pierna",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 34,
          "states": 7,
          "outlets": 9,
          "p10": 49,
          "p25": 52.75,
          "p50": 62.45,
          "p75": 114.25,
          "p90": 129.7,
          "ciLo": 55,
          "ciHi": 82
        },
        "anaquel": {
          "refId": "a057-granel-pierna",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 599,
          "states": 29,
          "outlets": 245,
          "p10": 63.72,
          "p25": 79.9,
          "p50": 98,
          "p75": 102,
          "p90": 104,
          "ciLo": 96,
          "ciHi": 98
        },
        "grade": "solo-rango",
        "gradeReason": "la mitad central de las 34 observaciones abarca el 98.5 % del precio y el tope es 40 %. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a057-granel-pierna",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": -1.88,
        "derivaR2": 0.187
      },
      {
        "refId": "a057-granel-pierna-muslo",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a057-granel-pierna-muslo",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 10,
          "states": 3,
          "outlets": 3,
          "p10": 31.8,
          "p25": 31.92,
          "p50": 40,
          "p75": 45,
          "p90": 45.3,
          "ciLo": 31.9,
          "ciHi": 45
        },
        "anaquel": {
          "refId": "a057-granel-pierna-muslo",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 64,
          "states": 9,
          "outlets": 17,
          "p10": 27.23,
          "p25": 28.99,
          "p50": 29.9,
          "p75": 29.99,
          "p90": 32.9,
          "ciLo": 29.9,
          "ciHi": 29.9
        },
        "grade": "solo-rango",
        "gradeReason": "sólo 10 observaciones en el mes y el mínimo para publicar un punto son 12. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a057-granel-pierna-muslo",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 3.76,
        "derivaR2": 0.471
      },
      {
        "refId": "a059-granel-entero",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a059-granel-entero",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 44,
          "states": 8,
          "outlets": 11,
          "p10": 51,
          "p25": 63.75,
          "p50": 72,
          "p75": 84.25,
          "p90": 102,
          "ciLo": 65,
          "ciHi": 81
        },
        "anaquel": {
          "refId": "a059-granel-entero",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 739,
          "states": 30,
          "outlets": 257,
          "p10": 36,
          "p25": 36,
          "p50": 39,
          "p75": 39,
          "p90": 44,
          "ciLo": 38.9,
          "ciHi": 39
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a059-granel-entero",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 0.57,
        "derivaR2": 0.5
      },
      {
        "refId": "a062-granel-pavo",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a062-granel-pavo",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 134,
          "states": 10,
          "outlets": 23,
          "p10": 50,
          "p25": 68,
          "p50": 90,
          "p75": 106.75,
          "p90": 127.1,
          "ciLo": 83.5,
          "ciHi": 96
        },
        "anaquel": {
          "refId": "a062-granel-pavo",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 557,
          "states": 25,
          "outlets": 164,
          "p10": 99.9,
          "p25": 128.5,
          "p50": 155,
          "p75": 434,
          "p90": 460.5,
          "ciLo": 139.9,
          "ciHi": 167
        },
        "grade": "solo-rango",
        "gradeReason": "la mitad central de las 134 observaciones abarca el 43.1 % del precio y el tope es 40 %. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a062-granel-pavo",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 0.16,
        "derivaR2": 0.125
      },
      {
        "refId": "a062-granel-pavo-virginia",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a062-granel-pavo-virginia",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 22,
          "states": 6,
          "outlets": 11,
          "p10": 156.18,
          "p25": 171,
          "p50": 172,
          "p75": 202.5,
          "p90": 210,
          "ciLo": 171,
          "ciHi": 202.5
        },
        "anaquel": {
          "refId": "a062-granel-pavo-virginia",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 3279,
          "states": 26,
          "outlets": 258,
          "p10": 192,
          "p25": 207,
          "p50": 220,
          "p75": 256.5,
          "p90": 270,
          "ciLo": 220,
          "ciHi": 222
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a062-granel-pavo-virginia",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 1.3,
        "derivaR2": 0.062
      },
      {
        "refId": "a062-paquete-290g-pavo-virginia",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a062-paquete-290g-pavo-virginia",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 11,
          "states": 4,
          "outlets": 4,
          "p10": 218.97,
          "p25": 225.64,
          "p50": 241.38,
          "p75": 241.38,
          "p90": 248.28,
          "ciLo": 221.97,
          "ciHi": 241.38
        },
        "anaquel": {
          "refId": "a062-paquete-290g-pavo-virginia",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 675,
          "states": 28,
          "outlets": 272,
          "p10": 192.9,
          "p25": 206.55,
          "p50": 206.9,
          "p75": 218.95,
          "p90": 241.38,
          "ciLo": 206.9,
          "ciHi": 206.9
        },
        "grade": "solo-rango",
        "gradeReason": "sólo 11 observaciones en el mes y el mínimo para publicar un punto son 12. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a062-paquete-290g-pavo-virginia",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 0.87,
        "derivaR2": 0.685
      },
      {
        "refId": "a075-caja-1l-descremada",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a075-caja-1l-descremada",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 23,
          "states": 4,
          "outlets": 10,
          "p10": 23.87,
          "p25": 23.87,
          "p50": 26,
          "p75": 28.55,
          "p90": 29,
          "ciLo": 23.87,
          "ciHi": 28.1
        },
        "anaquel": {
          "refId": "a075-caja-1l-descremada",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 937,
          "states": 29,
          "outlets": 316,
          "p10": 30,
          "p25": 30,
          "p50": 36,
          "p75": 36.9,
          "p90": 37.5,
          "ciLo": 36,
          "ciHi": 36
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a075-caja-1l-descremada",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-pareo-suficiente",
          "states": 3,
          "reason": "Los dos canales coinciden en 3 entidades con muestra suficiente, y hacen falta 5. Un diferencial nacional calculado sobre 3 estados no es un margen, es una anécdota."
        },
        "derivaMensualPct": 0.16,
        "derivaR2": 0.01
      },
      {
        "refId": "a075-caja-1l-entera",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a075-caja-1l-entera",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 28,
          "states": 6,
          "outlets": 6,
          "p10": 20,
          "p25": 23.86,
          "p50": 25.2,
          "p75": 25.55,
          "p90": 31,
          "ciLo": 23.86,
          "ciHi": 25.4
        },
        "anaquel": {
          "refId": "a075-caja-1l-entera",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 3249,
          "states": 30,
          "outlets": 332,
          "p10": 28.5,
          "p25": 31,
          "p50": 35,
          "p75": 37,
          "p90": 38,
          "ciLo": 34.9,
          "ciHi": 35
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a075-caja-1l-entera",
          "period": "2026-05",
          "pct": 41.73,
          "ciLo": 12.1,
          "ciHi": 56.11,
          "verdict": "anaquel-mas-caro",
          "states": 5,
          "reason": null
        },
        "derivaMensualPct": -0.04,
        "derivaR2": 0.002
      },
      {
        "refId": "a085-granel",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a085-granel",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 78,
          "states": 7,
          "outlets": 19,
          "p10": 98,
          "p25": 105,
          "p50": 114,
          "p75": 133.38,
          "p90": 155.3,
          "ciLo": 110,
          "ciHi": 125
        },
        "anaquel": {
          "refId": "a085-granel",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 856,
          "states": 25,
          "outlets": 171,
          "p10": 202,
          "p25": 220,
          "p50": 230,
          "p75": 252,
          "p90": 284,
          "ciLo": 230,
          "ciHi": 230
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a085-granel",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": -1.43,
        "derivaR2": 0.773
      },
      {
        "refId": "a087-granel",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a087-granel",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 53,
          "states": 6,
          "outlets": 13,
          "p10": 98,
          "p25": 98,
          "p50": 115,
          "p75": 140,
          "p90": 169,
          "ciLo": 110,
          "ciHi": 130
        },
        "anaquel": {
          "refId": "a087-granel",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 818,
          "states": 22,
          "outlets": 162,
          "p10": 245,
          "p25": 270.25,
          "p50": 292,
          "p75": 326,
          "p90": 348,
          "ciLo": 279.9,
          "ciHi": 292
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a087-granel",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-calidad",
          "states": 0,
          "reason": "En queso, carne, charcutería y pescado, «misma presentación a granel» no garantiza el mismo bien: la central vende grado mayoreo y el autoservicio charcutería de marca. El número saldría de una diferencia de calidad disfrazada de margen de intermediación. No lo publicamos."
        },
        "derivaMensualPct": 1.11,
        "derivaR2": 0.095
      },
      {
        "refId": "a093-granel-blanco",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a093-granel-blanco",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 49,
          "states": 8,
          "outlets": 12,
          "p10": 26,
          "p25": 28,
          "p50": 32,
          "p75": 37.5,
          "p90": 42,
          "ciLo": 30,
          "ciHi": 34.9
        },
        "anaquel": null,
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a093-granel-blanco",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-canal",
          "states": 0,
          "reason": "El autoservicio no vende esta presentación: 0 observaciones en 2026-05. Comparar contra otra presentación cambiaría el bien, no el canal."
        },
        "derivaMensualPct": -4.87,
        "derivaR2": 0.938
      },
      {
        "refId": "a095-botella-1l",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a095-botella-1l",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 52,
          "states": 10,
          "outlets": 19,
          "p10": 40.8,
          "p25": 42.75,
          "p50": 44.4,
          "p75": 47.78,
          "p90": 54.5,
          "ciLo": 43.62,
          "ciHi": 47
        },
        "anaquel": {
          "refId": "a095-botella-1l",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 960,
          "states": 30,
          "outlets": 325,
          "p10": 39.9,
          "p25": 45,
          "p50": 46,
          "p75": 47.9,
          "p90": 48,
          "ciLo": 46,
          "ciHi": 46
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a095-botella-1l",
          "period": "2026-05",
          "pct": -2.17,
          "ciLo": -7.5,
          "ciHi": 5.11,
          "verdict": "sin-diferencia",
          "states": 10,
          "reason": "El diferencial estimado es de -2.2 %, pero con 10 entidades pareadas el intervalo de confianza del 95 % va de -7.5 % a +5.1 % e incluye el cero. Con esta muestra no se puede afirmar una diferencia."
        },
        "derivaMensualPct": 0.07,
        "derivaR2": 0.013
      },
      {
        "refId": "a095-botella-900ml",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a095-botella-900ml",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 44,
          "states": 8,
          "outlets": 11,
          "p10": 37.78,
          "p25": 38.89,
          "p50": 41,
          "p75": 43.39,
          "p90": 52.92,
          "ciLo": 38.89,
          "ciHi": 42.22
        },
        "anaquel": {
          "refId": "a095-botella-900ml",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 33,
          "states": 6,
          "outlets": 9,
          "p10": 36.11,
          "p25": 36.66,
          "p50": 37.67,
          "p75": 37.67,
          "p90": 38.69,
          "ciLo": 37.67,
          "ciHi": 37.67
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a095-botella-900ml",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-pareo-suficiente",
          "states": 1,
          "reason": "Los dos canales coinciden en 1 entidad con muestra suficiente, y hacen falta 5. Un diferencial nacional calculado sobre 1 estado no es un margen, es una anécdota."
        },
        "derivaMensualPct": 1.89,
        "derivaR2": 0.966
      },
      {
        "refId": "a095-botella-500ml",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a095-botella-500ml",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 36,
          "states": 8,
          "outlets": 15,
          "p10": 43.8,
          "p25": 44.82,
          "p50": 47.9,
          "p75": 49.6,
          "p90": 51,
          "ciLo": 45.14,
          "ciHi": 49.24
        },
        "anaquel": null,
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a095-botella-500ml",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-canal",
          "states": 0,
          "reason": "El autoservicio no vende esta presentación: 0 observaciones en 2026-05. Comparar contra otra presentación cambiaría el bien, no el canal."
        },
        "derivaMensualPct": 1.01,
        "derivaR2": 0.581
      },
      {
        "refId": "a173-granel-estandar",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a173-granel-estandar",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 86,
          "states": 10,
          "outlets": 18,
          "p10": 20,
          "p25": 20.25,
          "p50": 22,
          "p75": 23,
          "p90": 24,
          "ciLo": 21,
          "ciHi": 22
        },
        "anaquel": null,
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a173-granel-estandar",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-canal",
          "states": 0,
          "reason": "El autoservicio no vende esta presentación: 0 observaciones en 2026-05. Comparar contra otra presentación cambiaría el bien, no el canal."
        },
        "derivaMensualPct": 0,
        "derivaR2": 0
      },
      {
        "refId": "a173-granel-refinada",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a173-granel-refinada",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 14,
          "states": 4,
          "outlets": 4,
          "p10": 22.45,
          "p25": 23.5,
          "p50": 28,
          "p75": 32,
          "p90": 37,
          "ciLo": 23.5,
          "ciHi": 32
        },
        "anaquel": null,
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a173-granel-refinada",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-canal",
          "states": 0,
          "reason": "El autoservicio no vende esta presentación: 0 observaciones en 2026-05. Comparar contra otra presentación cambiaría el bien, no el canal."
        },
        "derivaMensualPct": 3.13,
        "derivaR2": 0.203
      },
      {
        "refId": "a173-bolsa-1kg-estandar",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a173-bolsa-1kg-estandar",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 15,
          "states": 3,
          "outlets": 3,
          "p10": 19.97,
          "p25": 20.5,
          "p50": 21.8,
          "p75": 22,
          "p90": 22.12,
          "ciLo": 20.5,
          "ciHi": 22
        },
        "anaquel": {
          "refId": "a173-bolsa-1kg-estandar",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 68,
          "states": 8,
          "outlets": 19,
          "p10": 19,
          "p25": 19,
          "p50": 19,
          "p75": 19,
          "p90": 19,
          "ciLo": 19,
          "ciHi": 19
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a173-bolsa-1kg-estandar",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-pareo-suficiente",
          "states": 1,
          "reason": "Los dos canales coinciden en 1 entidad con muestra suficiente, y hacen falta 5. Un diferencial nacional calculado sobre 1 estado no es un margen, es una anécdota."
        },
        "derivaMensualPct": -0.95,
        "derivaR2": 0.879
      },
      {
        "refId": "a102-granel-alfa",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a102-granel-alfa",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 53,
          "states": 11,
          "outlets": 12,
          "p10": 28,
          "p25": 32,
          "p50": 38,
          "p75": 42,
          "p90": 43,
          "ciLo": 34,
          "ciHi": 40
        },
        "anaquel": {
          "refId": "a102-granel-alfa",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 1054,
          "states": 30,
          "outlets": 318,
          "p10": 35.9,
          "p25": 35.9,
          "p50": 42.9,
          "p75": 63,
          "p90": 69,
          "ciLo": 39.9,
          "ciHi": 42.95
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a102-granel-alfa",
          "period": "2026-05",
          "pct": 38.44,
          "ciLo": 6.17,
          "ciHi": 48.89,
          "verdict": "anaquel-mas-caro",
          "states": 10,
          "reason": null
        },
        "derivaMensualPct": 20.6,
        "derivaR2": 0.949
      },
      {
        "refId": "a112-granel-blanca",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a112-granel-blanca",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 50,
          "states": 10,
          "outlets": 12,
          "p10": 10,
          "p25": 11,
          "p50": 13,
          "p75": 19,
          "p90": 25,
          "ciLo": 12,
          "ciHi": 15
        },
        "anaquel": {
          "refId": "a112-granel-blanca",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 1125,
          "states": 30,
          "outlets": 321,
          "p10": 16,
          "p25": 19.9,
          "p50": 24.8,
          "p75": 34,
          "p90": 35,
          "ciLo": 24.8,
          "ciHi": 25
        },
        "grade": "solo-rango",
        "gradeReason": "la mitad central de las 50 observaciones abarca el 61.5 % del precio y el tope es 40 %. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a112-granel-blanca",
          "period": "2026-05",
          "pct": 46.25,
          "ciLo": -3.85,
          "ciHi": 162.63,
          "verdict": "sin-diferencia",
          "states": 9,
          "reason": "El diferencial estimado es de +46.2 %, pero con 9 entidades pareadas el intervalo de confianza del 95 % va de -3.8 % a +162.6 % e incluye el cero. Con esta muestra no se puede afirmar una diferencia."
        },
        "derivaMensualPct": -0.78,
        "derivaR2": 0.016
      },
      {
        "refId": "a115-a118-granel-jalapeno",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a115-a118-granel-jalapeno",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 57,
          "states": 11,
          "outlets": 13,
          "p10": 17,
          "p25": 20,
          "p50": 28,
          "p75": 35,
          "p90": 60,
          "ciLo": 22,
          "ciHi": 35
        },
        "anaquel": {
          "refId": "a115-a118-granel-jalapeno",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 1013,
          "states": 30,
          "outlets": 314,
          "p10": 13.95,
          "p25": 26.9,
          "p50": 28,
          "p75": 29,
          "p90": 32,
          "ciLo": 28,
          "ciHi": 28
        },
        "grade": "solo-rango",
        "gradeReason": "la mitad central de las 57 observaciones abarca el 53.6 % del precio y el tope es 40 %. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a115-a118-granel-jalapeno",
          "period": "2026-05",
          "pct": -4.11,
          "ciLo": -26.37,
          "ciHi": 26.18,
          "verdict": "sin-diferencia",
          "states": 10,
          "reason": "El diferencial estimado es de -4.1 %, pero con 10 entidades pareadas el intervalo de confianza del 95 % va de -26.4 % a +26.2 % e incluye el cero. Con esta muestra no se puede afirmar una diferencia."
        },
        "derivaMensualPct": 8.78,
        "derivaR2": 0.215
      },
      {
        "refId": "a115-a118-granel-poblano",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a115-a118-granel-poblano",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 33,
          "states": 11,
          "outlets": 12,
          "p10": 45,
          "p25": 55,
          "p50": 65,
          "p75": 79,
          "p90": 84,
          "ciLo": 58,
          "ciHi": 75
        },
        "anaquel": {
          "refId": "a115-a118-granel-poblano",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 820,
          "states": 30,
          "outlets": 295,
          "p10": 84,
          "p25": 104,
          "p50": 114,
          "p75": 119,
          "p90": 123.9,
          "ciLo": 114,
          "ciHi": 114
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a115-a118-granel-poblano",
          "period": "2026-05",
          "pct": 62.86,
          "ciLo": 42.5,
          "ciHi": 93.22,
          "verdict": "anaquel-mas-caro",
          "states": 7,
          "reason": null
        },
        "derivaMensualPct": 12.65,
        "derivaR2": 0.809
      },
      {
        "refId": "a115-a118-granel-habanero",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a115-a118-granel-habanero",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 34,
          "states": 11,
          "outlets": 11,
          "p10": 63.87,
          "p25": 90,
          "p50": 120,
          "p75": 120,
          "p90": 137,
          "ciLo": 100,
          "ciHi": 120
        },
        "anaquel": {
          "refId": "a115-a118-granel-habanero",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 694,
          "states": 30,
          "outlets": 261,
          "p10": 109,
          "p25": 112.23,
          "p50": 129,
          "p75": 145,
          "p90": 164,
          "ciLo": 129,
          "ciHi": 129
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a115-a118-granel-habanero",
          "period": "2026-05",
          "pct": 24.17,
          "ciLo": 10.56,
          "ciHi": 50.59,
          "verdict": "anaquel-mas-caro",
          "states": 9,
          "reason": null
        },
        "derivaMensualPct": 1.55,
        "derivaR2": 0.039
      },
      {
        "refId": "a124-granel-saladette",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a124-granel-saladette",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 53,
          "states": 11,
          "outlets": 13,
          "p10": 28.79,
          "p25": 35,
          "p50": 40,
          "p75": 45,
          "p90": 52.8,
          "ciLo": 36,
          "ciHi": 44
        },
        "anaquel": {
          "refId": "a124-granel-saladette",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 1081,
          "states": 30,
          "outlets": 312,
          "p10": 41.9,
          "p25": 45,
          "p50": 49,
          "p75": 55,
          "p90": 59,
          "ciLo": 49,
          "ciHi": 49.8
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a124-granel-saladette",
          "period": "2026-05",
          "pct": 24.9,
          "ciLo": -3.23,
          "ciHi": 42.57,
          "verdict": "sin-diferencia",
          "states": 8,
          "reason": "El diferencial estimado es de +24.9 %, pero con 8 entidades pareadas el intervalo de confianza del 95 % va de -3.2 % a +42.6 % e incluye el cero. Con esta muestra no se puede afirmar una diferencia."
        },
        "derivaMensualPct": 20.4,
        "derivaR2": 0.884
      },
      {
        "refId": "a124-granel-bola",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a124-granel-bola",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 13,
          "states": 6,
          "outlets": 6,
          "p10": 33,
          "p25": 35,
          "p50": 45,
          "p75": 60,
          "p90": 68,
          "ciLo": 33,
          "ciHi": 60
        },
        "anaquel": {
          "refId": "a124-granel-bola",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 327,
          "states": 30,
          "outlets": 172,
          "p10": 39.9,
          "p25": 39.9,
          "p50": 69.9,
          "p75": 89,
          "p90": 89.95,
          "ciLo": 65,
          "ciHi": 79
        },
        "grade": "solo-rango",
        "gradeReason": "la mitad central de las 13 observaciones abarca el 55.6 % del precio y el tope es 40 %. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a124-granel-bola",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-pareo-suficiente",
          "states": 2,
          "reason": "Los dos canales coinciden en 2 entidades con muestra suficiente, y hacen falta 5. Un diferencial nacional calculado sobre 2 estados no es un margen, es una anécdota."
        },
        "derivaMensualPct": 10.84,
        "derivaR2": 0.77
      },
      {
        "refId": "a137-granel-negro",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a137-granel-negro",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 62,
          "states": 9,
          "outlets": 15,
          "p10": 23,
          "p25": 24,
          "p50": 25,
          "p75": 28,
          "p90": 39,
          "ciLo": 24,
          "ciHi": 26
        },
        "anaquel": null,
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a137-granel-negro",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-canal",
          "states": 0,
          "reason": "El autoservicio no vende esta presentación: 0 observaciones en 2026-05. Comparar contra otra presentación cambiaría el bien, no el canal."
        },
        "derivaMensualPct": -0.97,
        "derivaR2": 0.78
      },
      {
        "refId": "a137-granel-pinto",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a137-granel-pinto",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 63,
          "states": 8,
          "outlets": 15,
          "p10": 18.5,
          "p25": 18.75,
          "p50": 23,
          "p75": 30,
          "p90": 35,
          "ciLo": 22,
          "ciHi": 24
        },
        "anaquel": null,
        "grade": "solo-rango",
        "gradeReason": "la mitad central de las 63 observaciones abarca el 48.9 % del precio y el tope es 40 %. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a137-granel-pinto",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-canal",
          "states": 0,
          "reason": "El autoservicio no vende esta presentación: 0 observaciones en 2026-05. Comparar contra otra presentación cambiaría el bien, no el canal."
        },
        "derivaMensualPct": -4.66,
        "derivaR2": 0.759
      },
      {
        "refId": "a137-granel-peruano",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a137-granel-peruano",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 56,
          "states": 7,
          "outlets": 12,
          "p10": 30,
          "p25": 32,
          "p50": 34,
          "p75": 39,
          "p90": 42,
          "ciLo": 32,
          "ciHi": 35
        },
        "anaquel": null,
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a137-granel-peruano",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-paridad-de-canal",
          "states": 0,
          "reason": "El autoservicio no vende esta presentación: 0 observaciones en 2026-05. Comparar contra otra presentación cambiaría el bien, no el canal."
        },
        "derivaMensualPct": 0,
        "derivaR2": 0
      },
      {
        "refId": "a154-granel-agrio",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a154-granel-agrio",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 45,
          "states": 10,
          "outlets": 12,
          "p10": 22,
          "p25": 25,
          "p50": 25,
          "p75": 30,
          "p90": 34.6,
          "ciLo": 25,
          "ciHi": 28
        },
        "anaquel": {
          "refId": "a154-granel-agrio",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 987,
          "states": 30,
          "outlets": 305,
          "p10": 23.54,
          "p25": 28.9,
          "p50": 35,
          "p75": 40,
          "p90": 45.9,
          "ciLo": 35,
          "ciHi": 35
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a154-granel-agrio",
          "period": "2026-05",
          "pct": 26.95,
          "ciLo": 1.67,
          "ciHi": 40,
          "verdict": "anaquel-mas-caro",
          "states": 9,
          "reason": null
        },
        "derivaMensualPct": -4.74,
        "derivaR2": 0.23
      },
      {
        "refId": "a154-granel-persa",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a154-granel-persa",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 35,
          "states": 9,
          "outlets": 11,
          "p10": 18,
          "p25": 20.95,
          "p50": 30,
          "p75": 35,
          "p90": 39,
          "ciLo": 25,
          "ciHi": 35
        },
        "anaquel": {
          "refId": "a154-granel-persa",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 921,
          "states": 30,
          "outlets": 293,
          "p10": 28.9,
          "p25": 32.9,
          "p50": 40,
          "p75": 45,
          "p90": 59.9,
          "ciLo": 40,
          "ciHi": 42.9
        },
        "grade": "solo-rango",
        "gradeReason": "la mitad central de las 35 observaciones abarca el 46.8 % del precio y el tope es 40 %. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a154-granel-persa",
          "period": "2026-05",
          "pct": 27.27,
          "ciLo": 25.43,
          "ciHi": 59.82,
          "verdict": "anaquel-mas-caro",
          "states": 7,
          "reason": null
        },
        "derivaMensualPct": 13.93,
        "derivaR2": 0.418
      },
      {
        "refId": "a158-granel-red-delicious",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a158-granel-red-delicious",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 49,
          "states": 11,
          "outlets": 14,
          "p10": 38.8,
          "p25": 41,
          "p50": 45,
          "p75": 50,
          "p90": 60,
          "ciLo": 43,
          "ciHi": 47
        },
        "anaquel": {
          "refId": "a158-granel-red-delicious",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 1012,
          "states": 30,
          "outlets": 313,
          "p10": 35.9,
          "p25": 38,
          "p50": 39,
          "p75": 39.8,
          "p90": 49.8,
          "ciLo": 39,
          "ciHi": 39
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a158-granel-red-delicious",
          "period": "2026-05",
          "pct": -12.44,
          "ciLo": -24.01,
          "ciHi": -3,
          "verdict": "central-mas-cara",
          "states": 10,
          "reason": null
        },
        "derivaMensualPct": 1.37,
        "derivaR2": 0.75
      },
      {
        "refId": "a158-granel-golden",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a158-granel-golden",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 39,
          "states": 11,
          "outlets": 13,
          "p10": 45,
          "p25": 45,
          "p50": 49.9,
          "p75": 60,
          "p90": 65,
          "ciLo": 46,
          "ciHi": 55
        },
        "anaquel": {
          "refId": "a158-granel-golden",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 810,
          "states": 30,
          "outlets": 284,
          "p10": 48.89,
          "p25": 57.9,
          "p50": 59,
          "p75": 59.8,
          "p90": 69.9,
          "ciLo": 59,
          "ciHi": 59
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a158-granel-golden",
          "period": "2026-05",
          "pct": 23.51,
          "ciLo": 5.6,
          "ciHi": 31.11,
          "verdict": "anaquel-mas-caro",
          "states": 10,
          "reason": null
        },
        "derivaMensualPct": 0.58,
        "derivaR2": 0.112
      },
      {
        "refId": "a158-granel-granny-smith",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a158-granel-granny-smith",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 26,
          "states": 9,
          "outlets": 11,
          "p10": 49,
          "p25": 50,
          "p50": 60,
          "p75": 65,
          "p90": 65,
          "ciLo": 50,
          "ciHi": 65
        },
        "anaquel": {
          "refId": "a158-granel-granny-smith",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 773,
          "states": 30,
          "outlets": 279,
          "p10": 39,
          "p25": 50,
          "p50": 57.9,
          "p75": 58,
          "p90": 59.9,
          "ciLo": 57.9,
          "ciHi": 57.9
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a158-granel-granny-smith",
          "period": "2026-05",
          "pct": -2.83,
          "ciLo": -26.92,
          "ciHi": 15.8,
          "verdict": "sin-diferencia",
          "states": 6,
          "reason": "El diferencial estimado es de -2.8 %, pero con 6 entidades pareadas el intervalo de confianza del 95 % va de -26.9 % a +15.8 % e incluye el cero. Con esta muestra no se puede afirmar una diferencia."
        },
        "derivaMensualPct": -0.49,
        "derivaR2": 0.038
      },
      {
        "refId": "a160-granel-jugo",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a160-granel-jugo",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 7,
          "states": 3,
          "outlets": 3,
          "p10": 20,
          "p25": 20,
          "p50": 23,
          "p75": 24,
          "p90": 25,
          "ciLo": null,
          "ciHi": null
        },
        "anaquel": {
          "refId": "a160-granel-jugo",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 240,
          "states": 25,
          "outlets": 126,
          "p10": 24.8,
          "p25": 24.9,
          "p50": 26.95,
          "p75": 30,
          "p90": 35.5,
          "ciLo": 26.4,
          "ciHi": 27
        },
        "grade": "solo-rango",
        "gradeReason": "sólo 7 observaciones en el mes y el mínimo para publicar un punto son 12. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a160-granel-jugo",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-pareo-suficiente",
          "states": 1,
          "reason": "Los dos canales coinciden en 1 entidad con muestra suficiente, y hacen falta 5. Un diferencial nacional calculado sobre 1 estado no es un margen, es una anécdota."
        },
        "derivaMensualPct": 0.08,
        "derivaR2": 0.001
      },
      {
        "refId": "a160-granel-valencia",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a160-granel-valencia",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 14,
          "states": 5,
          "outlets": 5,
          "p10": 20,
          "p25": 20.25,
          "p50": 25,
          "p75": 25,
          "p90": 29.7,
          "ciLo": 20,
          "ciHi": 25
        },
        "anaquel": {
          "refId": "a160-granel-valencia",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 393,
          "states": 28,
          "outlets": 169,
          "p10": 25,
          "p25": 27,
          "p50": 30,
          "p75": 32.9,
          "p90": 35.9,
          "ciLo": 29.9,
          "ciHi": 30
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a160-granel-valencia",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-pareo-suficiente",
          "states": 4,
          "reason": "Los dos canales coinciden en 4 entidades con muestra suficiente, y hacen falta 5. Un diferencial nacional calculado sobre 4 estados no es un margen, es una anécdota."
        },
        "derivaMensualPct": 4.05,
        "derivaR2": 0.448
      },
      {
        "refId": "a166-granel-tabasco",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a166-granel-tabasco",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 54,
          "states": 11,
          "outlets": 13,
          "p10": 12.99,
          "p25": 15,
          "p50": 19,
          "p75": 22,
          "p90": 32,
          "ciLo": 17,
          "ciHi": 20
        },
        "anaquel": {
          "refId": "a166-granel-tabasco",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 1103,
          "states": 30,
          "outlets": 321,
          "p10": 16.96,
          "p25": 21,
          "p50": 22,
          "p75": 24,
          "p90": 24.9,
          "ciLo": 21.9,
          "ciHi": 22
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a166-granel-tabasco",
          "period": "2026-05",
          "pct": 19.4,
          "ciLo": -15.85,
          "ciHi": 46,
          "verdict": "sin-diferencia",
          "states": 10,
          "reason": "El diferencial estimado es de +19.4 %, pero con 10 entidades pareadas el intervalo de confianza del 95 % va de -15.9 % a +46.0 % e incluye el cero. Con esta muestra no se puede afirmar una diferencia."
        },
        "derivaMensualPct": -2.87,
        "derivaR2": 0.201
      },
      {
        "refId": "a166-granel-macho",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a166-granel-macho",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 28,
          "states": 9,
          "outlets": 9,
          "p10": 20,
          "p25": 22,
          "p50": 30,
          "p75": 33,
          "p90": 35,
          "ciLo": 25,
          "ciHi": 33
        },
        "anaquel": {
          "refId": "a166-granel-macho",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 687,
          "states": 30,
          "outlets": 263,
          "p10": 32.9,
          "p25": 35,
          "p50": 38.9,
          "p75": 41.9,
          "p90": 42.9,
          "ciLo": 38.9,
          "ciHi": 39.5
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a166-granel-macho",
          "period": "2026-05",
          "pct": 23,
          "ciLo": 17.88,
          "ciHi": 75,
          "verdict": "anaquel-mas-caro",
          "states": 7,
          "reason": null
        },
        "derivaMensualPct": 0,
        "derivaR2": 0
      },
      {
        "refId": "a215-botella-15l",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a215-botella-15l",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 31,
          "states": 5,
          "outlets": 9,
          "p10": 6.64,
          "p25": 7.49,
          "p50": 7.93,
          "p75": 8.67,
          "p90": 9,
          "ciLo": 7.8,
          "ciHi": 8.67
        },
        "anaquel": {
          "refId": "a215-botella-15l",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 2062,
          "states": 27,
          "outlets": 296,
          "p10": 9.33,
          "p25": 9.67,
          "p50": 10,
          "p75": 11,
          "p90": 11.67,
          "ciLo": 10,
          "ciHi": 10.33
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a215-botella-15l",
          "period": "2026-05",
          "pct": 20.77,
          "ciLo": 9.09,
          "ciHi": 27.35,
          "verdict": "anaquel-mas-caro",
          "states": 5,
          "reason": null
        },
        "derivaMensualPct": -0.18,
        "derivaR2": 0.146
      },
      {
        "refId": "a220-lata-355ml",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a220-lata-355ml",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 17,
          "states": 5,
          "outlets": 8,
          "p10": 54.37,
          "p25": 59.15,
          "p50": 66.85,
          "p75": 67.61,
          "p90": 74.99,
          "ciLo": 59.15,
          "ciHi": 67.61
        },
        "anaquel": {
          "refId": "a220-lata-355ml",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 1334,
          "states": 28,
          "outlets": 297,
          "p10": 53.52,
          "p25": 53.52,
          "p50": 57.75,
          "p75": 64.79,
          "p90": 69.01,
          "ciLo": 57.75,
          "ciHi": 60.56
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a220-lata-355ml",
          "period": "2026-05",
          "pct": -10.34,
          "ciLo": -16.67,
          "ciHi": 11.4,
          "verdict": "sin-diferencia",
          "states": 5,
          "reason": "El diferencial estimado es de -10.3 %, pero con 5 entidades pareadas el intervalo de confianza del 95 % va de -16.7 % a +11.4 % e incluye el cero. Con esta muestra no se puede afirmar una diferencia."
        },
        "derivaMensualPct": 4.57,
        "derivaR2": 0.84
      },
      {
        "refId": "a220-botella-3l",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a220-botella-3l",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 15,
          "states": 4,
          "outlets": 6,
          "p10": 11.82,
          "p25": 11.82,
          "p50": 13.28,
          "p75": 14.17,
          "p90": 14.35,
          "ciLo": 11.82,
          "ciHi": 14.17
        },
        "anaquel": {
          "refId": "a220-botella-3l",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 3181,
          "states": 28,
          "outlets": 302,
          "p10": 13.67,
          "p25": 14,
          "p50": 15,
          "p75": 16.33,
          "p90": 17,
          "ciLo": 15,
          "ciHi": 15
        },
        "grade": "publicable",
        "gradeReason": null,
        "margin": {
          "refId": "a220-botella-3l",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-pareo-suficiente",
          "states": 2,
          "reason": "Los dos canales coinciden en 2 entidades con muestra suficiente, y hacen falta 5. Un diferencial nacional calculado sobre 2 estados no es un margen, es una anécdota."
        },
        "derivaMensualPct": -0.06,
        "derivaR2": 0.001
      },
      {
        "refId": "a220-botella-1l",
        "period": "2026-05",
        "geography": "MX",
        "central": {
          "refId": "a220-botella-1l",
          "channel": "central",
          "geography": "MX",
          "period": "2026-05",
          "n": 7,
          "states": 2,
          "outlets": 3,
          "p10": 31.5,
          "p25": 31.5,
          "p50": 31.5,
          "p75": 34.4,
          "p90": 35.84,
          "ciLo": null,
          "ciHi": null
        },
        "anaquel": {
          "refId": "a220-botella-1l",
          "channel": "autoservicio",
          "geography": "MX",
          "period": "2026-05",
          "n": 897,
          "states": 19,
          "outlets": 216,
          "p10": 29,
          "p25": 30,
          "p50": 30,
          "p75": 31,
          "p90": 31.9,
          "ciLo": 30,
          "ciHi": 30.5
        },
        "grade": "solo-rango",
        "gradeReason": "sólo 7 observaciones en el mes y el mínimo para publicar un punto son 12; sólo 2 entidades con observación y el mínimo son 3. Convoque por rango, o por entidad.",
        "margin": {
          "refId": "a220-botella-1l",
          "period": "2026-05",
          "pct": null,
          "ciLo": null,
          "ciHi": null,
          "verdict": "sin-pareo-suficiente",
          "states": 2,
          "reason": "Los dos canales coinciden en 2 entidades con muestra suficiente, y hacen falta 5. Un diferencial nacional calculado sobre 2 estados no es un margen, es una anécdota."
        },
        "derivaMensualPct": -1.19,
        "derivaR2": 0.125
      }
    ],
    "rankings": [
      {
        "refId": "a004-granel",
        "period": "2026-05",
        "commonStates": [
          "01",
          "03",
          "04",
          "07",
          "09",
          "11",
          "12",
          "14",
          "15",
          "16",
          "17",
          "20",
          "21",
          "22",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 13,
            "n": 19,
            "states": 19
          },
          {
            "chainId": "soriana",
            "p50": 13.9,
            "n": 19,
            "states": 19
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 14.5,
            "n": 19,
            "states": 19
          },
          {
            "chainId": "walmart",
            "p50": 14.5,
            "n": 19,
            "states": 19
          },
          {
            "chainId": "tortillerias",
            "p50": 25,
            "n": 19,
            "states": 19
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 23.75,
          "n": 4,
          "states": 19
        }
      },
      {
        "refId": "a009-paquete-spaghetti",
        "period": "2026-05",
        "commonStates": [
          "09",
          "15",
          "21",
          "27",
          "29"
        ],
        "chains": [
          {
            "chainId": "soriana",
            "p50": 22.5,
            "n": 5,
            "states": 5
          },
          {
            "chainId": "chedraui",
            "p50": 30,
            "n": 5,
            "states": 5
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 65,
            "n": 5,
            "states": 5
          },
          {
            "chainId": "walmart",
            "p50": 67.5,
            "n": 5,
            "states": 5
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 42.78,
          "n": 3,
          "states": 5
        }
      },
      {
        "refId": "a015-paquete-620g",
        "period": "2026-05",
        "commonStates": [
          "01",
          "03",
          "04",
          "07",
          "09",
          "11",
          "12",
          "14",
          "15",
          "17",
          "20",
          "21",
          "22",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 74.19,
            "n": 18,
            "states": 18
          },
          {
            "chainId": "walmart",
            "p50": 79.84,
            "n": 18,
            "states": 18
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 80.65,
            "n": 18,
            "states": 18
          },
          {
            "chainId": "soriana",
            "p50": 88.55,
            "n": 18,
            "states": 18
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 78.71,
          "n": 7,
          "states": 18
        }
      },
      {
        "refId": "a015-paquete-210g-tostado",
        "period": "2026-05",
        "commonStates": [
          "09",
          "11",
          "12",
          "14",
          "15",
          "21",
          "22",
          "27",
          "28",
          "29",
          "31"
        ],
        "chains": [
          {
            "chainId": "bodega-aurrera",
            "p50": 185.71,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "chedraui",
            "p50": 185.71,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "walmart",
            "p50": 185.71,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "soriana",
            "p50": 189.52,
            "n": 11,
            "states": 11
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 166.67,
          "n": 4,
          "states": 11
        }
      },
      {
        "refId": "a038-granel-milanesa",
        "period": "2026-05",
        "commonStates": [
          "09",
          "11",
          "12",
          "14",
          "15",
          "27",
          "29",
          "31"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 118.5,
            "n": 8,
            "states": 8
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 120,
            "n": 8,
            "states": 8
          },
          {
            "chainId": "walmart",
            "p50": 121,
            "n": 8,
            "states": 8
          },
          {
            "chainId": "soriana",
            "p50": 132,
            "n": 8,
            "states": 8
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 120,
          "n": 5,
          "states": 8
        }
      },
      {
        "refId": "a042-granel-chuleta",
        "period": "2026-05",
        "commonStates": [
          "04",
          "09",
          "11",
          "14",
          "15",
          "21",
          "22",
          "29",
          "31"
        ],
        "chains": [
          {
            "chainId": "walmart",
            "p50": 97,
            "n": 9,
            "states": 9
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 104.5,
            "n": 9,
            "states": 9
          },
          {
            "chainId": "chedraui",
            "p50": 104.5,
            "n": 9,
            "states": 9
          },
          {
            "chainId": "soriana",
            "p50": 114,
            "n": 9,
            "states": 9
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 114,
          "n": 5,
          "states": 9
        }
      },
      {
        "refId": "a052-granel-pierna",
        "period": "2026-05",
        "commonStates": [
          "01",
          "04",
          "09",
          "11",
          "15",
          "20",
          "21",
          "27",
          "29",
          "30"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 338,
            "n": 10,
            "states": 10
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 350,
            "n": 10,
            "states": 10
          },
          {
            "chainId": "walmart",
            "p50": 352,
            "n": 10,
            "states": 10
          },
          {
            "chainId": "soriana",
            "p50": 389,
            "n": 10,
            "states": 10
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 185,
          "n": 1,
          "states": 10
        }
      },
      {
        "refId": "a059-granel-entero",
        "period": "2026-05",
        "commonStates": [
          "01",
          "07",
          "09",
          "15",
          "16",
          "17",
          "22",
          "27",
          "28",
          "30"
        ],
        "chains": [
          {
            "chainId": "bodega-aurrera",
            "p50": 36,
            "n": 10,
            "states": 10
          },
          {
            "chainId": "chedraui",
            "p50": 37.5,
            "n": 10,
            "states": 10
          },
          {
            "chainId": "soriana",
            "p50": 38.17,
            "n": 10,
            "states": 10
          },
          {
            "chainId": "walmart",
            "p50": 39,
            "n": 10,
            "states": 10
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 65,
          "n": 3,
          "states": 10
        }
      },
      {
        "refId": "a062-granel-pavo-virginia",
        "period": "2026-05",
        "commonStates": [
          "01",
          "03",
          "04",
          "07",
          "09",
          "11",
          "14",
          "15",
          "20",
          "21",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        "chains": [
          {
            "chainId": "bodega-aurrera",
            "p50": 219,
            "n": 15,
            "states": 15
          },
          {
            "chainId": "chedraui",
            "p50": 220,
            "n": 15,
            "states": 15
          },
          {
            "chainId": "walmart",
            "p50": 220,
            "n": 15,
            "states": 15
          },
          {
            "chainId": "soriana",
            "p50": 252.52,
            "n": 15,
            "states": 15
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 187.01,
          "n": 2,
          "states": 15
        }
      },
      {
        "refId": "a062-paquete-290g-pavo-virginia",
        "period": "2026-05",
        "commonStates": [
          "09",
          "11",
          "14",
          "15",
          "21",
          "31"
        ],
        "chains": [
          {
            "chainId": "bodega-aurrera",
            "p50": 200,
            "n": 6,
            "states": 6
          },
          {
            "chainId": "chedraui",
            "p50": 203.45,
            "n": 6,
            "states": 6
          },
          {
            "chainId": "walmart",
            "p50": 206.9,
            "n": 6,
            "states": 6
          },
          {
            "chainId": "soriana",
            "p50": 227.41,
            "n": 6,
            "states": 6
          }
        ],
        "central": null
      },
      {
        "refId": "a075-caja-1l-descremada",
        "period": "2026-05",
        "commonStates": [
          "03",
          "09",
          "11",
          "12",
          "14",
          "15",
          "20",
          "21",
          "22",
          "27",
          "28",
          "29",
          "31"
        ],
        "chains": [
          {
            "chainId": "bodega-aurrera",
            "p50": 30,
            "n": 13,
            "states": 13
          },
          {
            "chainId": "chedraui",
            "p50": 30.5,
            "n": 13,
            "states": 13
          },
          {
            "chainId": "walmart",
            "p50": 36,
            "n": 13,
            "states": 13
          },
          {
            "chainId": "soriana",
            "p50": 36.7,
            "n": 13,
            "states": 13
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 25.94,
          "n": 2,
          "states": 13
        }
      },
      {
        "refId": "a075-caja-1l-entera",
        "period": "2026-05",
        "commonStates": [
          "01",
          "03",
          "04",
          "07",
          "09",
          "11",
          "12",
          "14",
          "15",
          "16",
          "17",
          "20",
          "21",
          "22",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 31,
            "n": 19,
            "states": 19
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 34,
            "n": 19,
            "states": 19
          },
          {
            "chainId": "walmart",
            "p50": 36.5,
            "n": 19,
            "states": 19
          },
          {
            "chainId": "soriana",
            "p50": 37.5,
            "n": 19,
            "states": 19
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 23.86,
          "n": 3,
          "states": 19
        }
      },
      {
        "refId": "a095-botella-1l",
        "period": "2026-05",
        "commonStates": [
          "03",
          "09",
          "11",
          "12",
          "14",
          "15",
          "17",
          "22",
          "27",
          "28",
          "29",
          "31"
        ],
        "chains": [
          {
            "chainId": "bodega-aurrera",
            "p50": 45,
            "n": 12,
            "states": 12
          },
          {
            "chainId": "chedraui",
            "p50": 46,
            "n": 12,
            "states": 12
          },
          {
            "chainId": "walmart",
            "p50": 46,
            "n": 12,
            "states": 12
          },
          {
            "chainId": "soriana",
            "p50": 47.8,
            "n": 12,
            "states": 12
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 45.02,
          "n": 6,
          "states": 12
        }
      },
      {
        "refId": "a102-granel-alfa",
        "period": "2026-05",
        "commonStates": [
          "01",
          "03",
          "04",
          "07",
          "09",
          "11",
          "12",
          "14",
          "15",
          "16",
          "17",
          "20",
          "21",
          "22",
          "27",
          "28",
          "29",
          "30"
        ],
        "chains": [
          {
            "chainId": "soriana",
            "p50": 35.9,
            "n": 18,
            "states": 18
          },
          {
            "chainId": "chedraui",
            "p50": 38,
            "n": 18,
            "states": 18
          },
          {
            "chainId": "walmart",
            "p50": 66,
            "n": 18,
            "states": 18
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 68,
            "n": 18,
            "states": 18
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 39.5,
          "n": 6,
          "states": 18
        }
      },
      {
        "refId": "a112-granel-blanca",
        "period": "2026-05",
        "commonStates": [
          "01",
          "03",
          "04",
          "07",
          "09",
          "11",
          "12",
          "14",
          "15",
          "16",
          "17",
          "20",
          "21",
          "22",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 16,
            "n": 19,
            "states": 19
          },
          {
            "chainId": "soriana",
            "p50": 21.8,
            "n": 19,
            "states": 19
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 34,
            "n": 19,
            "states": 19
          },
          {
            "chainId": "walmart",
            "p50": 35,
            "n": 19,
            "states": 19
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 14,
          "n": 6,
          "states": 19
        }
      },
      {
        "refId": "a115-a118-granel-jalapeno",
        "period": "2026-05",
        "commonStates": [
          "01",
          "03",
          "04",
          "07",
          "09",
          "11",
          "12",
          "14",
          "15",
          "16",
          "21",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 14.5,
            "n": 16,
            "states": 16
          },
          {
            "chainId": "soriana",
            "p50": 26.9,
            "n": 16,
            "states": 16
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 28,
            "n": 16,
            "states": 16
          },
          {
            "chainId": "walmart",
            "p50": 28,
            "n": 16,
            "states": 16
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 35,
          "n": 7,
          "states": 16
        }
      },
      {
        "refId": "a115-a118-granel-poblano",
        "period": "2026-05",
        "commonStates": [
          "09",
          "11",
          "12",
          "14",
          "15",
          "17",
          "21",
          "22",
          "29"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 110,
            "n": 9,
            "states": 9
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 114,
            "n": 9,
            "states": 9
          },
          {
            "chainId": "soriana",
            "p50": 119,
            "n": 9,
            "states": 9
          },
          {
            "chainId": "walmart",
            "p50": 119,
            "n": 9,
            "states": 9
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 64.5,
          "n": 2,
          "states": 9
        }
      },
      {
        "refId": "a115-a118-granel-habanero",
        "period": "2026-05",
        "commonStates": [
          "09",
          "11",
          "12",
          "14",
          "15",
          "17",
          "21",
          "22",
          "27",
          "29"
        ],
        "chains": [
          {
            "chainId": "soriana",
            "p50": 112,
            "n": 10,
            "states": 10
          },
          {
            "chainId": "chedraui",
            "p50": 120,
            "n": 10,
            "states": 10
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 129,
            "n": 10,
            "states": 10
          },
          {
            "chainId": "walmart",
            "p50": 129,
            "n": 10,
            "states": 10
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 110,
          "n": 4,
          "states": 10
        }
      },
      {
        "refId": "a124-granel-saladette",
        "period": "2026-05",
        "commonStates": [
          "01",
          "03",
          "04",
          "09",
          "11",
          "12",
          "14",
          "15",
          "16",
          "17",
          "20",
          "21",
          "22",
          "27",
          "28",
          "29",
          "30"
        ],
        "chains": [
          {
            "chainId": "soriana",
            "p50": 44.95,
            "n": 17,
            "states": 17
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 45,
            "n": 17,
            "states": 17
          },
          {
            "chainId": "chedraui",
            "p50": 45,
            "n": 17,
            "states": 17
          },
          {
            "chainId": "walmart",
            "p50": 55,
            "n": 17,
            "states": 17
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 37,
          "n": 5,
          "states": 17
        }
      },
      {
        "refId": "a154-granel-agrio",
        "period": "2026-05",
        "commonStates": [
          "03",
          "09",
          "11",
          "14",
          "15",
          "16",
          "17",
          "20",
          "21",
          "22",
          "28"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 21,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "soriana",
            "p50": 31,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 35,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "walmart",
            "p50": 40,
            "n": 11,
            "states": 11
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 28,
          "n": 4,
          "states": 11
        }
      },
      {
        "refId": "a154-granel-persa",
        "period": "2026-05",
        "commonStates": [
          "01",
          "07",
          "09",
          "11",
          "14",
          "15",
          "16",
          "17",
          "21",
          "22",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        "chains": [
          {
            "chainId": "soriana",
            "p50": 31,
            "n": 15,
            "states": 15
          },
          {
            "chainId": "chedraui",
            "p50": 39.9,
            "n": 15,
            "states": 15
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 40,
            "n": 15,
            "states": 15
          },
          {
            "chainId": "walmart",
            "p50": 45,
            "n": 15,
            "states": 15
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 27.5,
          "n": 5,
          "states": 15
        }
      },
      {
        "refId": "a158-granel-red-delicious",
        "period": "2026-05",
        "commonStates": [
          "04",
          "09",
          "11",
          "12",
          "14",
          "15",
          "21",
          "22",
          "27",
          "28",
          "29"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 37,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 39,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "walmart",
            "p50": 39,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "soriana",
            "p50": 39.8,
            "n": 11,
            "states": 11
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 50,
          "n": 5,
          "states": 11
        }
      },
      {
        "refId": "a158-granel-golden",
        "period": "2026-05",
        "commonStates": [
          "09",
          "11",
          "15",
          "17",
          "22",
          "27",
          "29"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 54.9,
            "n": 7,
            "states": 7
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 58,
            "n": 7,
            "states": 7
          },
          {
            "chainId": "walmart",
            "p50": 59,
            "n": 7,
            "states": 7
          },
          {
            "chainId": "soriana",
            "p50": 59.8,
            "n": 7,
            "states": 7
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 52.5,
          "n": 4,
          "states": 7
        }
      },
      {
        "refId": "a158-granel-granny-smith",
        "period": "2026-05",
        "commonStates": [
          "09",
          "11",
          "12",
          "15",
          "22",
          "27",
          "28",
          "29"
        ],
        "chains": [
          {
            "chainId": "walmart",
            "p50": 39,
            "n": 8,
            "states": 8
          },
          {
            "chainId": "chedraui",
            "p50": 52.63,
            "n": 8,
            "states": 8
          },
          {
            "chainId": "soriana",
            "p50": 57.9,
            "n": 8,
            "states": 8
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 58,
            "n": 8,
            "states": 8
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 52.5,
          "n": 4,
          "states": 8
        }
      },
      {
        "refId": "a166-granel-tabasco",
        "period": "2026-05",
        "commonStates": [
          "03",
          "04",
          "07",
          "09",
          "11",
          "12",
          "14",
          "15",
          "16",
          "17",
          "20",
          "21",
          "22",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 16,
            "n": 18,
            "states": 18
          },
          {
            "chainId": "soriana",
            "p50": 21.9,
            "n": 18,
            "states": 18
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 24,
            "n": 18,
            "states": 18
          },
          {
            "chainId": "walmart",
            "p50": 24,
            "n": 18,
            "states": 18
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 16.25,
          "n": 6,
          "states": 18
        }
      },
      {
        "refId": "a166-granel-macho",
        "period": "2026-05",
        "commonStates": [
          "09",
          "12",
          "15",
          "17",
          "27"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 32.95,
            "n": 5,
            "states": 5
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 38.9,
            "n": 5,
            "states": 5
          },
          {
            "chainId": "walmart",
            "p50": 39.9,
            "n": 5,
            "states": 5
          },
          {
            "chainId": "soriana",
            "p50": 41.9,
            "n": 5,
            "states": 5
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 21,
          "n": 1,
          "states": 5
        }
      },
      {
        "refId": "a215-botella-15l",
        "period": "2026-05",
        "commonStates": [
          "01",
          "03",
          "07",
          "09",
          "11",
          "12",
          "14",
          "15",
          "21",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 9.67,
            "n": 14,
            "states": 14
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 10,
            "n": 14,
            "states": 14
          },
          {
            "chainId": "walmart",
            "p50": 10.16,
            "n": 14,
            "states": 14
          },
          {
            "chainId": "soriana",
            "p50": 11,
            "n": 14,
            "states": 14
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 8.84,
          "n": 4,
          "states": 14
        }
      },
      {
        "refId": "a220-lata-355ml",
        "period": "2026-05",
        "commonStates": [
          "03",
          "07",
          "09",
          "11",
          "15",
          "20",
          "27",
          "28",
          "29",
          "30",
          "31"
        ],
        "chains": [
          {
            "chainId": "walmart",
            "p50": 53.52,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 56.34,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "chedraui",
            "p50": 56.34,
            "n": 11,
            "states": 11
          },
          {
            "chainId": "soriana",
            "p50": 64.79,
            "n": 11,
            "states": 11
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 66.01,
          "n": 4,
          "states": 11
        }
      },
      {
        "refId": "a220-botella-3l",
        "period": "2026-05",
        "commonStates": [
          "01",
          "03",
          "07",
          "09",
          "11",
          "12",
          "14",
          "15",
          "20",
          "21",
          "27",
          "28",
          "29",
          "30"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 14.33,
            "n": 14,
            "states": 14
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 14.84,
            "n": 14,
            "states": 14
          },
          {
            "chainId": "walmart",
            "p50": 15,
            "n": 14,
            "states": 14
          },
          {
            "chainId": "soriana",
            "p50": 15.97,
            "n": 14,
            "states": 14
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 13.57,
          "n": 2,
          "states": 14
        }
      },
      {
        "refId": "a220-botella-1l",
        "period": "2026-05",
        "commonStates": [
          "03",
          "09",
          "11",
          "12",
          "15",
          "27",
          "29"
        ],
        "chains": [
          {
            "chainId": "chedraui",
            "p50": 28.5,
            "n": 7,
            "states": 7
          },
          {
            "chainId": "bodega-aurrera",
            "p50": 30,
            "n": 7,
            "states": 7
          },
          {
            "chainId": "walmart",
            "p50": 30.5,
            "n": 7,
            "states": 7
          },
          {
            "chainId": "soriana",
            "p50": 31.9,
            "n": 7,
            "states": 7
          }
        ],
        "central": {
          "chainId": "central-abasto",
          "p50": 32.95,
          "n": 2,
          "states": 7
        }
      }
    ],
    "series": [
      {
        "refId": "a004-granel",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a004-granel",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 13.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 13.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 13.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 13.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 14.4,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a009-paquete-spaghetti",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 40,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 40,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 38.63,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 39,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 38.2,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a009-paquete-spaghetti",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 32.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a015-paquete-620g",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 79.03,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 79.03,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 78.39,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 79.03,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 78.87,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a015-paquete-620g",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 86.94,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 86.29,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 83.87,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 86.94,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 86.94,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a015-paquete-210g-tostado",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 161.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 163.1,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 158.1,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 161.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 165.71,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a015-paquete-210g-tostado",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 185.71,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 185.71,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 185.67,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 185.71,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 185.71,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a019-granel-grande",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 21,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 20,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 22,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 20,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 20,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a019-bolsa-1kg-super-extra",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 37.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 35.78,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 35.61,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 34.15,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 33.25,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a019-bolsa-1kg-super-extra",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 37,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 37,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 36,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 37,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 38,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a019-granel-quebrado",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 15.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 16,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 15,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 15,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 15,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a025-granel-diezmillo",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 208.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 205,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 210,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a025-granel-diezmillo",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 269,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 274.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 274,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 274.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 274.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a025-granel-milanesa",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 232,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a025-granel-milanesa",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 229,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 228,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 229,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 229,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 229.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a025-granel-espaldilla",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 217.25,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 230,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 230,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 230,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 232,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a034-granel-molida",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 230,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 202,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 200,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 209,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 209,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a034-granel-molida",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 142,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 139.95,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 126,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 138.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 147,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a034-granel-molida-popular",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 157,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 151.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 149.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 145,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 145,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a038-granel-milanesa",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 122,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 115,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 110,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 110,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 110,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a038-granel-milanesa",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 132,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 132,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 128.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 119.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 123,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a042-granel-chuleta",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 99,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 98,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 102,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 99,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 104,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a042-granel-chuleta",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 119,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 119,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 118,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 116,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 108.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a049-granel-longaniza",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 113.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 115,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 108.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 115,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 112,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a049-granel-longaniza",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 110,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 108,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 112,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 108,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 108,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a052-granel-pierna-horneado",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 145,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 150,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 152,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 144,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 140,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a052-granel-pierna-horneado",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 150,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 150,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 150,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 150,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 150,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a052-granel-pierna",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 372.8,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 304.7,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 236.59,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 236.59,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 236.59,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a052-granel-pierna",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 320,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 352,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 354,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 354.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 358,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a052-granel-pierna-horneado-especial",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 150,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 151,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 140,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 140,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a052-granel-pierna-horneado-especial",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 156.6,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 156.6,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 156.6,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 150,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 166.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a055-granel-viena",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 45.23,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 48.81,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 48.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 46.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 48.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a055-granel-viena",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 81.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 81.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 81.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 81.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 81.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a057-granel-pechuga",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 99,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 105,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 115.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 116,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 120,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a057-granel-pechuga",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 139.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 139,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 140,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 144,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 149,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a057-granel-pierna",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 62.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 70,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 65.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 58,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 62.45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a057-granel-pierna",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 94,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 95,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 89.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 89.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 98,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a057-granel-pierna-muslo",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 35.95,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 38.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 42,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 40,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a057-granel-pierna-muslo",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 31.45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 29.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 29.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 29.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 29.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a059-granel-entero",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 70,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 70,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 70,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 70,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 72,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a059-granel-entero",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 49.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 49.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 44,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 44,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 39,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a062-granel-pavo",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 90,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 88.58,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 90,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 90,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 90,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a062-granel-pavo",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 157.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 157.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 155,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 157.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 155,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a062-granel-pavo-virginia",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 157.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 195,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 172,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 186,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 172,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a062-granel-pavo-virginia",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 223.6,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a062-paquete-290g-pavo-virginia",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 234.48,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 234.48,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 233.62,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 241.38,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 241.38,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a062-paquete-290g-pavo-virginia",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 189.66,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 206.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 206.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 206.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 206.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a075-caja-1l-descremada",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 26.6,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 25,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 26.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 26.6,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a075-caja-1l-descremada",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 36,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 36,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 36,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 36,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 36,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a075-caja-1l-entera",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 25.3,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 25.3,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 24.51,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 25.4,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 25.2,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a075-caja-1l-entera",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 36,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 35.99,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 34,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 34,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 35,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a085-granel",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 121,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 120.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 121,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 117.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 114,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a085-granel",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 227,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 220,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 230,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a087-granel",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 115,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 114.65,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 110,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 128,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 115,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a087-granel",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 272,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 278,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 280.54,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 287,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 292,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a093-granel-blanco",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 39.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 36,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 35,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 33.99,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 32,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a095-botella-1l",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 44,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 44,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 43.4,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 43.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 44.4,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a095-botella-1l",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 41,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 41,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 42,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 46,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a095-botella-900ml",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 37.78,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 38.89,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 39.44,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 39.82,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 41,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a095-botella-900ml",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 36.56,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 36.56,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 36.11,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 36.56,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 37.67,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a095-botella-500ml",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 45.6,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 45.7,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 45.8,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 45.8,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 47.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a173-granel-estandar",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 22,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 22,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 22,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 22,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 22,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a173-granel-refinada",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 24,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 32,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 28,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a173-bolsa-1kg-estandar",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 22.76,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 22.2,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 22.2,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 22,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 21.8,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a173-bolsa-1kg-estandar",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 20,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 20,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 20,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 19,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 19,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a102-granel-alfa",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 17.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 25,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 28,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 34.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 38,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a102-granel-alfa",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 30.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 34.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 36.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 36,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 42.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a112-granel-blanca",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 15,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 13,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 13,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 16,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 13,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a112-granel-blanca",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 29.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 25,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 23.8,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 24.8,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a115-a118-granel-jalapeno",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 25,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 35,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 50,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 28,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a115-a118-granel-jalapeno",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 25.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 26.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 26.8,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 26.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 28,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a115-a118-granel-poblano",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 58,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 71,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 65,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a115-a118-granel-poblano",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 69,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 66.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 69.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 103.95,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 114,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a115-a118-granel-habanero",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 120,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 90,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 100,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 105,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 120,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a115-a118-granel-habanero",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 123.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 124.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 128,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 129,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 129,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a124-granel-saladette",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 20,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 25,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 35.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 40,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 40,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a124-granel-saladette",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 21.99,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 23.2,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 54.6,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 49,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a124-granel-bola",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 34.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 50,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a124-granel-bola",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 27.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 27.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 38.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 48.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 69.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a137-granel-negro",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 26,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 25.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 25,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a137-granel-pinto",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 28,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 25,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 23,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 23,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 23,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a137-granel-peruano",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 34,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 34,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 34,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 34,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 34,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a154-granel-agrio",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 29.99,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 35,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 38,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 31,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 25,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a154-granel-agrio",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 37.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 39.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 53.99,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 46.38,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 35,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a154-granel-persa",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 18,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 29,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 40,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 38.45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a154-granel-persa",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 27.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 33.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 39.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 59,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 40,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a158-granel-red-delicious",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 43,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 43,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 45,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a158-granel-red-delicious",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 36.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 35.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 37,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 39,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 39,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a158-granel-golden",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 50,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 47,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 48.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 50,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 49.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a158-granel-golden",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 49.8,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 50.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 52,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 54,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 59,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a158-granel-granny-smith",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 64,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 60,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 60,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 65,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 60,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a158-granel-granny-smith",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 56.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 54.8,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 55,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 52.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 57.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a160-granel-jugo",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 20,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 18.75,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 18.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 20,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 23,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a160-granel-jugo",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 26.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 25,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 25.9,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 26.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 26.95,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a160-granel-valencia",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 20.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 20,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 21.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 20,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 25,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a160-granel-valencia",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 29.5,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-02",
            "value": 29.55,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-03",
            "value": 27,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-04",
            "value": 27,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          },
          {
            "period": "2026-05",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "low"
          }
        ]
      },
      {
        "refId": "a166-granel-tabasco",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 21,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 23,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 24.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 21,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 19,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a166-granel-tabasco",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 22.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 25.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 27.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 22,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 22,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a166-granel-macho",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a166-granel-macho",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 38.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 38.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 38.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 38.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 38.9,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a215-botella-15l",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 8,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 7.87,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 7.87,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 7.87,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 7.93,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a215-botella-15l",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 10.67,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 10.67,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 10.27,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 10.27,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 10,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a220-lata-355ml",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 57.04,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 59.15,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 59.15,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 67.32,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 66.85,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a220-lata-355ml",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 57.75,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 61.97,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 61.97,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 58.87,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 57.75,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a220-botella-3l",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 13.57,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 13.65,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 14.17,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 14.17,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 13.28,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a220-botella-3l",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 16.33,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 15.83,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 15.33,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 15,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 15,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a220-botella-1l",
        "channel": "central",
        "points": [
          {
            "period": "2026-01",
            "value": 34.4,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 31.35,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 31.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 33,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 31.5,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      },
      {
        "refId": "a220-botella-1l",
        "channel": "autoservicio",
        "points": [
          {
            "period": "2026-01",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-02",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-03",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-04",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          },
          {
            "period": "2026-05",
            "value": 30,
            "sourceId": "profeco-qqp",
            "confidence": "medium"
          }
        ]
      }
    ],
    "contrasteInegi": {
      "period": "2026-05",
      "renglones": 29,
      "desviacionMedianaPct": 21.2,
      "dentroDe10": 7
    },
    "cobertura": {
      "quincenas": [
        "01-2026_Q1",
        "01-2026_Q2",
        "02-2026_Q1",
        "02-2026_Q2",
        "03-2026_Q1",
        "03-2026_Q2",
        "04-2026_Q1",
        "04-2026_Q2",
        "05-2026_Q1",
        "05-2026_Q2"
      ],
      "faltantes": [
        "06-2026_Q1",
        "06-2026_Q2",
        "07-2026_Q1",
        "07-2026_Q2"
      ]
    },
    "detailFile": "precio-base-2026.json",
    "detailRows": 9941
  },
  "contextFacts": [
    {
      "id": "salario-minimo-mensual",
      "label": "Salario mínimo mensual vigente",
      "value": 9582.466666666667,
      "unit": "MXN_hogar_mes",
      "displayValue": "$9,582.47",
      "asOf": "2026-01",
      "sourceId": "conasami-salario-minimo",
      "confidence": "high"
    }
  ],
  "notes": [
    {
      "id": "contraste-coneval",
      "kind": "metodologia",
      "title": "La serie fue contrastada contra el archivo histórico de CONEVAL",
      "body": "Los 1596 valores del tramo común (1992-01 a 2025-03) coinciden al centavo con el archivo histórico que publicó CONEVAL antes de que el INEGI asumiera la medición.",
      "sourceUrl": "https://www.coneval.org.mx/Medicion/Documents/Lineas_de_Pobreza_por_Ingresos/Lineas_de_Pobreza_por_Ingresos.zip"
    },
    {
      "id": "total-no-cuadra-2026-05-urbano",
      "kind": "advertencia",
      "title": "En 2026-05 el desglose por producto no suma el total publicado (ámbito urbano)",
      "body": "El boletín del INEGI publica un total de $2597.37 para la canasta alimentaria urbana de ese mes, pero la suma de los valores mensuales que él mismo imprime por renglón da $2593.30: una diferencia de $4.07. La discrepancia está en el documento fuente, no en esta herramienta: los renglones se leen tal como los imprime el boletín, sin recalcularlos. La cifra de canasta que muestra esta app es el total oficial, no la suma de renglones.",
      "appliesTo": [
        "canasta-alimentaria"
      ],
      "period": "2026-05",
      "sourceUrl": "https://www.inegi.org.mx/contenidos/saladeprensa/boletines/2026/lp/lp2026_06.pdf"
    },
    {
      "id": "contraste-boletines",
      "kind": "metodologia",
      "title": "Los boletines confirman la serie principal",
      "body": "Los 12 boletines mensuales publican exactamente los mismos valores de canasta que el Banco de Indicadores, en los cuatro ámbitos.",
      "sourceUrl": "https://www.inegi.org.mx/desarrollosocial/lp/"
    },
    {
      "id": "cambio-institucional",
      "kind": "corte-de-serie",
      "title": "La serie cambió de institución responsable a media serie",
      "body": "CONEVAL calculó y publicó las Líneas de Pobreza de enero de 1992 a marzo de 2025. A partir de las reformas vigentes desde el 17 de julio de 2025, el INEGI asumió la medición de la pobreza y publica la serie completa con los mismos criterios metodológicos. No hay ruptura metodológica, sí un cambio de responsable.",
      "appliesTo": [
        "canasta-alimentaria-rural",
        "canasta-alimentaria-urbana",
        "canasta-ampliada-rural",
        "canasta-ampliada-urbana"
      ],
      "period": "2025-07",
      "sourceUrl": "https://www.inegi.org.mx/desarrollosocial/lp/"
    },
    {
      "id": "que-mide-la-canasta",
      "kind": "metodologia",
      "title": "Qué mide y qué no mide esta cifra",
      "body": "La canasta alimentaria es un umbral: el costo mínimo de los alimentos que una persona necesita al mes. No es lo que gasta un hogar promedio, no incluye no alimentos, y no considera calidad nutricional más allá del requerimiento energético. Para un banco de alimentos es útil como piso: por debajo de ese ingreso, comer bien es aritméticamente imposible.",
      "appliesTo": [
        "canasta-alimentaria"
      ],
      "sourceUrl": "https://www.inegi.org.mx/desarrollosocial/lp/"
    },
    {
      "id": "indice-no-es-nivel",
      "kind": "advertencia",
      "title": "El desglose territorial mide cambio, no nivel",
      "body": "El costo de la canasta en pesos se publica sólo para el país, en ámbito rural y urbano: no existe una canasta oficial por estado ni por ciudad. Lo que sí se publica por territorio es el índice de precios. Un índice dice cuánto subieron los precios desde una fecha base, no cuánto cuestan hoy. Que un estado tenga un índice más alto que otro significa que ahí los alimentos se encarecieron más desde julio de 2018, no que comer sea más caro ahí.",
      "appliesTo": [
        "inegi-inpc-territorio"
      ],
      "period": "2018-07",
      "sourceUrl": "https://www.inegi.org.mx/programas/inpc/2018/"
    }
  ],
  "ingestion": {
    "runAt": "2026-08-03T04:59:05.920Z",
    "results": [
      {
        "sourceId": "inegi-lp",
        "status": "ok",
        "message": "1656 puntos en 4 series (LPEI y LPI, rural y urbano) desde 1992-01",
        "pointsWritten": 1656,
        "latestPeriod": "2026-06"
      },
      {
        "sourceId": "coneval-lp-historico",
        "status": "ok",
        "message": "1596 valores idénticos a la serie del INEGI en el tramo común",
        "pointsWritten": 0,
        "latestPeriod": "2025-03"
      },
      {
        "sourceId": "inegi-lp-boletin",
        "status": "ok",
        "message": "12 boletines (2025-07 a 2026-06), 162 series por producto",
        "pointsWritten": 1944,
        "latestPeriod": "2026-06"
      },
      {
        "sourceId": "conasami-salario-minimo",
        "status": "ok",
        "message": "414 puntos mensuales derivados de 43 tramos de vigencia, desde 1992-01",
        "pointsWritten": 414,
        "latestPeriod": "2026-06"
      },
      {
        "sourceId": "inegi-inpc-territorio",
        "status": "ok",
        "message": "32 entidades y 55 ciudades, más el nacional",
        "pointsWritten": 8448,
        "latestPeriod": "2026-06"
      },
      {
        "sourceId": "inegi-denue-mayoristas",
        "status": "ok",
        "message": "23654 mayoristas de alimento en 1424 municipios",
        "pointsWritten": 23654
      },
      {
        "sourceId": "profeco-qqp",
        "status": "ok",
        "message": "60 presentaciones de 10 quincenas (5421779 filas leídas, 1122719 de canasta, 79245 duplicadas), última observación 2026-05-29 (66 días)",
        "pointsWritten": 9941,
        "latestPeriod": "2026-05"
      }
    ]
  }
}
